import React from "react";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { useBarnsWithHorses } from "components/Location/useBarnsWithHorses";
import { mapPropsAreEqual } from "components/MapComponents/mapPropsAreEqual";

import useStyles from "./styles";

interface Props {
  containerSize: {
    width: number;
    height: number;
  };
  horses: racehorse360.IHorse[];
  mapRootRef: React.RefObject<SVGGElement>;
  clipPathRef: React.RefObject<SVGRectElement>;
  svgContainerRef: React.RefObject<HTMLDivElement>;
  handleGroupClick?: (e: React.MouseEvent) => void;
  isPreview?: boolean;
}

const SantaAnitaMap = (props: Props) => {
  const {
    mapRootRef,
    containerSize,
    svgContainerRef,
    clipPathRef,
    handleGroupClick,
    horses,
    isPreview
  } = props;

  const stylesProps = { isPreview };
  const classes = useStyles(stylesProps);

  const barnsWithHorses = useBarnsWithHorses(horses);

  return (
    <div ref={svgContainerRef}>
      <svg
        width={containerSize.width}
        height={containerSize.height}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1848 1063"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              ref={clipPathRef}
              className={classes.cls1}
              width="1852"
              height="1060"
            />
          </clipPath>
        </defs>
        <g ref={mapRootRef}>
          <g>
            <g className={classes.cls2}>
              <path
                d="M303.913 402.303l10.97 9.194a761.828 761.828 0 0025.486-27.561l-18.345-3.512a473.871 473.871 0 01-18.111 21.88zM569.508 136.303l-76.462 27.049h51.256q11.942-13.178 25.206-27.049zM327.73 372.939l19.024 3.642a712.613 712.613 0 0021.018-25.725l-21.168-5.043a484.729 484.729 0 01-18.875 27.126zM266.592 439.933l15.182 3.632c7.75-7.042 17-15.78 27.188-26.04l-10.677-8.947a423.327 423.327 0 01-31.693 31.355z"
                className={classes.cls3}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M166.18 584.054l.17-.15c67.856-57.11 161.232-139.62 220.727-208.37 35.775-41.343 42.366-58.305 42.429-58.471l.291-.628c19.481-34.247 52.495-83.49 106.94-144.659h-65.022c-24.907 89.532-79.778 165.63-121.693 213.922l-.016.083-.048-.01c-45.886 52.854-86.6 84.753-87.006 85.07l-.212.154C196.314 516.372 82.322 621.402 42.377 658.75v66.624c52.455-74.067 123.024-140.588 123.803-141.32z"
                className={classes.cls3}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M508.185 132.57l-51.47-26.684 2.782-6.955-14.898-13.911-9.214 10.665 38.95 40.341-17.156 13.498H420.06a493.778 493.778 0 01-51.205 158.188h29.872c26.618-40.477 51.526-88.57 65.718-141.244l.575-2.136 114.697-40.576.518 1.465q18.466-18.88 39.466-38.929c33.086-31.525 63.137-57.526 84.435-75.28H682.6l-115.168 99.975zM274.136 450.399l-15.43-3.691c-7.825 6.514-12.507 9.761-12.507 9.761l-19.475 16.075-14.374-12.861-12.898 9.738 9.484 10.718-78.196 61.154-86.347-8.347V11.012h-2.016v636.216c44.357-41.312 151.57-139.41 215.497-183.11.833-.657 6.81-5.4 16.262-13.719zM351.38 338.291l22.013 5.245a667.426 667.426 0 0019.695-27.4h-28.763q-6.356 11.555-12.946 22.155z"
                className={classes.cls3}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1400.313 381.093a3.835 3.835 0 01-.352-.301 84.554 84.554 0 01-9.437-11.064h-345.945l10.536 373.235h238.793c-5.541-22.638 3.727-50.087 4.207-51.477.02-.057.042-.114.064-.17l96.737-235.557c26.11-58.078 5.607-74.507 5.397-74.666zM1385.567 339.395c-.16 4.34 1.662 13.531 8.36 24.015h86.673a123.938 123.938 0 0134.84 3.18c20.622 4.958 35.889 15.099 44.779 29.55l30.561-18.25c17.548-11.18 14.28-39.903 14.245-40.191a3.199 3.199 0 01-.024-.384v-62.71c-6.257-35.385-72.095-32.388-72.762-32.351a3.568 3.568 0 01-.164.004h-161.358c2.87 13.82 12.373 61.395 14.845 96.77a3.121 3.121 0 01.005.367zM1178.366 933.444l.3.86.464-.39z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1572.827 463.448h23.598c-1.544-15.567-4.522-24.657-5.61-27.57-28.182-14.045-31.708-25.416-32.1-28.78-16.702-41.643-77.137-37.43-77.75-37.38a3.26 3.26 0 01-.247.01h-82.238a78.99 78.99 0 005.794 6.442c2.718 2.164 23.705 21.455-3.554 82.085l-96.658 235.368c-.567 1.698-9.725 29.823-3.3 50.45a3.132 3.132 0 01.772 2.05c0 .052-.012.1-.015.152a34.592 34.592 0 001.531 3.45c17.53-12.441 47.137-15.563 108.538 4.42 65.819 21.423 111.892 27.578 149.385 19.959 38.73-7.87 69.951-30.577 101.23-73.626 2.78-3.825 5.571-7.369 8.365-10.69-35.588.227-104.17-23.419-107.328-24.516a3.158 3.158 0 01-2.024-3.77l22.888-89.1c8.859-32.42 12.338-58.868 13.105-79.604h-24.382zM1265.504 905.466c20.38-28.349 1.683-35.95 1.683-35.95l-20.092-8.712 1.807 1.086q-20.321 33.821-56.811 66.381l.327.408-.75.6-.293-.365c-.76.677-1.532 1.352-2.303 2.027l.203.253-.75.6-.179-.223q-.74.646-1.485 1.29a3.082 3.082 0 01-1.891 1.639c-.418.357-.852.712-1.273 1.069l.065.038-.814.652-.042-.026q-7.875 6.637-16.43 13.208l-.015.012c-.932.717-1.856 1.435-2.8 2.15a6.145 6.145 0 01-.666.624l-1.302 1.043-.083-.104c-.195.146-.397.292-.593.438l.147.087-.814.653-.182-.112q-1.364 1.017-2.748 2.032l.117.331-.763.611-.124-.373c-.341.25-.673.501-1.016.751a2.76 2.76 0 01-1.002 1.477 2.636 2.636 0 01-1.909.618q-.752.541-1.508 1.082l.716.32-.84.674-.773-.35c-.645.458-1.284.918-1.934 1.376l.556.696-.749.598-.596-.744c-.289.203-.584.406-.874.609l.942.559-.814.652-.991-.61c-.756.528-1.508 1.056-2.27 1.583l.447 1.278-.763.61-.449-1.356a759.266 759.266 0 01-75.77 45.435c-26.139 13.808-63.972 42.126-79.774 54.249h245.618c10.598-139.752 32.607-160.874 32.607-160.874zm-32.488 31.238l-16.166 129.602h-214.758l20.657-14.753 6.086 7.377 30.297-21.348-4.037-9.872s130.527-50.754 194.217-155.027l10.497 4.625z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1146.47 958.65l-.849.679.13.162c.66-.465 1.31-.932 1.966-1.397a1.762 1.762 0 00-1.247.556zM1096.126 363.41h290.388c-7.156-12.701-7.298-22.47-7.264-24.097-2.55-36.19-12.535-85.353-14.986-97.055h-279.682a272.58 272.58 0 001.673 5.85c1.192 2.788 10.17 26.783 9.87 115.303zM1055.293 749.28l2.13 75.438h121.399c.053 0 .108.001.161.004.753.042 75.44 3.272 100.286-43.638l.005-.007.082-.153c5.355-9.898 10.617-19.615 18.692-27.122a39.827 39.827 0 01-2.147-4.521zM1151.195 954.738a1.641 1.641 0 00-.637 1.319c.752-.542 1.517-1.082 2.262-1.624a1.582 1.582 0 00-1.625.305z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M791.684 358.716L776.747 813.706 1008.724 813.706 995.881 358.716 791.684 358.716z"
                className={classes.cls4}
              />
              <path
                d="M1173.959 938.179l.258-.21-.591-.472zM1155.768 951.53l.202.576.334-.246zM1598.684 439.577a136.526 136.526 0 014.239 23.871h72.28c-34.916-8.053-59.382-16.267-76.519-23.87zM96.411 1022.28l47.389 23.567 3.697-26.593h305.622l.752-36.114H115.26c-19.039 0-32.49-5.231-39.978-15.55-10.805-14.888-5.019-34.725-4.376-36.782l56.184-244.434a3.159 3.159 0 116.157 1.415L77.034 932.35q-.032.136-.076.27c-.057.18-5.826 18.539 3.458 31.29 6.239 8.57 17.962 12.914 34.843 12.914h338.744l.364-17.504h82.277l-.774 17.504h34.813a3.124 3.124 0 01.916.15c2.019-38.36 4.85-88.074 8.633-145.937H329.636l-13.568 89.576a3.16 3.16 0 01-6.247-.946l61.754-407.713a3.159 3.159 0 013.123-2.686h86.582l9.104-99.716c.06-1.443.85-11.241 11.353-21.433 22.388-21.726 67.778-25.43 101.92-24.707h68.864c2.2-3.288 12.898-28.024 22.065-203.765-.03-1.88.007-19.895 11.238-39.69 19.322-34.058 56.275-45.993 83.898-50.007a162.866 162.866 0 0130.006-2.217c22.584.378 40.299 5.374 52.652 14.847 11.58 8.881 18.064 21.531 19.273 37.6.006.08.009.158.009.237V363.41h168.688a3.125 3.125 0 01.885-.168 3.166 3.166 0 011.046.168h47.526c.157-46.711-2.332-74.73-4.475-90.083-2.388-17.117-4.886-22.738-4.912-22.793a3.658 3.658 0 01-.161-.425c-12.866-42.925-7.553-60.36-6.656-62.793 7.092-27.856 7.103-66.508 7.102-66.896a3.136 3.136 0 01.212-1.12c-37.077-10.603-75.604-22.752-115.312-36.393-79.915-27.452-147.587-55.12-186.857-71.896h-61.405c-21.264 17.486-54.646 45.943-91.907 81.45-58.26 55.52-138.168 140.093-188.16 227.862-2.454 6.176-33.498 74.752-265.412 269.948-2.897 2.733-77.867 73.81-129.486 149.889v244.587l1.514 61.294 40.792 13.798zM1765.809 494.918c-14.95-6.992-29.1-12.619-41.258-17v14.879h-40.223v27.28h-71.278v-27.28h-9.396c-.802 21.169-4.395 48.111-13.443 81.223l-22.147 86.216c14.315 4.79 80.508 26.24 108.403 22.903 28.336-30.264 56.442-36.602 76.238-36.072 24.383.681 41.175 11.447 42.812 12.535 15.523 8.904 40.026 19.341 68.67 18.549a91.337 91.337 0 0026.984-4.478v-77.58a3.143 3.143 0 01-.448-.548c-30.63-49.206-84.834-81.881-124.914-100.627zM1891.17 584.768V359.002l-68.235 160.792c25.136 16.947 49.911 38.462 68.235 64.974z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1386.186 171.155l-.216.004c-59.933-.071-131.102-9.396-211.531-27.715q-42.062-9.58-87.417-22.397c-.021 5.32-.425 40.998-7.344 68.013a3.203 3.203 0 01-.154.454c-.044.11-4.862 12.9 3.406 46.426h283.153c.018-.004.033-.013.05-.017a3.138 3.138 0 011.374.017h164.487c3.977-.196 72.428-2.947 79.281 37.872a3.178 3.178 0 01.043.523v62.8a70.482 70.482 0 01-.584 17.653c-2.103 13.037-7.856 22.884-16.638 28.479l-30.848 18.42q.816 1.737 1.523 3.544a2.136 2.136 0 01.222 1.078c.25 1.49 6.49 28.174 121.418 53.177.159.038 5.485 1.307 14.4 3.962h23.74v7.766c12.765 4.534 27.834 10.457 43.81 17.923a410.942 410.942 0 0149.211 27.119l73.598-173.427v-74.606c-144.536-54.76-274.174-78.239-357.503-88.291-90.263-10.89-146.917-8.798-147.48-8.777z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1386.185 150.444l-.155.007-.156-.003c-137.974-2.684-279.693-42.143-374.284-74.772a1702.537 1702.537 0 01-160.992-64.664h-44.732c40.04 16.644 97.482 39.38 163.264 61.974 116.124 39.885 282.675 87.461 416.75 87.643 2.93-.103 59.9-1.905 149.048 8.849 83.191 10.036 212.219 33.364 356.242 87.494v-9.46c-144.42-54.716-273.959-78.196-357.227-88.258-90.334-10.915-147.193-8.832-147.758-8.81zM1166.732 942.756l.324.926.518-.408z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1141.444 962.49l-.218-.659.83-.662.693.412c.738-.514 1.48-1.027 2.213-1.54l-.585-.73 1.512-1.21c1.09-.87 1.963-1.242 2.742-.662q.527-.376 1.05-.753a2.639 2.639 0 011.047-2.597 2.433 2.433 0 012.9-.253c.55-.4 1.086-.803 1.631-1.204l-.531-1.605.829-.665 1.538.914c.626-.465 1.266-.929 1.887-1.395l-1.102-1.377 1.3-1.041c1.22-.976 2.466-1.369 3.674-.53.328-.251.661-.502.988-.753l-1.194-1.492.748-.599 1.209 1.51c.587-.453 1.162-.907 1.744-1.361l-.658-1.987.83-.662 1.822 1.082c1.079-.85 2.161-1.7 3.224-2.55l-1.639-1.26.823-.657 1.59 1.288c.33-.266.656-.533.985-.8l-.913-1.819.874-.7 1.59 1.262c.332-.272.673-.543 1.004-.815l-.91-1.794.788-.63.856 1.828c.459-.378.9-.757 1.355-1.136l-.644-1.946.828-.664 1.714 1.018c.53-.445 1.069-.89 1.594-1.336a1.658 1.658 0 01-.166-.169c-.72-.9-.124-2.068.685-2.714a2.142 2.142 0 012.903-.092l-.723.578a1.375 1.375 0 00-1.714.164c-.348.278-.815.922-.416 1.421a.763.763 0 00.2.165c1.18-1.007 2.331-2.017 3.488-3.026l-1.006-1.258.748-.598.983 1.227q1.159-1.015 2.3-2.032l-.889-1.111.749-.6.855 1.068q35.663-31.88 55.684-65.024l-6.54-2.836c13.858-19.629 38.86-16.046 38.86-16.046l96.074 10.404c35.48 2.445 19.286 41.575 19.286 41.575l-14.821 49.862c-14.674 68.612 11.413 36.549 11.413 36.549 37.454-29.492 77.85-50.13 118.896-64.158 25.46-58.79 84.881-132.25 222.76-175.059l-52.487-50.116q-5.746 6.47-11.27 14.058c-32.28 44.423-64.688 67.894-105.083 76.103-38.622 7.848-85.684 1.636-152.6-20.142-95.11-30.954-108.831-5.591-124.72 23.778l-.057.106-.002.005c-.013.026-.028.05-.042.076-4.76 8.8-9.697 17.888-16.956 25.97-6.83 7.606-15.605 18.536-25.765 31.194-36.096 44.967-90.63 112.903-140.348 133.313l2.746 5.354s-116.037 51.092-143.642 86.358H580.044l3.28-43.151h-7.72c-1.19 24.985-1.743 39.03-1.764 39.583a3.159 3.159 0 01-3.155 3.037l-.124-.002a3.16 3.16 0 01-3.034-3.28c.021-.552.57-14.501 1.753-39.338h-35.458l-1.908 43.151H65.21l-21.02-8.212.204 8.246h935.991c11.879-9.22 55.455-42.523 84.702-57.974a752.786 752.786 0 0076.358-45.878z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M588.175 959.319h505.731l4.961 9.672a3.132 3.132 0 01.364-.193c48.236-19.733 102.213-86.976 137.931-131.472 7.53-9.38 14.298-17.81 20.12-24.696-10.09 6.22-22.135 10.991-35.926 14.152a176.975 176.975 0 01-38.275 4.336 96.15 96.15 0 01-4.339-.082H586.564c-4.363 66.708-7.463 122.599-9.51 162.77h8.5zM570.728 993.806c.176-3.464.36-7.03.552-10.726a3.168 3.168 0 01-.597.06h-35.092l-.471 10.666zM1159.643 948.108l-.52.415.622.776c.77-.58 1.526-1.162 2.29-1.743a2.104 2.104 0 00-2.392.552zM865.344 120.535c-1.09-14.136-6.74-25.217-16.797-32.933-26.992-20.715-77.214-11.528-77.72-11.432l-.134.022c-38.157 5.53-64.863 21.302-79.374 46.88-10.758 18.963-10.42 36.366-10.415 36.54.002.082 0 .166-.003.249-5.784 110.928-13.483 183.304-21.496 203.55h205.94zM601.785 552.517c.03-.14 3.082-14.744-6.02-25.37-7.589-8.862-21.414-12.755-41.09-11.568a3.353 3.353 0 01-.19.006h-177.07l-46.823 309.133h250.055c5.183-78.662 12.097-171.865 21.076-271.796a3.185 3.185 0 01.062-.405z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M583.59 369.728c-55.114-1.158-81.308 10-93.587 19.57-12.88 10.036-13.295 20.082-13.306 20.505a4.4 4.4 0 01-.013.231l-9.06 99.233h86.766c21.744-1.297 37.3 3.358 46.224 13.829 10.585 12.42 7.819 28.416 7.384 30.575-8.95 99.631-15.846 192.565-21.02 271.047h225.825l14.936-454.99z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1792.274 665.027a3.11 3.11 0 01-.203-.128 81.286 81.286 0 00-39.847-11.524c-24.985-.59-48.238 10.199-69.35 32.12l106.132 101.337c27.33 25.949 83.343 75.844 102.164 81.348V680.348c-11.571 3.656-50.59 12.43-98.896-15.322z"
                className={classes.cls5}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1784.65 791.408l-53.579-51.159c-137.879 42.81-197.299 116.27-222.76 175.06 174.386-59.603 360.523.157 382.86 7.77v-48.467a3.14 3.14 0 01-.742-.09c-24.184-5.836-102.458-79.962-105.779-83.114z"
                className={classes.cls5}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1682.505 0L1848.793 48.757 1848.793 0 1682.505 0z"
                className={classes.cls4}
              />
              <path
                d="M1792.311 84.201L1721.129 92.908 1715.692 102.653 1793.291 86.434 1792.311 84.201z"
                className={classes.cls4}
              />
              <path
                d="M1816.103 195.718s-4.76-1.316-13.037-3.55l-6.254 12.102a1536.097 1536.097 0 0194.358 32v-32.084l-68.717-20.449zM1751.473 114.68l5.561-9.968-46.578 5.697a98.021 98.021 0 0041.017 4.27z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1812.975 62.666L1812.975 63.646 1848.793 71.957 1848.793 57.535 1820.782 49.322 1812.975 62.666z"
                className={classes.cls4}
              />
              <path
                d="M1506.199 74.408a450.72 450.72 0 00122.363-33.016c-24.273-29.663-61.985-30.125-62.38-30.125v-.255h-50.538c-10.97 19.526-38.975 23.744-38.975 23.744-67.155 6.649-140.342-14-170.18-23.744h-124.853c25.354 13.333 81.61 39.785 154.247 55.09 58.318 12.286 115.621 15.08 170.316 8.306z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1633.566 39.21a465.448 465.448 0 0053.84-28.198h-94.466a86.159 86.159 0 0140.626 28.198z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1385.932 139.917c3.482-.12 60.325-1.847 148.996 8.85a1550.587 1550.587 0 01256.756 53.958l6.18-11.958c-49.5-13.293-186.32-49.048-241.106-53.248v-13.66l116.85-33.434a106.377 106.377 0 0026.216 15.98l132.654-16.226-.287-.654s13.91-8.364 14.606-16.852l3.29.763v-1.185l7.865-13.444-157.288-46.118c-59.477 37.997-124.606 61.58-193.607 70.1a488.932 488.932 0 01-59.94 3.644 548.112 548.112 0 01-113.258-12.15 628.257 628.257 0 01-134.321-45.014l-.007.957c-90.137-.614-179.148 22.754-180.038 22.99l-2.782.739-7.392-42.943h-133.35c30.343 13.528 79.326 34.113 139.212 54.764 93.8 32.347 234.251 71.46 370.751 74.14z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1190.567 24.978c-13.718-6.714-22.804-11.876-26.372-13.966H1014.66l6.267 36.406c15.28-3.807 90.89-21.65 169.64-22.44z"
                className={classes.cls4}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1795.516 659.603c-1.637-1.088-18.429-11.854-42.812-12.535-19.795-.53-47.901 5.808-76.238 36.071-27.894 3.337-94.088-18.113-108.402-22.903l22.146-86.216c9.048-33.112 12.641-60.054 13.444-81.223h-6.445c-.767 20.736-4.246 47.185-13.105 79.604l-22.888 89.1a3.158 3.158 0 002.024 3.77c3.158 1.097 71.74 24.743 107.328 24.516a190.154 190.154 0 00-8.364 10.69c-31.28 43.049-62.5 65.756-101.231 73.626-37.493 7.62-83.566 1.464-149.385-19.958-61.401-19.983-91.008-16.862-108.538-4.42a34.592 34.592 0 01-1.53-3.451c.002-.051.014-.1.014-.152a3.132 3.132 0 00-.773-2.05c-6.424-20.627 2.734-48.751 3.3-50.45l96.659-235.367c27.259-60.63 6.272-79.921 3.554-82.085a78.99 78.99 0 01-5.794-6.442h82.238c.082 0 .165-.004.247-.01.614-.05 61.048-4.263 77.75 37.38.392 3.363 3.918 14.735 32.1 28.78 1.088 2.913 4.067 12.003 5.61 27.57h6.498a136.526 136.526 0 00-4.238-23.87c17.136 7.603 41.602 15.817 76.518 23.87h25.61c-8.916-2.655-14.243-3.924-14.4-3.962-114.928-25.003-121.168-51.688-121.419-53.177a2.136 2.136 0 00-.222-1.078q-.706-1.807-1.523-3.543l30.848-18.421c8.782-5.595 14.535-15.442 16.638-28.479a70.482 70.482 0 00.584-17.653v-62.8a3.178 3.178 0 00-.043-.523c-6.853-40.819-75.304-38.068-79.28-37.872h-164.489a3.138 3.138 0 00-1.373-.016c-.018.003-.033.012-.05.016H1082.93c-8.268-33.527-3.45-46.316-3.406-46.426a3.203 3.203 0 00.154-.454c6.919-27.015 7.323-62.692 7.344-68.013-2.026-.573-4.07-1.165-6.105-1.747a3.136 3.136 0 00-.212 1.121c.001.388-.01 39.04-7.102 66.896-.897 2.433-6.21 19.868 6.656 62.793a3.658 3.658 0 00.161.425c.026.055 2.524 5.676 4.912 22.793 2.143 15.353 4.631 43.372 4.475 90.083h-47.526a3.166 3.166 0 00-1.046-.168 3.125 3.125 0 00-.885.168H871.662V120.415c0-.079-.003-.158-.009-.237-1.209-16.068-7.692-28.718-19.273-37.6-12.354-9.473-30.069-14.468-52.653-14.847a162.866 162.866 0 00-30.005 2.218c-27.623 4.013-64.576 15.949-83.899 50.006-11.23 19.796-11.266 37.81-11.238 39.69-9.166 175.742-19.864 200.478-22.065 203.766h-68.862c-34.143-.722-79.533 2.981-101.921 24.707-10.503 10.192-11.293 19.99-11.353 21.433l-9.104 99.716h-86.582a3.159 3.159 0 00-3.123 2.686l-61.754 407.713a3.16 3.16 0 006.247.946l13.568-89.576h250.596a11578.12 11578.12 0 00-8.633 145.938 3.124 3.124 0 00-.916-.151H535.87l-.28 6.317h35.093a3.168 3.168 0 00.596-.06c-.192 3.696-.375 7.262-.552 10.726h6.326c2.047-40.171 5.147-96.062 9.51-162.77h592.179c.406.02 1.928.082 4.34.082a176.975 176.975 0 0038.274-4.336c13.791-3.161 25.836-7.932 35.926-14.152-5.822 6.885-12.59 15.317-20.12 24.696-35.718 44.496-89.695 111.739-137.931 131.472a3.132 3.132 0 00-.364.193l2.874 5.603c49.717-20.41 104.252-88.346 140.348-133.313 10.16-12.658 18.935-23.588 25.765-31.193 7.26-8.083 12.196-17.171 16.956-25.97.014-.026.029-.051.042-.077l.002-.005.058-.106c15.888-29.37 29.61-54.732 124.72-23.778 66.915 21.778 113.978 27.99 152.6 20.142 40.394-8.209 72.803-31.68 105.082-76.103q5.521-7.598 11.27-14.058l52.487 50.116 53.579 51.159c3.32 3.152 81.595 77.278 105.779 83.114a3.14 3.14 0 00.741.09v-6.432c-18.82-5.503-74.834-55.399-102.164-81.348l-106.131-101.338c21.111-21.92 44.364-32.708 69.35-32.119a81.286 81.286 0 0139.846 11.524c.067.046.134.088.204.128 48.305 27.751 87.324 18.978 98.896 15.322v-6.675a91.337 91.337 0 01-26.983 4.477c-28.646.793-53.149-9.644-68.672-18.548zm-263.441-417.345c.054 0 .109-.002.163-.004.668-.037 66.506-3.034 72.763 32.35v62.71a3.199 3.199 0 00.024.385c.035.288 3.303 29.011-14.245 40.191l-30.561 18.249c-8.89-14.45-24.157-24.591-44.779-29.549a123.938 123.938 0 00-34.84-3.18h-86.673c-6.698-10.484-8.52-19.675-8.36-24.015a3.121 3.121 0 00-.005-.367c-2.473-35.376-11.975-82.95-14.845-96.77zm-445.82 5.85a272.745 272.745 0 01-1.673-5.85h279.681c2.452 11.701 12.437 60.865 14.986 97.055-.033 1.626.108 11.395 7.265 24.097h-290.389c.3-88.52-8.678-112.514-9.87-115.302zM680.9 159.86c.004-.083.005-.167.003-.25-.005-.173-.343-17.576 10.415-36.539 14.512-25.578 41.217-41.35 79.375-46.88.044-.006.09-.014.134-.022.505-.095 50.727-9.283 77.72 11.432 10.056 7.716 15.707 18.797 16.796 32.933v242.876H659.405c8.013-20.246 15.712-92.622 21.496-203.55zM580.647 824.718H330.593l46.822-309.133h177.07c.064 0 .127-.002.19-.005 19.676-1.188 33.502 2.705 41.09 11.567 9.102 10.626 6.05 25.23 6.02 25.37a3.185 3.185 0 00-.062.405c-8.98 99.93-15.893 193.134-21.076 271.796zm6.331 0c5.175-78.482 12.07-171.416 21.02-271.047.435-2.159 3.202-18.155-7.383-30.575-8.924-10.471-24.48-15.126-46.224-13.829h-86.766l9.06-99.233a4.4 4.4 0 00.013-.23c.01-.424.425-10.47 13.305-20.506 12.28-9.57 38.473-20.728 93.588-19.57H827.74l-14.936 454.99zm232.147 0l14.936-454.99h204.197l12.844 454.99zm460.231-43.794l-.082.153-.005.007c-24.847 46.91-99.533 43.68-100.286 43.638a2.808 2.808 0 00-.161-.004h-121.4l-2.129-75.437h240.608a39.827 39.827 0 002.147 4.521c-8.074 7.507-13.337 17.224-18.692 27.122zm18.76-89.438c-.48 1.39-9.75 28.839-4.208 51.477h-238.793l-10.536-373.235h345.945a84.554 84.554 0 009.437 11.064 3.835 3.835 0 00.352.3c.21.16 20.714 16.59-5.396 74.667l-96.738 235.557a3.24 3.24 0 00-.064.17zM567.527 1062.494a3.16 3.16 0 003.034 3.279l.124.002a3.159 3.159 0 003.155-3.037c.021-.554.574-14.597 1.765-39.583h-6.325c-1.183 24.837-1.732 38.787-1.753 39.339z"
                className={classes.cls6}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1768.362 489.138c-15.976-7.467-31.046-13.39-43.81-17.924v6.705c12.157 4.38 26.307 10.007 41.257 17 40.08 18.745 94.285 51.42 124.913 100.627a3.143 3.143 0 00.448.547v-11.325c-18.324-26.512-43.099-48.027-68.235-64.974l68.235-160.792v-16.173l-73.597 173.427a410.942 410.942 0 00-49.21-27.118zM80.416 963.908c-9.284-12.75-3.515-31.108-3.457-31.288q.043-.134.075-.271l56.212-244.56a3.159 3.159 0 10-6.157-1.414L70.906 930.808c-.644 2.057-6.43 21.894 4.375 36.782 7.489 10.319 20.94 15.55 39.978 15.55H453.87l.132-6.317H115.259c-16.881 0-28.604-4.345-34.843-12.915z"
                className={classes.cls6}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M588.175 959.319l-2.621 34.487h61.676v29.349h-63.907l-3.28 43.151h380.802c27.606-35.265 143.643-86.358 143.643-86.358l-2.746-5.354-2.875-5.603-4.96-9.672zM1055.095 1027.71l4.037 9.872-30.298 21.348-6.085-7.376-20.657 14.752h214.758l16.166-129.602 26.793-59.396-10.497-4.625c-63.69 104.273-194.217 155.027-194.217 155.027z"
                className={classes.cls7}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M489.537 1055.294L491.445 1012.143 453.129 1012.143 453.129 982.794 492.742 982.794 493.214 972.128 493.493 965.811 494.267 948.307 411.99 948.307 411.626 965.811 411.494 972.128 410.742 1008.242 216.944 1008.242 105.12 1008.242 101.423 1034.835 54.034 1011.268 42.307 1048.827 1.514 1035.03 0.938 1034.835 0.938 1046.741 1.812 1047.082 22.832 1055.294 489.537 1055.294z"
                className={classes.cls7}
              />
              <path
                d="M1567.34 1074.884h290.003s-91.6-87.137-290.003 0z"
                className={classes.cls8}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1710.456 110.409l-.716.088-23.27 30.301 44.148 11.256 20.855-37.375a98.021 98.021 0 01-41.017-4.27z"
                className={classes.cls9}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1556.758 123.859v13.66c54.786 4.2 191.606 39.954 241.106 53.247l7.368-14.257-219.998-56.088 114.59-14.016a106.377 106.377 0 01-26.216-15.98z"
                className={classes.cls9}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1785.892 132.389L1770.581 162.015 1829.004 176.575 1848.623 132.617 1848.793 132.693 1848.793 77.372 1812.041 81.79 1785.892 132.389z"
                className={classes.cls9}
              />
              <path
                d="M1812.975 76.369L1814.969 76.125 1814.963 76.137 1848.793 72.07 1848.793 71.957 1812.975 63.646 1812.975 76.369z"
                className={classes.cls9}
              />
              <path
                d="M1810.469 177.844l-7.403 14.323c8.278 2.235 13.037 3.55 13.037 3.55l6.35-11.98 68.717 20.449v-6.242l-80.696-20.11z"
                className={classes.cls9}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1848.793 181.506L1848.793 145.155 1834.192 177.868 1848.793 181.506z"
                className={classes.cls9}
              />
              <path
                d="M1571.318 111.233L1638.543 128.371 1660.037 100.381 1571.318 111.233z"
                className={classes.cls9}
              />
              <path
                d="M1793.291 86.434L1715.692 102.653 1693.52 142.387 1765.336 160.696 1803.428 86.989 1805.716 82.561 1792.311 84.201 1793.291 86.434z"
                className={classes.cls9}
              />
              <path
                d="M1832.19 89.525l.288.654 17.61-2.154V73.436l-3.29-.763c-.696 8.489-14.607 16.852-14.607 16.852z"
                className={classes.cls9}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M171.863 590.272C403.778 395.076 434.821 326.5 437.276 320.324c49.992-87.77 129.9-172.343 188.16-227.861 37.26-35.508 70.642-63.965 91.907-81.451h-13.207c-21.298 17.754-51.349 43.755-84.435 75.28q-21.035 20.042-39.466 38.93l-.518-1.466-114.697 40.576-.576 2.136c-14.191 52.675-39.1 100.767-65.717 141.244h-29.872a493.778 493.778 0 0051.206-158.187h37.118l17.156-13.499-38.95-40.34L444.6 85.02l14.898 13.91-2.782 6.956 51.47 26.684 59.249-21.583L682.6 11.012H44.393v521.934l86.347 8.347 78.196-61.154-9.484-10.718 12.898-9.738 14.374 12.861L246.2 456.47s4.682-3.248 12.508-9.762l15.429 3.691c-9.451 8.319-15.429 13.062-16.262 13.718-63.927 43.7-171.14 141.8-215.496 183.111v11.522c39.944-37.348 153.936-142.378 220.362-187.755l.212-.155c.406-.316 41.12-32.215 87.006-85.069l.048.01.016-.083c41.915-48.293 96.786-124.39 121.693-213.922h65.021c-54.444 61.168-87.458 110.412-106.94 144.658l-.291.628c-.062.167-6.654 17.129-42.429 58.47-59.495 68.753-152.871 151.262-220.727 208.37l-.17.152c-.78.731-71.348 67.253-123.803 141.319v14.787c51.62-76.079 126.59-147.155 129.487-149.888zm109.91-146.707l-15.181-3.632a423.327 423.327 0 0031.693-31.355l10.677 8.948a737.175 737.175 0 01-27.188 26.039zm33.11-32.069l-10.97-9.193a473.804 473.804 0 0018.112-21.88l18.345 3.512a761.698 761.698 0 01-25.487 27.562zm31.87-34.915l-19.024-3.642a484.782 484.782 0 0018.875-27.126l21.168 5.043a712.402 712.402 0 01-21.018 25.725zm26.64-33.045l-22.014-5.245q6.573-10.586 12.946-22.156h28.763a666.886 666.886 0 01-19.695 27.4zm119.653-180.184l76.462-27.049q-13.279 13.87-25.206 27.049zM1687.407 11.012a465.448 465.448 0 01-53.841 28.198 86.159 86.159 0 00-40.626-28.198h-26.758v.255c.395 0 38.107.462 62.38 30.125A450.72 450.72 0 011506.2 74.408c-54.694 6.774-111.998 3.98-170.315-8.306-72.638-15.305-128.894-41.757-154.248-55.09h-17.44c3.567 2.09 12.653 7.251 26.372 13.966-78.75.789-154.36 18.632-169.64 22.44l-6.267-36.406h-5.342l7.392 42.943 2.782-.74c.89-.235 89.9-23.603 180.038-22.99l.007-.956a628.257 628.257 0 00134.32 45.014 548.112 548.112 0 00113.26 12.15 488.932 488.932 0 0059.938-3.644c69.002-8.52 134.13-32.103 193.608-70.1l157.289 46.118-7.865 13.444v15.774l-17.61 2.154-132.654 16.226-114.59 14.017 219.999 56.087-7.369 14.258-6.18 11.958q2.56.767 5.128 1.545l6.255-12.103 7.402-14.323.005-.01 80.697 20.11v-5.425l-14.601-3.639 14.6-32.713v-12.462l-.17-.076-19.619 43.958-58.422-14.56 15.31-29.626 26.15-50.599 36.751-4.418v-5.302l-33.83 4.067.006-.012-1.994.244V73.678l7.807-13.344 28.011 8.213v-8.778l-166.287-48.757zm-73.712 111.233l88.72-10.852-21.495 27.99zm72.776 18.553l23.268-30.301.717-.088 46.578-5.697-5.561 9.967-20.855 37.375zm159.334-42.796l-38.092 73.706-71.815-18.308 22.17-39.735 5.438-9.745 71.182-8.706 13.406-1.64z"
                className={classes.cls7}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1411.311 1074.884h148.635c202.933-76.51 296.624 0 296.624 0h34.6v-78.69c-303.57-126.658-479.859 78.69-479.859 78.69z"
                className={classes.cls10}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1476.668 34.756s28.007-4.218 38.976-23.744h-209.155c29.839 9.744 103.025 30.393 170.18 23.744zM1143.567 966.062l.021.061c.763-.526 1.514-1.054 2.27-1.582l-.221-.136zM1155.97 952.106l.818 2.34 1.617-1.293-2.1-1.293-.335.246zM1148.159 960.813l-.823.658 1.048 1.31c.65-.458 1.29-.917 1.935-1.376l-1.857-.844c-.093.084-.198.168-.303.252zM1150.466 958.329a3.675 3.675 0 01-.785-1.643l-1.05.752a2.167 2.167 0 01.408.393 1.516 1.516 0 01.084 1.993l2.092.937q.757-.541 1.509-1.082a3.313 3.313 0 01-2.257-1.35zM1147.717 958.093c-.656.466-1.306.932-1.966 1.398l1.096 1.368.862-.69c.703-.562 1.098-1.05.573-1.707a.91.91 0 00-.565-.369zM1142.749 961.58l3.973 2.36c.29-.204.585-.406.874-.61l-2.634-3.29c-.732.514-1.475 1.027-2.213 1.54z"
                className={classes.cls11}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1100.908 954.239L1102.525 952.946 1099.89 951.324 1100.908 954.239z"
                className={classes.cls11}
              />
              <path
                d="M1173.326 938.692c-.33.266-.654.533-.985.8l2.334 1.889zM1175.88 936.619c-.33.272-.67.543-1.004.815l2.375 1.886zM1169.368 944.377l-1.794-1.103-.519.408.696 1.99zM1157.095 951.275l3.923 2.329c.195-.146.397-.292.592-.438l-2.629-3.285c-.62.465-1.26.929-1.886 1.394zM1157.068 955.256l.353 1.008q1.38-1.015 2.747-2.032l-1.029-.633zM1182.23 931.312a1.06 1.06 0 001.072-.06l.66-.335c.888-.45 1.95-.836 2.723.13a1.685 1.685 0 01.176 1.814q.747-.644 1.486-1.29l-2.628-3.285c-1.157 1.009-2.308 2.019-3.488 3.026zM1189.454 926.512l-.71-.887q-1.143 1.016-2.3 2.032l.617.77zM1162.854 946.932a4.005 4.005 0 01.86.805 2.637 2.637 0 01-.052 3.866c.943-.716 1.867-1.434 2.8-2.15l-2.62-3.273c-.327.25-.66.5-.988.752z"
                className={classes.cls11}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1179.666 937.17l.469 1.34-.763.61-1.402-4.233c-.455.378-.897.758-1.355 1.136l1.808 3.857-.901.721-3.305-2.632-.258.21 1.854 3.79-.901.722-3.345-2.571c-1.063.851-2.145 1.7-3.224 2.55l3.785 2.248-.814.652-1.211-.745-2.071 1.656.469 1.341-.763.61-1.389-4.194c-.582.453-1.157.907-1.744 1.36l2.606 3.257-.734.586q8.54-6.572 16.43-13.208l-1.17-.72zM1153.628 953.836a2.993 2.993 0 01.4.294l-.722.58a1.946 1.946 0 00-.486-.277c-.745.542-1.51 1.082-2.262 1.624a2.715 2.715 0 00.677 1.657c.942 1.176 2.096 1.366 2.918.707a1.6 1.6 0 00.504-2.064l.722-.578a2.536 2.536 0 01.256 1.805c.342-.25.674-.5 1.015-.75l-1.391-4.203c-.545.402-1.082.804-1.63 1.205zM1182.755 933.91l.736-.59a1.477 1.477 0 002.04-.012c.623-.5.819-1.13.446-1.598-.395-.493-1.033-.306-1.622-.007l-.681.351a1.862 1.862 0 01-2.212-.096c-.526.446-1.064.891-1.594 1.337l3.83 2.273c.421-.356.854-.712 1.273-1.068a2.15 2.15 0 01-2.216-.59z"
                className={classes.cls11}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1178.666 934.303l.718 2.057 1.617-1.293-1.872-1.153-.463.39zM1187.565 929.058l1.507 1.883c.771-.676 1.543-1.35 2.304-2.027l-1.417-1.771zM1162.034 947.556c-.763.581-1.518 1.163-2.29 1.743l2.204 2.753.519-.415c.954-.763 1.73-1.707.473-3.278a3.015 3.015 0 00-.906-.803zM1142.824 966.656l-1.38-4.167a752.786 752.786 0 01-76.359 45.877c-29.247 15.451-72.822 48.754-84.701 57.974h6.895c15.802-12.123 53.635-40.44 79.774-54.25a759.266 759.266 0 0075.77-45.434zM1189.459 924.983l2.632 3.288q36.406-32.506 56.81-66.381l-1.806-1.086-1.952-.846q-19.941 33.092-55.684 65.025z"
                className={classes.cls11}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1508.311 915.308c-41.046 14.03-81.441 34.666-118.896 64.158 0 0-26.086 32.064-11.413-36.549l14.822-49.862s16.193-39.13-19.287-41.575l-96.073-10.404s-25.002-3.583-38.86 16.046l6.54 2.836 1.951.846 20.092 8.713s18.697 7.6-1.682 35.949c0 0-22.01 21.122-32.608 160.874h189.127s172.352-182.27 469.147-69.847v-73.415c-22.337-7.612-208.474-67.372-382.86-7.77z"
                className={classes.cls8}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1190.827 140.355L1192.856 140.772 1192.419 137.708 1190.827 140.355z"
                className={classes.cls12}
              />
              <path
                d="M1156.841 133.362L1158.87 133.779 1158.435 130.716 1156.841 133.362z"
                className={classes.cls12}
              />
              <path
                d="M1195.607 140.4l-1.378-.285-.36 1.757 1.377.283c.651.134 1.11-.046 1.244-.698.117-.57-.256-.928-.883-1.058zM1210.606 143.486l-.651-.135-.911 4.428.65.135c1.197.246 2.42.24 2.825-1.732.402-1.954-.717-2.45-1.913-2.696z"
                className={classes.cls12}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1385.88 160.63c-134.075-.183-300.626-47.76-416.75-87.645-65.782-22.593-123.224-45.33-163.264-61.973h-27.118c39.27 16.777 106.942 44.444 186.857 71.896 39.708 13.64 78.235 25.79 115.313 36.392 2.034.582 4.078 1.174 6.104 1.747q45.274 12.792 87.417 22.397c80.429 18.32 151.597 27.644 211.531 27.715l.216-.004c.564-.021 57.218-2.112 147.482 8.777 83.328 10.052 212.966 33.531 357.502 88.291v-11.25c-144.023-54.13-273.05-77.46-356.242-87.496-89.147-10.753-146.118-8.95-149.047-8.848zM817.435 23.446l.496-1.489-5.958-1.99.332-.992 5.958 1.99.497-1.489 1.317 2.646zm233.898 84.358l.497-1.488-5.958-1.99.331-.992 5.958 1.99.497-1.489 1.317 2.646zm136.036 32.558l.678.294c.915.395 1.89.965 1.64 2.177-.243 1.187-1.517 1.57-2.671 1.332a2.293 2.293 0 01-2.042-2.527l.923.19a1.476 1.476 0 001.312 1.561c.783.162 1.395-.092 1.515-.678.127-.618-.424-.989-1.031-1.252l-.704-.3a1.799 1.799 0 01-1.317-1.998c.232-1.129 1.513-1.416 2.527-1.207a2.143 2.143 0 011.925 2.175l-.907-.187a1.375 1.375 0 00-1.221-1.214c-.437-.09-1.229-.038-1.357.588-.103.496.232.831.73 1.046zm7.227 5.252l-2.376-.49 1.231-5.978 2.201.453c1.098.225 2.06.725 1.81 1.936a1.528 1.528 0 01-.926 1.16 1.438 1.438 0 01.608 1.603c-.262 1.27-1.328 1.566-2.549 1.316zm6.978 1.435l-.2-1.408-2.597-.534-.733 1.216-.956-.197 3.449-5.522 1.04.214 1.02 6.442zm5.708 1.174l-4.023-.827 1.23-5.979.94.193-1.066 5.179 3.084.634zm6.21-1.841c-.474 2.308-2.017 2.704-3.914 2.314l-1.632-.336 1.23-5.978 1.633.336c1.897.39 3.157 1.363 2.683 3.664zm4.518 4.05l-.102-4.98-2.043 4.538-1.13-.232-.237-6.281 1.032.212.061 5.05 2.025-4.62 1.096.225.111 5.059 2-4.624.99.203-2.673 5.682zm4.275.878l-.94-.193 1.231-5.979.94.194zm6.195 1.275l-1.311-.27-1.62-5.49-1.019 4.948-.923-.19 1.23-5.979 1.312.27 1.621 5.482 1.017-4.94.924.19zm7.08 1.457l-.2-1.407-2.597-.535-.732 1.215-.957-.196 3.448-5.522 1.04.214 1.02 6.441zm3.136.645l-.83-6.402 1.03.212.578 5.258 2.564-4.611.99.203-3.268 5.56zm9.018-3.543l-3.2-.658-.352 1.708 3.02.62-.163.792-3.019-.62-.388 1.88 3.2.658-.164.8-4.14-.852 1.232-5.978 4.139.852zm42.527 10.938l.239-1.55-6.208-.957.159-1.034 6.208.957.24-1.551 1.743 2.385zm167.661 7.687l.12-1.564-6.262-.482.08-1.043 6.263.482.12-1.565 1.92 2.246zm286.132 45.762l6.124 1.401.35-1.53 1.567 2.505-2.5 1.574.35-1.53-6.124-1.4z"
                className={classes.cls12}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1195.13 142.887l-1.41-.29-.402 1.946 1.46.301c.8.165 1.27-.109 1.4-.743.136-.66-.19-1.038-1.049-1.214zM1791.684 202.725a1550.587 1550.587 0 00-256.756-53.958c-88.671-10.697-145.514-8.97-148.996-8.85-136.5-2.682-276.95-41.795-370.751-74.14-59.886-20.652-108.87-41.237-139.213-54.765h-25.37a1702.537 1702.537 0 00160.992 64.664c94.591 32.63 236.31 72.088 374.284 74.772l.156.003.155-.007c.565-.022 57.424-2.106 147.758 8.81 83.268 10.062 212.807 33.543 357.228 88.258V236.27a1535.827 1535.827 0 00-94.359-32q-2.57-.78-5.128-1.545zM906.253 30.263l-5.755-2.518-.63 1.437-1.072-2.753 2.75-1.08-.628 1.437 5.754 2.519zm257.157 84.941l-6.085-1.56-.39 1.52-1.501-2.545 2.541-1.508-.39 1.52 6.085 1.56zm216.418 30.597l-6.26-.533-.132 1.563-1.902-2.262 2.257-1.907-.133 1.563 6.258.534zm236.8 21.257l-6.248-.655-.163 1.56-1.858-2.298 2.294-1.863-.164 1.56 6.248.655z"
                className={classes.cls12}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1187.995 138.73a1.375 1.375 0 011.222 1.212l.906.188a2.143 2.143 0 00-1.925-2.175c-1.014-.209-2.295.078-2.527 1.207a1.799 1.799 0 001.317 1.998l.704.3c.607.263 1.158.634 1.03 1.252-.12.585-.731.84-1.514.678a1.476 1.476 0 01-1.312-1.56l-.923-.19a2.293 2.293 0 002.042 2.526c1.154.237 2.428-.145 2.671-1.332.25-1.212-.724-1.782-1.64-2.177l-.678-.294c-.498-.215-.833-.55-.73-1.046.128-.626.92-.678 1.357-.588zM1196.535 142.696a1.528 1.528 0 00.926-1.16c.25-1.211-.712-1.71-1.81-1.936l-2.201-.453-1.231 5.978 2.375.49c1.22.25 2.287-.046 2.548-1.316a1.438 1.438 0 00-.607-1.603zm-.357 1.405c-.13.634-.6.908-1.4.743l-1.46-.3.401-1.946 1.41.29c.859.175 1.185.553 1.049 1.213zm-.932-1.946l-1.378-.283.361-1.757 1.378.284c.627.13 1 .488.883 1.058-.134.652-.593.832-1.244.698zM1200.536 140.605l-3.449 5.522.956.197.733-1.216 2.597.534.2 1.408 1.023.21-1.02-6.441zm-1.317 3.77l1.594-2.647.435 3.063z"
                className={classes.cls13}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1163.051 130.599L1162.111 130.406 1160.881 136.385 1164.904 137.212 1165.069 136.412 1161.985 135.778 1163.051 130.599z"
                className={classes.cls13}
              />
              <path
                d="M1210.807 142.719l-1.631-.336-1.231 5.978 1.632.336c1.897.39 3.44-.006 3.914-2.314.474-2.3-.786-3.274-2.684-3.664zm1.712 3.463c-.406 1.971-1.628 1.978-2.824 1.732l-.651-.135.911-4.428.651.135c1.196.246 2.315.742 1.913 2.696z"
                className={classes.cls13}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1178.445 133.768L1176.445 138.392 1176.334 133.333 1175.237 133.107 1173.213 137.727 1173.151 132.678 1172.12 132.466 1172.356 138.747 1173.486 138.979 1175.53 134.44 1175.631 139.42 1176.761 139.652 1179.434 133.971 1178.445 133.768z"
                className={classes.cls13}
              />
              <path
                d="M1219.378 147.746H1225.482V148.70600000000002H1219.378z"
                className={classes.cls13}
                transform="rotate(-78.377 1194.487 168.71)"
              />
              <path
                d="M1185.392 140.344L1183.77 134.863 1182.459 134.593 1181.228 140.572 1182.152 140.762 1183.17 135.815 1184.79 141.305 1186.101 141.574 1187.332 135.596 1186.409 135.406 1185.392 140.344z"
                className={classes.cls13}
              />
              <path
                d="M1234.52 147.598l-3.447 5.522.956.196.733-1.215 2.597.535.2 1.407 1.022.21-1.02-6.44zm-1.315 3.769l1.592-2.647.436 3.064z"
                className={classes.cls13}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1199.659 138.133L1197.095 142.745 1196.518 137.486 1195.487 137.274 1196.317 143.676 1197.382 143.895 1200.65 138.336 1199.659 138.133z"
                className={classes.cls13}
              />
              <path
                d="M1200.13 144.461L1204.269 145.313 1204.434 144.513 1201.234 143.854 1201.621 141.974 1204.64 142.595 1204.803 141.804 1201.784 141.183 1202.135 139.475 1205.336 140.133 1205.5 139.335 1201.361 138.482 1200.13 144.461z"
                className={classes.cls13}
              />
              <path
                d="M1142.055 961.169l-.829.662.218.658 1.38 4.167.449 1.356.763-.61-.447-1.279-.022-.061 2.07-1.657.222.136.99.61.815-.652-.942-.56-3.973-2.358zm1.23 4.082l-1.018-2.915 2.636 1.622zM1149.04 957.831a2.167 2.167 0 00-.41-.393c-.778-.58-1.652-.209-2.742.662l-1.511 1.21.585.73 2.634 3.29.596.744.749-.598-.557-.696-1.048-1.31.823-.658c.105-.084.21-.169.303-.253l1.857.844.772.351.84-.674-.715-.32-2.092-.937a1.516 1.516 0 00-.085-1.992zm-1.331 2.338l-.862.69-1.096-1.368-.13-.163.85-.678a1.762 1.762 0 011.246-.557.91.91 0 01.565.369c.525.657.13 1.145-.573 1.708zM1155.38 955.779l-.723.578a1.6 1.6 0 01-.504 2.064c-.821.659-1.975.47-2.917-.707a2.715 2.715 0 01-.678-1.657 1.641 1.641 0 01.637-1.319 1.582 1.582 0 011.625-.305 1.946 1.946 0 01.487.276l.722-.579a2.993 2.993 0 00-.4-.294 2.433 2.433 0 00-2.9.252 2.639 2.639 0 00-1.048 2.598 3.675 3.675 0 00.786 1.643 3.313 3.313 0 002.257 1.35 2.636 2.636 0 001.909-.618 2.76 2.76 0 001.002-1.477 2.536 2.536 0 00-.255-1.805zM1155.556 950.362l-.828.664.531 1.605 1.391 4.202.124.373.763-.61-.116-.333-.353-1.007 2.071-1.657 1.03.633.181.112.815-.653-.147-.087-3.923-2.329zm1.231 4.084l-.817-2.34-.202-.576.536.33 2.1 1.293zM1163.715 947.737a4.005 4.005 0 00-.861-.805c-1.208-.839-2.454-.446-3.674.53l-1.3 1.041 1.101 1.378 2.63 3.284.082.104 1.302-1.042a6.145 6.145 0 00.667-.624 2.637 2.637 0 00.053-3.865zm-1.248 3.9l-.519.415-2.203-2.753-.621-.776.519-.415a2.104 2.104 0 012.391-.552 3.015 3.015 0 01.906.803c1.256 1.571.48 2.515-.473 3.278z"
                className={classes.cls13}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1122.228 934.586L1121.019 933.076 1120.27 933.676 1121.464 935.167 1124.084 938.44 1124.084 938.441 1124.1 938.428 1124.834 937.842 1122.228 934.586z"
                className={classes.cls13}
              />
              <path
                d="M1168.5 947.822l-.468-1.341 2.07-1.657 1.212.746.814-.652-3.785-2.248-1.823-1.082-.829.663.658 1.986 1.389 4.195zm-1.768-5.065l.842.517 1.793 1.103-1.616 1.295-.696-1.99z"
                className={classes.cls13}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1133.435 930.957L1131.581 927.167 1131.248 926.486 1131.84 926.957 1135.145 929.589 1136.045 928.868 1134.238 925.011 1133.381 923.183 1132.593 923.813 1133.503 925.607 1134.874 928.308 1132.499 926.422 1130.91 925.16 1130.036 925.861 1130.949 927.68 1132.297 930.369 1129.964 928.479 1128.373 927.191 1127.551 927.848 1129.189 929.108 1132.535 931.679 1133.435 930.957z"
                className={classes.cls13}
              />
              <path
                d="M1178.154 932.277l-.829.663.645 1.947 1.402 4.234.763-.611-.47-1.34 2.072-1.657 1.17.72.042.026.814-.652-.065-.038-3.83-2.274zm1.23 4.083l-.718-2.057-.3-.859.763.47 1.873 1.153zM1186.685 931.046c-.773-.965-1.835-.58-2.723-.13l-.66.335a1.06 1.06 0 01-1.07.06.763.763 0 01-.2-.164c-.4-.5.067-1.144.415-1.421a1.375 1.375 0 011.714-.165l.723-.578a2.142 2.142 0 00-2.903.093c-.809.646-1.406 1.814-.685 2.714a1.658 1.658 0 00.166.168 1.862 1.862 0 002.212.096l.681-.35c.59-.3 1.228-.487 1.623.006.372.467.177 1.099-.447 1.598a1.477 1.477 0 01-2.04.013l-.736.589a2.15 2.15 0 002.216.59 3.082 3.082 0 001.89-1.639 1.685 1.685 0 00-.176-1.815z"
                className={classes.cls13}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1146.226 912.902L1145.478 913.502 1146.367 914.613 1147.077 915.5 1144.684 917.415 1144.067 916.644 1143.084 915.417 1142.335 916.016 1143.342 917.274 1145.97 920.559 1146.148 920.782 1146.898 920.182 1146.695 919.929 1145.188 918.046 1147.582 916.131 1148.999 917.902 1149.291 918.268 1150.04 917.667 1149.714 917.259 1147.082 913.971 1146.226 912.902z"
                className={classes.cls13}
              />
              <path
                d="M1248.261 148.487L1242.052 147.53 1241.893 148.564 1248.101 149.521 1247.862 151.071 1250.243 149.322 1248.5 146.936 1248.261 148.487z"
                className={classes.cls14}
              />
              <path
                d="M1009.783 94.313L1003.825 92.323 1003.493 93.315 1009.452 95.305 1008.955 96.793 1011.597 95.47 1010.28 92.825 1009.783 94.313z"
                className={classes.cls14}
              />
              <path
                d="M775.885 9.954L769.926 7.965 769.595 8.957 775.553 10.946 775.056 12.435 777.698 11.111 776.382 8.466 775.885 9.954z"
                className={classes.cls14}
              />
              <path
                d="M1415.724 156.151L1409.461 155.669 1409.381 156.712 1415.644 157.194 1415.524 158.758 1417.765 156.832 1415.845 154.586 1415.724 156.151z"
                className={classes.cls14}
              />
              <path
                d="M1707.196 208.47L1709.697 206.896 1708.129 204.392 1707.779 205.921 1701.655 204.521 1701.422 205.54 1707.546 206.941 1707.196 208.47z"
                className={classes.cls14}
              />
              <path
                d="M1568.275 152.79L1565.982 154.653 1567.839 156.952 1568.003 155.391 1574.25 156.046 1574.359 155.006 1568.112 154.351 1568.275 152.79z"
                className={classes.cls14}
              />
              <path
                d="M1331.413 131.65L1329.156 133.557 1331.058 135.819 1331.191 134.256 1337.45 134.789 1337.539 133.747 1331.28 133.213 1331.413 131.65z"
                className={classes.cls14}
              />
              <path
                d="M1115.598 100.098L1113.057 101.606 1114.558 104.151 1114.948 102.632 1121.033 104.192 1121.292 103.179 1115.208 101.618 1115.598 100.098z"
                className={classes.cls14}
              />
              <path
                d="M859.169 14.337L856.419 15.417 857.492 18.17 858.121 16.733 863.875 19.251 864.295 18.293 858.54 15.774 859.169 14.337z"
                className={classes.cls14}
              />
              <path
                d="M1625.284 475.896c0-1.748-1.474-2.296-3.518-2.296h-2.338v4.592h2.486c2.38 0 3.37-.779 3.37-2.296zM1710.384 475.896c0-1.748-1.474-2.296-3.518-2.296h-2.338v4.592h2.486c2.38 0 3.37-.779 3.37-2.296z"
                className={classes.cls15}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1602.923 463.448h-30.096v29.35h40.223v27.28h71.279v-27.28h40.223v-29.35h-121.63zm98.593 7.793h5.014c5.034 0 6.95 1.433 6.95 4.634a4.138 4.138 0 01-2.759 4.023l3.392 6.614h-3.35l-3.033-5.982h-3.202v5.983h-3.012zm-32.366 8.931l-1.938-.358c-2.464-.506-4.571-1.77-4.571-4.424 0-3.074 3.286-4.422 6.087-4.422 3.139 0 5.835 1.853 6.004 4.78h-2.907c-.232-1.79-1.79-2.38-3.223-2.38-1.41 0-2.95.527-2.95 1.895 0 1.075.886 1.665 2.128 1.897l2.001.358c2.486.463 5.224 1.411 5.224 4.592 0 3.138-3.117 4.675-6.192 4.675-3.75 0-6.235-2.021-6.51-5.308h2.908c.337 2.254 1.896 2.907 3.707 2.907 1.348 0 3.055-.506 3.055-2.127 0-1.284-1.202-1.81-2.823-2.085zm-26.367-8.93h3.012v6.234h6.845v-6.235h3.013v15.271h-3.013v-6.593h-6.845v6.593h-3.012zm-45.57 15.27h-3.918l-6.108-11.648v11.648h-2.844v-15.27h3.917l6.11 11.648v-11.649h2.843zm9.602.274c-4.55 0-7.478-3.18-7.478-7.92s2.928-7.898 7.478-7.898 7.478 3.159 7.478 7.898-2.929 7.92-7.478 7.92zm12.613-6.256v5.982h-3.012v-15.27h5.014c5.033 0 6.95 1.432 6.95 4.633a4.138 4.138 0 01-2.76 4.023l3.392 6.614h-3.349l-3.033-5.982h-3.202zm16.987 31.254h-2.38l-.084-1.79a5.278 5.278 0 01-4.593 2.063c-4.296 0-6.971-3.096-6.971-7.982 0-4.74 2.802-7.836 7.477-7.836 3.602 0 6.003 2.085 6.51 4.907h-2.865a3.549 3.549 0 00-3.665-2.506c-2.55 0-4.34 1.79-4.34 5.435 0 3.685 1.686 5.581 4.318 5.581 1.622 0 3.813-.821 3.813-3.264v-.253h-3.813v-2.464h6.594zm.177-25.272h-3.012v-12.827h-4.697v-2.444h12.427v2.444h-4.718zm12.457 25.272l-1.074-3.097h-5.94l-1.075 3.097h-3.074l5.687-15.271h3.033l5.709 15.27zm13.69-12.828h-4.719v12.828h-3.012v-12.828h-4.697v-2.444h12.428zm12.593 0h-8.11v3.791h7.668v2.443h-7.668v4.15h8.11v2.443h-11.122v-15.27h11.122zm19.11-27.715l5.709 15.271h-3.265l-1.074-3.096h-5.94l-1.074 3.096h-3.076l5.687-15.27zm-19.144 0h12.427v2.444h-4.718v12.827h-3.012v-12.827h-4.697z"
                className={classes.cls15}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1650.464 463.916L1648.358 469.939 1652.57 469.939 1650.464 463.916z"
                className={classes.cls15}
              />
              <path
                d="M1606.815 473.369c-2.38 0-4.361 1.916-4.361 5.497 0 3.602 1.98 5.519 4.36 5.519s4.36-1.917 4.36-5.519c0-3.58-1.98-5.497-4.36-5.497z"
                className={classes.cls15}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M1600.521 495.211L1604.734 495.211 1602.627 489.187 1600.521 495.211z"
                className={classes.cls15}
              />
              <path d="M1551.992 471.878L1545.883 460.229 1541.965 460.229 1541.965 475.5 1544.81 475.5 1544.81 463.852 1550.918 475.5 1554.836 475.5 1554.836 460.229 1551.992 460.229 1551.992 471.878z" />
              <path
                d="M1606.815 470.968c-4.55 0-7.478 3.159-7.478 7.898s2.928 7.92 7.478 7.92 7.478-3.18 7.478-7.92-2.929-7.898-7.478-7.898zm0 13.417c-2.38 0-4.361-1.917-4.361-5.519 0-3.58 1.98-5.497 4.36-5.497s4.36 1.916 4.36 5.497c0 3.602-1.98 5.519-4.36 5.519zM1625.664 486.512h3.349l-3.392-6.614a4.138 4.138 0 002.76-4.023c0-3.201-1.918-4.634-6.95-4.634h-5.015v15.271h3.012v-5.982h3.202zm-6.236-8.32V473.6h2.338c2.044 0 3.518.548 3.518 2.296 0 1.517-.99 2.296-3.37 2.296z"
                transform="translate(-42.377 -11.012)"
              />
              <path d="M1598.933 460.229L1586.506 460.229 1586.506 462.672 1591.203 462.672 1591.203 475.5 1594.215 475.5 1594.215 462.672 1598.933 462.672 1598.933 460.229z" />
              <path d="M1603.417 468.907L1610.262 468.907 1610.262 475.5 1613.275 475.5 1613.275 460.229 1610.262 460.229 1610.262 466.464 1603.417 466.464 1603.417 460.229 1600.405 460.229 1600.405 475.5 1603.417 475.5 1603.417 468.907z" />
              <path
                d="M1668.917 484.385c-1.81 0-3.37-.653-3.707-2.907h-2.907c.275 3.286 2.76 5.308 6.51 5.308 3.075 0 6.192-1.537 6.192-4.676 0-3.18-2.738-4.128-5.224-4.592l-2-.358c-1.243-.231-2.128-.821-2.128-1.896 0-1.369 1.538-1.895 2.949-1.895 1.432 0 2.991.589 3.222 2.38h2.907c-.168-2.928-2.864-4.78-6.003-4.78-2.8 0-6.087 1.347-6.087 4.422 0 2.654 2.107 3.918 4.57 4.424l1.939.358c1.621.274 2.822.8 2.822 2.085 0 1.62-1.707 2.127-3.055 2.127z"
                transform="translate(-42.377 -11.012)"
              />
              <path d="M1637.618 475.5L1640.63 475.5 1640.63 462.672 1645.348 462.672 1645.348 460.229 1632.921 460.229 1632.921 462.672 1637.618 462.672 1637.618 475.5z" />
              <path
                d="M1688.797 486.512l1.075-3.096h5.94l1.074 3.096h3.265l-5.708-15.27h-3.034l-5.687 15.27zm4.045-11.584l2.105 6.023h-4.211zM1704.528 480.53h3.202l3.034 5.983h3.349l-3.391-6.614a4.138 4.138 0 002.758-4.024c0-3.201-1.916-4.634-6.95-4.634h-5.014v15.272h3.012zm0-6.93h2.338c2.044 0 3.518.548 3.518 2.296 0 1.517-.99 2.296-3.37 2.296h-2.486zM1629.822 506.138h3.813v.253c0 2.443-2.192 3.265-3.813 3.265-2.632 0-4.318-1.896-4.318-5.582 0-3.644 1.79-5.434 4.34-5.434a3.549 3.549 0 013.664 2.506h2.865c-.506-2.823-2.907-4.907-6.509-4.907-4.676 0-7.478 3.096-7.478 7.835 0 4.887 2.676 7.983 6.972 7.983a5.278 5.278 0 004.593-2.064l.084 1.79h2.38v-8.109h-6.594zM1643.573 496.512l-5.687 15.272h3.074l1.075-3.097h5.94l1.073 3.097h3.266l-5.709-15.272zm-.674 9.71l2.106-6.023 2.106 6.023z"
                transform="translate(-42.377 -11.012)"
              />
              <path d="M1607.933 487.944L1612.63 487.944 1612.63 500.772 1615.642 500.772 1615.642 487.944 1620.361 487.944 1620.361 485.5 1607.933 485.5 1607.933 487.944z" />
              <path d="M1621.833 500.772L1632.955 500.772 1632.955 498.328 1624.845 498.328 1624.845 494.178 1632.512 494.178 1632.512 491.735 1624.845 491.735 1624.845 487.944 1632.955 487.944 1632.955 485.5 1621.833 485.5 1621.833 500.772z" />
              <path
                d="M559.218 993.227L556.797 1000.152 561.639 1000.152 559.218 993.227z"
                className={classes.cls15}
              />
              <path
                d="M495.506 993.806v29.349H647.23v-29.35H495.506zm128.178 6.196h12.785v2.809h-9.322v4.357h8.814v2.81h-8.814v4.77h9.322v2.808h-12.785zm-15.983 0h14.286v2.809h-5.424v14.745H613.1v-14.745h-5.4zm-7.752 0h3.487l6.561 17.554h-3.752l-1.235-3.559h-6.829l-1.234 3.56h-3.536zm-15.766-.315c4.14 0 6.9 2.398 7.481 5.642h-3.293a4.078 4.078 0 00-4.213-2.881c-2.93 0-4.987 2.057-4.987 6.246 0 4.238 1.936 6.417 4.963 6.417 1.865 0 4.383-.945 4.383-3.753v-.291h-4.383v-2.833h7.579v9.322h-2.736l-.097-2.057a6.068 6.068 0 01-5.278 2.372c-4.94 0-8.015-3.559-8.015-9.176 0-5.448 3.22-9.008 8.596-9.008zm-57.52 17.87h-3.221v-13.197l-4.31 13.196h-3.439l-4.333-13.196v13.196h-3.22v-17.554h5.037l4.26 13.68 4.14-13.68h5.086zm26.11-17.554h4.504l7.022 13.39v-13.39h3.268v17.554h-4.503l-7.022-13.39v13.39h-3.269zm-6.611 0h3.462v17.554h-3.462zm-1.577 17.554h-3.753l-1.235-3.56h-6.828l-1.235 3.56H528l6.537-17.554h3.487z"
                className={classes.cls15}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M491.384 1000.152L496.227 1000.152 493.806 993.227 491.384 1000.152z"
                className={classes.cls15}
              />
              <path d="M475.06 1002.671L470.799 988.99 465.762 988.99 465.762 1006.544 468.983 1006.544 468.983 993.348 473.317 1006.544 476.755 1006.544 481.065 993.348 481.065 1006.544 484.285 1006.544 484.285 988.99 479.201 988.99 475.06 1002.671z" />
              <path
                d="M534.536 1000.002L528 1017.556h3.535l1.235-3.559h6.828l1.235 3.56h3.753l-6.562-17.555zm4.068 11.162h-4.843l2.422-6.925z"
                transform="translate(-42.377 -11.012)"
              />
              <path d="M503.785 988.99H507.247V1006.544H503.785z" />
              <path d="M513.665 993.155L520.687 1006.544 525.19 1006.544 525.19 988.99 521.922 988.99 521.922 1002.38 514.9 988.99 510.396 988.99 510.396 1006.544 513.665 1006.544 513.665 993.155z" />
              <path
                d="M583.602 1017.87a6.068 6.068 0 005.278-2.371l.097 2.057h2.736v-9.322h-7.579v2.833h4.383v.29c0 2.809-2.518 3.754-4.383 3.754-3.026 0-4.963-2.179-4.963-6.417 0-4.189 2.058-6.246 4.987-6.246a4.078 4.078 0 014.213 2.88h3.293c-.58-3.243-3.341-5.641-7.481-5.641-5.376 0-8.596 3.56-8.596 9.007 0 5.618 3.075 9.177 8.015 9.177zM598.181 1013.997h6.829l1.235 3.56h3.753l-6.562-17.555h-3.487l-6.537 17.554h3.535zm3.415-9.758l2.42 6.925h-4.842z"
                transform="translate(-42.377 -11.012)"
              />
              <path d="M570.723 1006.544L574.186 1006.544 574.186 991.799 579.609 991.799 579.609 988.99 565.323 988.99 565.323 991.799 570.723 991.799 570.723 1006.544z" />
              <path d="M594.092 1003.736L584.77 1003.736 584.77 998.966 593.583 998.966 593.583 996.156 584.77 996.156 584.77 991.799 594.092 991.799 594.092 988.99 581.307 988.99 581.307 1006.544 594.092 1006.544 594.092 1003.736z" />
            </g>
            <path
              d="M819.517 485.397c1.886-9.19 6.599-17.046 16.496-17.046 11.47 0 16.496 12.254 16.496 22.702 0 11.704-6.912 21.758-17.831 22.386V502.6c6.677-.864 8.877-6.677 8.877-12.019 0-5.263-1.964-10.997-7.07-10.997-4.007 0-6.206 3.3-7.07 7.934l-1.335 7.462c-1.729 9.269-5.263 19.481-17.125 19.481-11.704 0-17.438-11.626-17.438-23.094 0-13.983 7.541-23.252 19.795-24.273v10.84c-8.405 1.257-10.84 7.07-10.84 13.826 0 5.027 1.886 11.39 7.934 11.39 4.791 0 6.755-4.477 7.776-10.526zM842.376 533.073v-17.517h9.112v46.345h-9.112v-17.595h-47.838v-11.233zM851.488 575.645v11.313l-56.95 21.287V596.07l11.547-4.006v-22.151l-11.547-4.007v-11.468zm-36.212-2.513v15.71l22.466-7.855zM851.488 613.346v22.152c0 9.975-3.142 20.737-14.846 20.737a15.453 15.453 0 01-12.019-6.44c-2.12 4.398-5.42 8.483-13.275 8.483-12.254 0-16.81-10.134-16.81-21.838v-23.095zm-48.152 11.233v12.411c0 6.52 2.67 9.82 8.012 9.82s8.17-3.3 8.17-10.29v-11.942zm24.665 0v11.625c0 5.342 2.514 8.484 7.541 8.484 4.477 0 7.148-3.22 7.148-8.484V624.58zM803.65 676.732v27.73h-9.112v-38.963h56.95v11.233zM851.488 709.563v41.476h-9.112v-30.243h-14.14v28.592h-9.111v-28.593H803.65v30.243h-9.112v-41.476zM819.517 773.186c1.886-9.191 6.599-17.046 16.496-17.046 11.47 0 16.496 12.254 16.496 22.701 0 11.704-6.912 21.759-17.831 22.387v-10.84c6.677-.864 8.877-6.677 8.877-12.017 0-5.264-1.964-10.998-7.07-10.998-4.007 0-6.206 3.299-7.07 7.933l-1.335 7.463c-1.729 9.27-5.263 19.48-17.125 19.48-11.704 0-17.438-11.624-17.438-23.094 0-13.981 7.541-23.25 19.795-24.271v10.84c-8.405 1.256-10.84 7.07-10.84 13.824 0 5.027 1.886 11.39 7.934 11.39 4.791 0 6.755-4.477 7.776-10.526z"
              className={classes.cls16}
              transform="translate(-42.377 -11.012)"
            />
            <path
              d="M807.332 443.649L807.332 475.234 796.874 475.254 796.874 443.669 807.332 443.649z"
              className={classes.cls17}
            />
            <path
              d="M807.332 443.649L808.772 447.321 808.772 478.905 807.332 475.234 807.332 443.649z"
              className={classes.cls18}
            />
            <path
              d="M807.332 475.234L808.772 478.905 798.313 478.925 796.874 475.254 807.332 475.234z"
              className={classes.cls19}
            />
            <path
              d="M991.432 283.267L991.432 289.79 955.301 289.859 955.301 283.336 991.432 283.267z"
              className={classes.cls17}
            />
            <path
              d="M991.432 283.267L992.871 286.939 992.871 293.462 991.432 289.79 991.432 283.267z"
              className={classes.cls18}
            />
            <path
              d="M991.432 289.79L992.871 293.462 956.74 293.531 955.301 289.859 991.432 289.79z"
              className={classes.cls19}
            />
            <path
              d="M1603.497 315.306L1634.351 324.483 1632.371 331.085 1601.517 321.918 1603.497 315.306z"
              className={classes.cls17}
            />
            <path
              d="M1634.351 324.483L1635.791 328.154 1633.811 334.757 1632.371 331.085 1634.351 324.483z"
              className={classes.cls20}
            />
            <path
              d="M1632.371 331.085L1633.811 334.757 1602.957 325.589 1601.517 321.918 1632.371 331.085z"
              className={classes.cls19}
            />
            <path
              d="M1690.834 259.62L1720.912 268.562 1718.922 275.202 1688.835 266.26 1690.834 259.62z"
              className={classes.cls17}
            />
            <path
              d="M1720.912 268.562L1722.351 272.233 1720.362 278.873 1718.922 275.202 1720.912 268.562z"
              className={classes.cls20}
            />
            <path
              d="M1718.922 275.202L1720.362 278.873 1690.275 269.931 1688.835 266.26 1718.922 275.202z"
              className={classes.cls19}
            />
            <path
              d="M1417.621 388.335L1419.522 393.455 1417.445 403.202 1415.544 398.082 1417.621 388.335z"
              className={classes.cls21}
            />
            <path
              d="M1415.544 398.082L1417.445 403.202 1387.908 396.287 1386.007 391.167 1415.544 398.082z"
              className={classes.cls19}
            />
            <path
              d="M1392.224 361.901L1490.759 384.958 1486.605 404.491 1417.621 388.335 1415.544 398.082 1386.007 391.167 1388.071 381.421 1392.224 361.901z"
              className={classes.cls17}
            />
            <path
              d="M1490.759 384.958L1492.66 390.078 1488.506 409.611 1486.605 404.491 1490.759 384.958z"
              className={classes.cls21}
            />
            <path
              d="M1486.605 404.491L1488.506 409.611 1419.522 393.455 1417.621 388.335 1486.605 404.491z"
              className={classes.cls19}
            />
            <path
              d="M1535.458 245.378L1541.739 268.045 1534.141 270.149 1527.861 247.491 1535.458 245.378z"
              className={classes.cls17}
            />
            <path
              d="M1535.458 245.378L1536.898 249.049 1543.178 271.717 1541.739 268.045 1535.458 245.378z"
              className={classes.cls22}
            />
            <path
              d="M1541.739 268.045L1543.178 271.717 1535.581 273.82 1534.141 270.149 1541.739 268.045z"
              className={classes.cls19}
            />
            <path
              d="M1091.755 237.311L1094.559 264.22 1071.738 266.636 1068.934 239.727 1091.755 237.311z"
              className={classes.cls17}
            />
            <path
              d="M1091.755 237.311L1093.194 240.982 1095.999 267.891 1094.559 264.22 1091.755 237.311z"
              className={classes.cls23}
            />
            <path
              d="M1094.559 264.22L1095.999 267.891 1073.178 270.307 1071.738 266.636 1094.559 264.22z"
              className={classes.cls19}
            />
            <path
              d="M1099.165 268.255L1101.969 295.155 1071.74 298.351 1068.936 271.442 1099.165 268.255z"
              className={classes.cls17}
            />
            <path
              d="M1099.165 268.255L1100.604 271.927 1103.408 298.826 1101.969 295.155 1099.165 268.255z"
              className={classes.cls23}
            />
            <path
              d="M1101.969 295.155L1103.408 298.826 1073.179 302.023 1071.74 298.351 1101.969 295.155z"
              className={classes.cls19}
            />
            <path
              d="M1102.018 300.392L1105.801 336.784 1077.979 339.723 1074.184 303.331 1102.018 300.392z"
              className={classes.cls17}
            />
            <path
              d="M1102.018 300.392L1103.755 304.821 1107.538 341.214 1105.801 336.784 1102.018 300.392z"
              className={classes.cls23}
            />
            <path
              d="M1105.801 336.784L1107.538 341.214 1079.716 344.153 1077.979 339.723 1105.801 336.784z"
              className={classes.cls19}
            />
            <path
              d="M1097.581 213.835L1097.581 219.355 1065.912 219.416 1065.912 213.895 1097.581 213.835z"
              className={classes.cls17}
            />
            <path
              d="M1097.581 213.835L1099.02 217.506 1099.02 223.027 1097.581 219.355 1097.581 213.835z"
              className={classes.cls18}
            />
            <path
              d="M1097.581 219.355L1099.02 223.027 1067.352 223.087 1065.912 219.416 1097.581 219.355z"
              className={classes.cls19}
            />
            <path
              d="M1296.488 286.692L1296.488 293.017 1264.686 293.078 1264.686 286.753 1296.488 286.692z"
              className={classes.cls17}
            />
            <path
              d="M1296.488 286.692L1297.927 290.364 1297.927 296.688 1296.488 293.017 1296.488 286.692z"
              className={classes.cls18}
            />
            <path
              d="M1296.488 293.017L1297.927 296.688 1266.126 296.749 1264.686 293.078 1296.488 293.017z"
              className={classes.cls19}
            />
            <path
              d="M1087.28 417.984L1087.28 426.728 1053.451 426.793 1053.451 418.048 1087.28 417.984z"
              className={classes.cls17}
            />
            <path
              d="M1087.28 417.984L1088.719 421.655 1088.719 430.4 1087.28 426.728 1087.28 417.984z"
              className={classes.cls18}
            />
            <path
              d="M1087.28 426.728L1088.719 430.4 1054.89 430.464 1053.451 426.793 1087.28 426.728z"
              className={classes.cls19}
            />
            <path
              d="M1024.115 436.26L1025.554 439.932 1025.554 443.931 1024.115 440.259 1024.115 436.26z"
              className={classes.cls18}
            />
            <path
              d="M1024.115 440.259L1025.554 443.931 1012.699 443.955 1011.259 440.284 1024.115 440.259z"
              className={classes.cls19}
            />
            <path
              d="M1039.717 409.25L1039.717 436.231 1024.115 436.26 1024.115 440.259 1011.259 440.284 1011.259 436.285 1011.259 413.303 1011.259 409.304 1039.717 409.25z"
              className={classes.cls17}
            />
            <path
              d="M1039.717 409.25L1041.156 412.921 1041.156 439.902 1039.717 436.231 1039.717 409.25z"
              className={classes.cls18}
            />
            <path
              d="M1039.717 436.231L1041.156 439.902 1025.554 439.932 1024.115 436.26 1039.717 436.231z"
              className={classes.cls19}
            />
            <path
              d="M1464.134 657.405L1559.453 685.811 1551.486 712.268 1456.177 683.862 1464.134 657.405z"
              className={classes.cls17}
            />
            <path
              d="M1559.453 685.811L1560.893 689.482 1552.926 715.939 1551.486 712.268 1559.453 685.811z"
              className={classes.cls20}
            />
            <path
              d="M1551.486 712.268L1552.926 715.939 1457.616 687.533 1456.177 683.862 1551.486 712.268z"
              className={classes.cls19}
            />
            <path
              d="M1572.004 570.444L1596.918 577.864 1587.435 609.373 1562.521 601.952 1572.004 570.444z"
              className={classes.cls17}
            />
            <path
              d="M1596.918 577.864L1598.357 581.536 1588.875 613.044 1587.435 609.373 1596.918 577.864z"
              className={classes.cls20}
            />
            <path
              d="M1587.435 609.373L1588.875 613.044 1563.96 605.623 1562.521 601.952 1587.435 609.373z"
              className={classes.cls19}
            />
            <path
              d="M1600.262 606.852L1621.653 613.231 1610.929 648.882 1589.529 642.513 1600.262 606.852z"
              className={classes.cls17}
            />
            <path
              d="M1621.653 613.231L1623.092 616.902 1612.368 652.553 1610.929 648.882 1621.653 613.231z"
              className={classes.cls20}
            />
            <path
              d="M1610.929 648.882L1612.368 652.553 1590.968 646.184 1589.529 642.513 1610.929 648.882z"
              className={classes.cls19}
            />
            <path
              d="M1579.063 669.762L1596.2 674.862 1591.966 688.956 1574.819 683.846 1579.063 669.762z"
              className={classes.cls17}
            />
            <path
              d="M1596.2 674.862L1597.64 678.533 1593.405 692.627 1591.966 688.956 1596.2 674.862z"
              className={classes.cls20}
            />
            <path
              d="M1591.966 688.956L1593.405 692.627 1576.259 687.517 1574.819 683.846 1591.966 688.956z"
              className={classes.cls19}
            />
            <path
              d="M1705.556 565.52L1706.995 569.191 1639.092 530.201 1637.652 526.53 1705.556 565.52z"
              className={classes.cls19}
            />
            <path
              d="M1720.419 574.066L1721.859 577.737 1713.788 591.697 1712.348 588.025 1720.419 574.066z"
              className={classes.cls24}
            />
            <path
              d="M1712.348 588.025L1713.788 591.697 1698.924 583.16 1697.485 579.489 1712.348 588.025z"
              className={classes.cls19}
            />
            <path
              d="M1657.394 492.365L1824.065 588.077 1804.323 622.242 1720.419 574.066 1712.348 588.025 1697.485 579.489 1705.556 565.52 1637.652 526.53 1657.394 492.365z"
              className={classes.cls17}
            />
            <path
              d="M1824.065 588.077L1825.505 591.748 1805.762 625.913 1804.323 622.242 1824.065 588.077z"
              className={classes.cls24}
            />
            <path
              d="M1804.323 622.242L1805.762 625.913 1721.859 577.737 1720.419 574.066 1804.323 622.242z"
              className={classes.cls19}
            />
            <path
              d="M1023.089 448.933L1023.089 469.334 1012.63 469.354 1012.63 448.953 1023.089 448.933z"
              className={classes.cls17}
            />
            <path
              d="M1023.089 448.933L1024.528 452.605 1024.528 473.005 1023.089 469.334 1023.089 448.933z"
              className={classes.cls18}
            />
            <path
              d="M1023.089 469.334L1024.528 473.005 1014.07 473.025 1012.63 469.354 1023.089 469.334z"
              className={classes.cls19}
            />
            <path
              d="M1251.302 497.265L1251.302 505.395 1217.436 505.46 1217.436 497.33 1251.302 497.265z"
              className={classes.cls17}
            />
            <path
              d="M1251.302 497.265L1252.742 500.936 1252.742 509.066 1251.302 505.395 1251.302 497.265z"
              className={classes.cls18}
            />
            <path
              d="M1251.302 505.395L1252.742 509.066 1218.875 509.131 1217.436 505.46 1251.302 505.395z"
              className={classes.cls19}
            />
            <path
              d="M1025.486 516.216L1025.486 549.814 1015.615 549.833 1015.615 516.235 1025.486 516.216z"
              className={classes.cls17}
            />
            <path
              d="M1025.486 516.216L1026.926 519.887 1026.926 553.485 1025.486 549.814 1025.486 516.216z"
              className={classes.cls18}
            />
            <path
              d="M1025.486 549.814L1026.926 553.485 1017.055 553.504 1015.615 549.833 1025.486 549.814z"
              className={classes.cls19}
            />
            <path
              d="M1095.164 569.249L1095.164 578.249 1059.061 578.318 1059.061 569.318 1095.164 569.249z"
              className={classes.cls17}
            />
            <path
              d="M1095.164 569.249L1096.603 572.92 1096.603 581.92 1095.164 578.249 1095.164 569.249z"
              className={classes.cls18}
            />
            <path
              d="M1095.164 578.249L1096.603 581.92 1060.501 581.989 1059.061 578.318 1095.164 578.249z"
              className={classes.cls19}
            />
            <path
              d="M1031.815 591.207L1031.815 625.656 1012.926 625.692 1012.926 591.243 1031.815 591.207z"
              className={classes.cls17}
            />
            <path
              d="M1031.815 591.207L1033.254 594.878 1033.254 629.327 1031.815 625.656 1031.815 591.207z"
              className={classes.cls18}
            />
            <path
              d="M1031.815 625.656L1033.254 629.327 1014.365 629.363 1012.926 625.692 1031.815 625.656z"
              className={classes.cls19}
            />
            <path
              d="M1175.659 640.372L1175.659 649.381 1139.557 649.45 1139.557 640.441 1175.659 640.372z"
              className={classes.cls17}
            />
            <path
              d="M1175.659 640.372L1177.098 644.043 1177.098 653.052 1175.659 649.381 1175.659 640.372z"
              className={classes.cls18}
            />
            <path
              d="M1175.659 649.381L1177.098 653.052 1140.996 653.121 1139.557 649.45 1175.659 649.381z"
              className={classes.cls19}
            />
            <path
              d="M1033.522 669.117L1033.522 706.988 1022.372 707.009 1022.372 669.138 1033.522 669.117z"
              className={classes.cls17}
            />
            <path
              d="M1033.522 669.117L1034.962 672.788 1034.962 710.659 1033.522 706.988 1033.522 669.117z"
              className={classes.cls18}
            />
            <path
              d="M1033.522 706.988L1034.962 710.659 1023.812 710.681 1022.372 707.009 1033.522 706.988z"
              className={classes.cls19}
            />
            <path
              d="M1035.986 760.13L1035.986 781.741 1024.922 781.763 1024.922 760.152 1035.986 760.13z"
              className={classes.cls17}
            />
            <path
              d="M1035.986 760.13L1037.426 763.802 1037.426 785.413 1035.986 781.741 1035.986 760.13z"
              className={classes.cls18}
            />
            <path
              d="M1035.986 781.741L1037.426 785.413 1026.361 785.434 1024.922 781.763 1035.986 781.741z"
              className={classes.cls19}
            />
            <path
              d="M863.931 85.417L877.298 90.676 874.494 97.753 861.118 92.484 863.931 85.417z"
              className={classes.cls17}
            />
            <path
              d="M877.298 90.676L878.737 94.347 875.933 101.424 874.494 97.753 877.298 90.676z"
              className={classes.cls25}
            />
            <path
              d="M874.494 97.753L875.933 101.424 862.557 96.155 861.118 92.484 874.494 97.753z"
              className={classes.cls19}
            />
            <path
              d="M471.325 322.78L505.892 331.345 503.296 341.712 468.729 333.146 471.325 322.78z"
              className={classes.cls17}
            />
            <path
              d="M505.892 331.345L507.332 335.017 504.736 345.383 503.296 341.712 505.892 331.345z"
              className={classes.cls26}
            />
            <path
              d="M503.296 341.712L504.736 345.383 470.168 336.818 468.729 333.146 503.296 341.712z"
              className={classes.cls19}
            />
            <path
              d="M556.607 313.512L558.047 317.183 551.538 316.855 550.099 313.184 556.607 313.512z"
              className={classes.cls19}
            />
            <path
              d="M550.516 305.252L597.617 307.629 604.125 307.957 603.187 325.836 556.086 323.458 556.607 313.512 550.099 313.184 550.516 305.252z"
              className={classes.cls17}
            />
            <path
              d="M604.125 307.957L605.564 311.628 604.626 329.507 603.187 325.836 604.125 307.957z"
              className={classes.cls27}
            />
            <path
              d="M603.187 325.836L604.626 329.507 557.526 327.129 556.086 323.458 603.187 325.836z"
              className={classes.cls19}
            />
            <path
              d="M392.574 443.156L392.574 475.232 380.354 475.255 380.354 443.179 392.574 443.156z"
              className={classes.cls17}
            />
            <path
              d="M392.574 443.156L394.014 446.827 394.014 478.903 392.574 475.232 392.574 443.156z"
              className={classes.cls18}
            />
            <path
              d="M392.574 475.232L394.014 478.903 381.793 478.926 380.354 475.255 392.574 475.232z"
              className={classes.cls19}
            />
            <path
              d="M301.167 487.94L301.167 495.408 267.651 495.472 267.651 488.004 301.167 487.94z"
              className={classes.cls17}
            />
            <path
              d="M301.167 487.94L302.607 491.611 302.607 499.079 301.167 495.408 301.167 487.94z"
              className={classes.cls18}
            />
            <path
              d="M301.167 495.408L302.607 499.079 269.091 499.143 267.651 495.472 301.167 495.408z"
              className={classes.cls19}
            />
            <path
              d="M731.382 419.792L731.382 426.731 698.283 426.794 698.283 419.855 731.382 419.792z"
              className={classes.cls17}
            />
            <path
              d="M731.382 419.792L732.821 423.463 732.821 430.402 731.382 426.731 731.382 419.792z"
              className={classes.cls18}
            />
            <path
              d="M731.382 426.731L732.821 430.402 699.722 430.466 698.283 426.794 731.382 426.731z"
              className={classes.cls19}
            />
            <path
              d="M646.812 494.509L646.812 503.603 613.371 503.667 613.371 494.573 646.812 494.509z"
              className={classes.cls17}
            />
            <path
              d="M646.812 494.509L648.251 498.18 648.251 507.275 646.812 503.603 646.812 494.509z"
              className={classes.cls18}
            />
            <path
              d="M646.812 503.603L648.251 507.275 614.811 507.338 613.371 503.667 646.812 503.603z"
              className={classes.cls19}
            />
            <path
              d="M693.522 562.616L693.522 571.711 658.177 571.778 658.177 562.684 693.522 562.616z"
              className={classes.cls17}
            />
            <path
              d="M693.522 562.616L694.961 566.287 694.961 575.382 693.522 571.711 693.522 562.616z"
              className={classes.cls18}
            />
            <path
              d="M693.522 571.711L694.961 575.382 659.617 575.449 658.177 571.778 693.522 571.711z"
              className={classes.cls19}
            />
            <path
              d="M325.034 751.537L325.034 791.223 312.794 791.247 312.794 751.56 325.034 751.537z"
              className={classes.cls17}
            />
            <path
              d="M325.034 751.537L326.473 755.208 326.473 794.895 325.034 791.223 325.034 751.537z"
              className={classes.cls18}
            />
            <path
              d="M325.034 791.223L326.473 794.895 314.234 794.918 312.794 791.247 325.034 791.223z"
              className={classes.cls19}
            />
            <path
              d="M395.782 721.367L395.782 729.78 357.548 729.853 357.548 721.44 395.782 721.367z"
              className={classes.cls17}
            />
            <path
              d="M395.782 721.367L397.221 725.038 397.221 733.452 395.782 729.78 395.782 721.367z"
              className={classes.cls18}
            />
            <path
              d="M395.782 729.78L397.221 733.452 358.988 733.524 357.548 729.853 395.782 729.78z"
              className={classes.cls19}
            />
            <path
              d="M335.761 668.204L335.761 706.425 321.087 706.453 321.087 668.232 335.761 668.204z"
              className={classes.cls17}
            />
            <path
              d="M335.761 668.204L337.2 671.875 337.2 710.096 335.761 706.425 335.761 668.204z"
              className={classes.cls18}
            />
            <path
              d="M335.761 706.425L337.2 710.096 322.526 710.124 321.087 706.453 335.761 706.425z"
              className={classes.cls19}
            />
            <path
              d="M428.202 558.348L429.641 562.019 429.641 568.684 428.202 565.013 428.202 558.348z"
              className={classes.cls18}
            />
            <path
              d="M451.061 564.969L452.5 568.64 452.5 585.203 451.061 581.532 451.061 564.969z"
              className={classes.cls18}
            />
            <path
              d="M362.022 622.948L363.462 626.619 333.081 626.677 331.642 623.006 362.022 622.948z"
              className={classes.cls19}
            />
            <path
              d="M389.012 631.036L390.451 634.707 363.462 634.759 362.022 631.087 389.012 631.036z"
              className={classes.cls19}
            />
            <path
              d="M523.568 581.393L525.008 585.065 525.008 593.195 523.568 589.524 523.568 581.393z"
              className={classes.cls18}
            />
            <path
              d="M414.826 630.987L416.265 634.658 416.265 638.609 414.826 634.938 414.826 630.987z"
              className={classes.cls18}
            />
            <path
              d="M414.826 634.938L416.265 638.609 390.451 638.659 389.012 634.987 414.826 634.938z"
              className={classes.cls19}
            />
            <path
              d="M523.568 622.64L525.008 626.311 523.056 626.315 521.617 622.643 523.568 622.64z"
              className={classes.cls19}
            />
            <path
              d="M537.987 622.612L539.426 626.283 525.008 626.311 523.568 622.64 537.987 622.612z"
              className={classes.cls19}
            />
            <path
              d="M537.987 589.496L539.426 593.167 539.426 626.283 537.987 622.612 537.987 589.496z"
              className={classes.cls18}
            />
            <path
              d="M521.617 630.783L523.056 634.454 416.265 634.658 414.826 630.987 521.617 630.783z"
              className={classes.cls19}
            />
            <path
              d="M521.617 622.643L523.056 626.315 523.056 634.454 521.617 630.783 521.617 622.643z"
              className={classes.cls18}
            />
            <path
              d="M428.202 558.348L428.202 565.013 451.061 564.969 451.061 581.532 523.568 581.393 523.568 589.524 537.987 589.496 537.987 622.612 523.568 622.64 521.617 622.643 521.617 630.783 414.826 630.987 414.826 634.938 389.012 634.987 389.012 631.036 362.022 631.087 362.022 622.948 331.642 623.006 331.642 581.76 376.1 581.675 376.1 565.112 385.611 565.094 385.611 558.429 428.202 558.348z"
              className={classes.cls17}
            />
            <path
              d="M359.159 523.533L359.159 544.813 346.787 544.837 346.787 523.557 359.159 523.533z"
              className={classes.cls17}
            />
            <path
              d="M359.159 523.533L360.599 527.204 360.599 548.485 359.159 544.813 359.159 523.533z"
              className={classes.cls18}
            />
            <path
              d="M359.159 544.813L360.599 548.485 348.227 548.508 346.787 544.837 359.159 544.813z"
              className={classes.cls19}
            />
            <path
              d="M214.147 988.122L214.147 1004.09 102.364 1004.303 102.364 988.336 214.147 988.122z"
              className={classes.cls17}
            />
            <path
              d="M214.147 988.122L215.587 991.794 215.587 1007.761 214.147 1004.09 214.147 988.122z"
              className={classes.cls18}
            />
            <path
              d="M214.147 1004.09L215.587 1007.761 103.803 1007.974 102.364 1004.303 214.147 1004.09z"
              className={classes.cls19}
            />
            <path
              d="M251.597 1007.504L253.037 1011.175 232.764 1011.214 231.325 1007.543 251.597 1007.504z"
              className={classes.cls19}
            />
            <path
              d="M324.058 974.089L325.497 977.76 325.497 984.264 324.058 980.593 324.058 974.089z"
              className={classes.cls18}
            />
            <path
              d="M401.472 980.446L402.912 984.117 402.912 992.105 401.472 988.434 401.472 980.446z"
              className={classes.cls18}
            />
            <path
              d="M308.976 1039.858L310.416 1043.53 253.037 1043.639 251.597 1039.968 308.976 1039.858z"
              className={classes.cls19}
            />
            <path
              d="M404.693 988.428L406.133 992.099 406.133 1010.883 404.693 1007.212 404.693 988.428z"
              className={classes.cls18}
            />
            <path
              d="M404.693 1007.212L406.133 1010.883 402.912 1010.889 401.472 1007.218 404.693 1007.212z"
              className={classes.cls19}
            />
            <path
              d="M320.96 1039.836L322.399 1043.507 322.399 1049.198 320.96 1045.527 320.96 1039.836z"
              className={classes.cls18}
            />
            <path
              d="M320.96 1045.527L322.399 1049.198 310.416 1049.221 308.976 1045.55 320.96 1045.527z"
              className={classes.cls19}
            />
            <path
              d="M401.472 1007.218L402.912 1010.889 402.912 1043.353 401.472 1039.682 401.472 1007.218z"
              className={classes.cls18}
            />
            <path
              d="M324.058 974.089L324.058 980.593 401.472 980.446 401.472 988.434 404.693 988.428 404.693 1007.212 401.472 1007.218 401.472 1039.682 320.96 1039.836 320.96 1045.527 308.976 1045.55 308.976 1039.858 251.597 1039.968 251.597 1007.504 231.325 1007.543 231.325 988.758 234.271 988.753 234.271 980.765 257.774 980.72 257.774 974.216 324.058 974.089z"
              className={classes.cls17}
            />
            <path
              d="M401.472 1039.682L402.912 1043.353 322.399 1043.507 320.96 1039.836 401.472 1039.682z"
              className={classes.cls19}
            />
            <path
              d="M721.791 722.024L721.791 730.598 686.674 730.665 686.674 722.091 721.791 722.024z"
              className={classes.cls17}
            />
            <path
              d="M721.791 722.024L723.23 725.695 723.23 734.269 721.791 730.598 721.791 722.024z"
              className={classes.cls18}
            />
            <path
              d="M721.791 730.598L723.23 734.269 688.113 734.336 686.674 730.665 721.791 730.598z"
              className={classes.cls19}
            />
            <path
              d="M457.992 454.187L457.992 470.107 446.823 470.128 446.823 454.208 457.992 454.187z"
              className={classes.cls17}
            />
            <path
              d="M457.992 454.187L459.432 457.858 459.432 473.778 457.992 470.107 457.992 454.187z"
              className={classes.cls18}
            />
            <path
              d="M457.992 470.107L459.432 473.778 448.263 473.799 446.823 470.128 457.992 470.107z"
              className={classes.cls19}
            />
            <path
              d="M698.118 282.124L698.118 289.791 664.441 289.856 664.441 282.189 698.118 282.124z"
              className={classes.cls17}
            />
            <path
              d="M698.118 282.124L699.558 285.796 699.558 293.463 698.118 289.791 698.118 282.124z"
              className={classes.cls18}
            />
            <path
              d="M698.118 289.791L699.558 293.463 665.881 293.527 664.441 289.856 698.118 289.791z"
              className={classes.cls19}
            />
            <path
              d="M702.308 218.712L702.308 227.447 673.405 227.502 673.405 218.767 702.308 218.712z"
              className={classes.cls17}
            />
            <path
              d="M702.308 218.712L703.747 222.383 703.747 231.119 702.308 227.447 702.308 218.712z"
              className={classes.cls18}
            />
            <path
              d="M702.308 227.447L703.747 231.119 674.845 231.174 673.405 227.502 702.308 227.447z"
              className={classes.cls19}
            />
            <path
              d="M695.693 159.419L695.693 164.58 663.948 164.641 663.948 159.479 695.693 159.419z"
              className={classes.cls17}
            />
            <path
              d="M695.693 159.419L697.132 163.09 697.132 168.252 695.693 164.58 695.693 159.419z"
              className={classes.cls18}
            />
            <path
              d="M695.693 164.58L697.132 168.252 665.388 168.312 663.948 164.641 695.693 164.58z"
              className={classes.cls19}
            />
            <path
              d="M986.808 154.199L986.808 160.722 955.3 160.782 955.3 154.259 986.808 154.199z"
              className={classes.cls17}
            />
            <path
              d="M986.808 154.199L988.247 157.87 988.247 164.393 986.808 160.722 986.808 154.199z"
              className={classes.cls18}
            />
            <path
              d="M986.808 160.722L988.247 164.393 956.739 164.453 955.3 160.782 986.808 160.722z"
              className={classes.cls19}
            />
            <path
              d="M852.309 180.673L852.309 198.483 841.519 198.504 841.519 180.693 852.309 180.673z"
              className={classes.cls17}
            />
            <path
              d="M852.309 180.673L853.748 184.344 853.748 202.154 852.309 198.483 852.309 180.673z"
              className={classes.cls18}
            />
            <path
              d="M852.309 198.483L853.748 202.154 842.958 202.175 841.519 198.504 852.309 198.483z"
              className={classes.cls19}
            />
            <path
              d="M951.79 728.295L951.79 737.201 914.106 737.272 914.106 728.367 951.79 728.295z"
              className={classes.cls17}
            />
            <path
              d="M951.79 728.295L953.23 731.966 953.23 740.872 951.79 737.201 951.79 728.295z"
              className={classes.cls18}
            />
            <path
              d="M951.79 737.201L953.23 740.872 915.545 740.944 914.106 737.272 951.79 737.201z"
              className={classes.cls19}
            />
            <path
              d="M877.568 647.312L877.568 655.792 835.81 655.872 835.81 647.392 877.568 647.312z"
              className={classes.cls17}
            />
            <path
              d="M877.568 647.312L879.007 650.983 879.007 659.463 877.568 655.792 877.568 647.312z"
              className={classes.cls18}
            />
            <path
              d="M877.568 655.792L879.007 659.463 837.25 659.543 835.81 655.872 877.568 655.792z"
              className={classes.cls19}
            />
            <path
              d="M804.309 669.115L804.309 706.987 791.577 707.011 791.577 669.14 804.309 669.115z"
              className={classes.cls17}
            />
            <path
              d="M804.309 669.115L805.748 672.787 805.748 710.658 804.309 706.987 804.309 669.115z"
              className={classes.cls18}
            />
            <path
              d="M804.309 706.987L805.748 710.658 793.016 710.682 791.577 707.011 804.309 706.987z"
              className={classes.cls19}
            />
            <path
              d="M872.214 494.676L872.214 503.6 834.928 503.671 834.928 494.747 872.214 494.676z"
              className={classes.cls17}
            />
            <path
              d="M872.214 494.676L873.654 498.347 873.654 507.271 872.214 503.6 872.214 494.676z"
              className={classes.cls18}
            />
            <path
              d="M872.214 503.6L873.654 507.271 836.367 507.342 834.928 503.671 872.214 503.6z"
              className={classes.cls19}
            />
            <path
              d="M1136.099 833.73L1137.538 837.401 1137.538 839.14 1136.099 835.469 1136.099 833.73z"
              className={classes.cls18}
            />
            <path
              d="M1088.07 859.384L1089.509 863.055 1089.509 867.669 1088.07 863.997 1088.07 859.384z"
              className={classes.cls18}
            />
            <path
              d="M1088.07 863.997L1089.509 867.669 1076.702 867.693 1075.262 864.022 1088.07 863.997z"
              className={classes.cls19}
            />
            <path
              d="M1138.543 835.465L1139.982 839.136 1139.982 851.917 1138.543 848.246 1138.543 835.465z"
              className={classes.cls18}
            />
            <path
              d="M1138.543 848.246L1139.982 851.917 1137.538 851.922 1136.099 848.251 1138.543 848.246z"
              className={classes.cls19}
            />
            <path
              d="M1136.099 848.251L1137.538 851.922 1137.538 862.964 1136.099 859.292 1136.099 848.251z"
              className={classes.cls18}
            />
            <path
              d="M1136.099 833.73L1136.099 835.469 1138.543 835.465 1138.543 848.246 1136.099 848.251 1136.099 859.292 1088.07 859.384 1088.07 863.997 1075.262 864.022 1075.262 859.408 1075.262 851.241 1075.262 833.846 1136.099 833.73z"
              className={classes.cls17}
            />
            <path
              d="M1136.099 859.292L1137.538 862.964 1089.509 863.055 1088.07 859.384 1136.099 859.292z"
              className={classes.cls19}
            />
            <path
              d="M1046.527 843.842L1068.552 874.836 1049.975 887.993 1027.96 856.999 1046.527 843.842z"
              className={classes.cls17}
            />
            <path
              d="M1068.552 874.836L1069.992 878.507 1051.415 891.664 1049.975 887.993 1068.552 874.836z"
              className={classes.cls19}
            />
            <path
              d="M1049.975 887.993L1051.415 891.664 1029.399 860.67 1027.96 856.999 1049.975 887.993z"
              className={classes.cls19}
            />
            <path
              d="M1075.287 884.223L1079.767 890.52 1066.344 900.028 1061.863 893.731 1075.287 884.223z"
              className={classes.cls17}
            />
            <path
              d="M1079.767 890.52L1081.207 894.191 1067.783 903.699 1066.344 900.028 1079.767 890.52z"
              className={classes.cls19}
            />
            <path
              d="M1066.344 900.028L1067.783 903.699 1063.303 897.402 1061.863 893.731 1066.344 900.028z"
              className={classes.cls19}
            />
            <path
              d="M1073.97 910.542L1085.414 918.49 1070.75 939.486 1059.315 931.538 1073.97 910.542z"
              className={classes.cls17}
            />
            <path
              d="M1085.414 918.49L1086.853 922.161 1072.189 943.157 1070.75 939.486 1085.414 918.49z"
              className={classes.cls28}
            />
            <path
              d="M1070.75 939.486L1072.189 943.157 1060.755 935.21 1059.315 931.538 1070.75 939.486z"
              className={classes.cls19}
            />
            <path
              d="M713.195 895.923L713.195 906.747 676.724 906.817 676.724 895.992 713.195 895.923z"
              className={classes.cls17}
            />
            <path
              d="M713.195 895.923L714.635 899.594 714.635 910.418 713.195 906.747 713.195 895.923z"
              className={classes.cls18}
            />
            <path
              d="M713.195 906.747L714.635 910.418 678.163 910.488 676.724 906.817 713.195 906.747z"
              className={classes.cls19}
            />
            <path
              d="M225.41 803.642L225.41 811.706 186.295 811.781 186.295 803.717 225.41 803.642z"
              className={classes.cls17}
            />
            <path
              d="M225.41 803.642L226.849 807.313 226.849 815.377 225.41 811.706 225.41 803.642z"
              className={classes.cls18}
            />
            <path
              d="M225.41 811.706L226.849 815.377 187.734 815.452 186.295 811.781 225.41 811.706z"
              className={classes.cls19}
            />
            <path
              d="M84.603 793.313L95.611 795.41 88.876 830.203 77.868 828.106 84.603 793.313z"
              className={classes.cls17}
            />
            <path
              d="M95.611 795.41L97.05 799.081 90.315 833.874 88.876 830.203 95.611 795.41z"
              className={classes.cls29}
            />
            <path
              d="M88.876 830.203L90.315 833.874 79.307 831.777 77.868 828.106 88.876 830.203z"
              className={classes.cls19}
            />
            <path
              d="M101.718 711.378L112.735 713.484 106 748.276 94.983 746.18 101.718 711.378z"
              className={classes.cls17}
            />
            <path
              d="M112.735 713.484L114.175 717.155 107.439 751.948 106 748.276 112.735 713.484z"
              className={classes.cls29}
            />
            <path
              d="M106 748.276L107.439 751.948 96.422 749.851 94.983 746.18 106 748.276z"
              className={classes.cls19}
            />
            <path
              d="M176.577 644.189L176.577 651.979 139.934 652.049 139.934 644.259 176.577 644.189z"
              className={classes.cls17}
            />
            <path
              d="M176.577 644.189L178.016 647.86 178.016 655.65 176.577 651.979 176.577 644.189z"
              className={classes.cls18}
            />
            <path
              d="M176.577 651.979L178.016 655.65 141.374 655.72 139.934 652.049 176.577 651.979z"
              className={classes.cls19}
            />
            <path
              d="M173.945 551.856L180.841 559.33 150.707 587.068 143.801 579.594 173.945 551.856z"
              className={classes.cls17}
            />
            <path
              d="M180.841 559.33L182.28 563.002 152.146 590.739 150.707 587.068 180.841 559.33z"
              className={classes.cls30}
            />
            <path
              d="M150.707 587.068L152.146 590.739 145.24 583.265 143.801 579.594 150.707 587.068z"
              className={classes.cls19}
            />
            <path
              d="M1749.025 677.665L1753.317 694.692 1696.269 709.114 1691.978 692.077 1749.025 677.665z"
              className={classes.cls17}
            />
            <path
              d="M1749.025 677.665L1750.465 681.336 1754.756 698.363 1753.317 694.692 1749.025 677.665z"
              className={classes.cls31}
            />
            <path
              d="M1753.317 694.692L1754.756 698.363 1697.709 712.785 1696.269 709.114 1753.317 694.692z"
              className={classes.cls19}
            />
            <path
              d="M709.205 66.409H769.063V100.754H709.205z"
              className={classes.cls1}
            />
            <path
              d="M769.064 66.38L771.883 70.051 771.883 104.396 769.064 100.725 769.064 66.38z"
              className={classes.cls18}
            />
            <path
              d="M769.064 100.725L771.883 104.396 712.025 104.454 709.205 100.783 769.064 100.725z"
              className={classes.cls19}
            />
            <path
              d="M423.414 618.515a4.39 4.39 0 01-4.632 3.598c-3.068 0-4.852-2.315-4.852-5.56 0-3.304 1.961-5.517 4.97-5.517a4.344 4.344 0 014.455 3.599h-1.46a2.945 2.945 0 00-3.068-2.33c-1.888 0-3.363 1.474-3.363 4.248 0 2.713 1.416 4.292 3.407 4.292a2.935 2.935 0 003.083-2.33zM427.7 611.228h1.74l4.027 10.693h-1.623l-.84-2.315h-4.912l-.826 2.315h-1.534zm-1.15 7.094h3.982l-2.006-5.575zM434.73 611.228h6.947v1.298h-5.443v3.245h5.133v1.298h-5.133v4.852h-1.504zM442.985 611.228h7.257v1.298h-5.752v3.245h5.413v1.298h-5.413v3.555h5.752v1.297h-7.256zM450.753 621.921l4.204-10.693h1.357l-4.218 10.693zM461.783 617.408c-.28.015-.531.015-.812.015h-1.888v4.498h-1.504v-10.693h3.393c2.595 0 4.454.516 4.454 3.083a2.624 2.624 0 01-2.124 2.86l2.478 4.75h-1.681zm-2.7-4.912v3.659h2.007c1.578 0 2.788-.163 2.788-1.815s-1.21-1.844-2.788-1.844zM467.589 611.228h7.256v1.298h-5.752v3.245h5.413v1.298h-5.413v3.555h5.752v1.297h-7.256zM485.593 618.515a4.39 4.39 0 01-4.632 3.598c-3.067 0-4.852-2.315-4.852-5.56 0-3.304 1.962-5.517 4.97-5.517a4.344 4.344 0 014.455 3.599h-1.46a2.945 2.945 0 00-3.068-2.33c-1.888 0-3.363 1.474-3.363 4.248 0 2.713 1.416 4.292 3.407 4.292a2.935 2.935 0 003.083-2.33zM499.45 611.228v10.693h-1.504v-4.852h-5.62v4.852h-1.505v-10.693h1.505v4.543h5.62v-4.543zM504.68 611.228h1.74l4.026 10.693h-1.623l-.84-2.315h-4.912l-.825 2.315h-1.535zm-1.151 7.094h3.982l-2.006-5.575zM513.214 620.624h5.65v1.297h-7.155v-10.693h1.505zM521.631 620.624h5.65v1.297h-7.154v-10.693h1.504z"
              className={classes.cls32}
              transform="translate(-42.377 -11.012)"
            />
            <path
              d="M1316.878 774.107h-1.46a2.849 2.849 0 00-3.039-2.035c-1.888 0-3.362 1.475-3.362 4.248 0 2.714 1.401 4.292 3.362 4.292 1.416 0 3.157-.59 3.157-2.802v-.28h-2.832v-1.298h4.248v5.457h-1.18l-.074-1.342a3.736 3.736 0 01-3.378 1.533c-3.067 0-4.838-2.315-4.838-5.56 0-3.304 1.962-5.517 4.971-5.517a4.253 4.253 0 014.425 3.304zM1322.196 770.995h1.74l4.028 10.694h-1.623l-.841-2.316h-4.911l-.827 2.316h-1.533zm-1.15 7.095h3.982l-2.006-5.576zM1332.574 770.995c2.611 0 4.44.59 4.44 3.23 0 2.655-1.829 3.23-4.44 3.23h-1.843v4.234h-1.505v-10.693zm-1.843 1.268v3.88h1.962c1.577 0 2.787-.162 2.787-1.917 0-1.741-1.21-1.962-2.787-1.962zM1277.531 946.253l-.325 1.709-11.259 1.956.304-1.594 2.433-.393.919-4.825-2.121-1.245.286-1.506zm-6.753-2.458l-.745 3.913 5.852-.928zM1275.67 956.027c-.631 3.318-2.35 5.484-6.334 4.725-4-.762-4.802-3.407-4.171-6.725l.547-2.87 10.505 2zm-1.236-.28l.256-1.348-8.012-1.526-.256 1.348c-.412 2.159-.378 4.343 3.2 5.023 3.565.68 4.4-1.338 4.812-3.498zM1262.866 966.105l9.709-1.155-9.158-1.744.282-1.477 10.505 2-.472 2.478-9.261 1.015 8.24 4.346-.471 2.479-10.505-2.001.281-1.48 9.157 1.745-8.605-4.642zM1260.98 976.009l.282-1.478 10.505 2-.282 1.478zM1270.56 983.897c-.363 1.898-1.535 3.401-3.628 3.437l.273-1.434a2.568 2.568 0 002.118-2.298c.155-.813.064-2.3-1.11-2.525-.928-.176-1.53.46-1.933 1.404l-.508 1.165c-.653 1.541-1.63 3.353-3.744 2.95-2.044-.389-2.78-2.511-2.383-4.598.472-2.478 2.132-3.783 4.27-3.661l-.276 1.45a2.647 2.647 0 00-2.754 2.478c-.298 1.564.258 2.586 1.302 2.784 1.115.213 1.73-.645 2.285-1.906l.524-1.253c.594-1.387 1.678-2.668 3.418-2.337 2.012.384 2.468 2.648 2.145 4.344zM1268.764 993.324c-.362 1.898-1.534 3.402-3.627 3.438l.274-1.435a2.57 2.57 0 002.118-2.3c.154-.81.064-2.3-1.11-2.523-.928-.177-1.53.46-1.935 1.404l-.507 1.165c-.654 1.541-1.63 3.352-3.745 2.95-2.043-.389-2.78-2.511-2.381-4.598.472-2.478 2.13-3.784 4.268-3.661l-.276 1.449a2.649 2.649 0 00-2.753 2.478c-.298 1.565.258 2.586 1.302 2.785 1.114.212 1.73-.646 2.284-1.907l.525-1.252c.593-1.387 1.678-2.667 3.418-2.336 2.012.384 2.468 2.647 2.145 4.343zM1256.662 998.685l.28-1.477 10.506 2-.281 1.478zM1255.16 1005.56c.574-3.014 3.211-4.494 6.385-3.89s5.068 2.948 4.494 5.962-3.198 4.496-6.371 3.891-5.083-2.95-4.508-5.963zm1.244.237c-.364 1.912.842 3.703 3.55 4.22s4.475-.71 4.839-2.623c.367-1.927-.826-3.7-3.535-4.217s-4.487.692-4.854 2.62zM1252.834 1018.788l9.886-3.103-8.97-1.708.281-1.477 10.505 2-.414 2.173-9.853 3.094 8.94 1.702-.28 1.479-10.506-2.001zM1262.003 1028.83c-.362 1.899-1.534 3.402-3.627 3.44l.274-1.435a2.572 2.572 0 002.118-2.3c.154-.81.064-2.3-1.11-2.524-.928-.176-1.53.46-1.935 1.405l-.507 1.164c-.654 1.542-1.63 3.353-3.745 2.95-2.043-.389-2.78-2.511-2.381-4.598.47-2.477 2.13-3.783 4.268-3.66l-.276 1.449a2.647 2.647 0 00-2.753 2.478c-.297 1.565.258 2.586 1.302 2.785 1.114.212 1.73-.646 2.285-1.907l.524-1.252c.593-1.388 1.678-2.668 3.418-2.337 2.012.384 2.468 2.648 2.145 4.343zM1630.16 731.297l-2.696-2.202.82-1.005 6.557 5.359-.822 1.003-2.695-2.202-5.945 7.275-1.164-.951zM1636.859 735.097l-4.116 5.036c-1.334 1.634-1.37 2.863.184 4.132 1.588 1.298 2.889.895 4.224-.738l4.013-4.911 1.165.95-3.938 4.822c-1.98 2.42-3.875 2.851-6.285.882-2.295-1.876-2.535-3.634-.426-6.214l4.013-4.911zM1642.354 753.397l1.984-10.168-5.777 7.07-1.164-.953 6.766-8.28 1.714 1.4-1.979 10.136 5.758-7.046 1.165.952-6.767 8.28zM1650.972 760.44l1.985-10.169-5.778 7.07-1.165-.95 6.767-8.28 1.713 1.399-1.979 10.136 5.759-7.046 1.166.95-6.767 8.28zM1661.399 755.152l5.62 4.592-.822 1.005-4.454-3.64-2.054 2.513 4.192 3.425-.821 1.006-4.192-3.427-2.25 2.753 4.455 3.64-.82 1.005-5.62-4.593zM1663.616 769.097l4.375 3.576-.822 1.004-5.54-4.526 6.767-8.28 1.164.952zM1670.116 925.802h-3.48v-1.297h8.466v1.297h-3.481v9.396h-1.505zM1680.569 930.685c-.28.014-.532.014-.811.014h-1.888v4.499h-1.504v-10.693h3.392c2.595 0 4.454.516 4.454 3.082a2.624 2.624 0 01-2.124 2.861l2.478 4.75h-1.681zm-2.7-4.912v3.658h2.007c1.577 0 2.788-.162 2.788-1.815s-1.21-1.843-2.788-1.843zM1689.221 924.505h1.74l4.028 10.693h-1.623l-.841-2.316h-4.911l-.826 2.316h-1.534zm-1.15 7.094h3.982l-2.006-5.576zM1704.836 931.791a4.39 4.39 0 01-4.632 3.598c-3.067 0-4.852-2.315-4.852-5.56 0-3.304 1.962-5.517 4.97-5.517a4.344 4.344 0 014.455 3.6h-1.46a2.945 2.945 0 00-3.068-2.33c-1.888 0-3.363 1.474-3.363 4.247 0 2.714 1.416 4.292 3.407 4.292a2.934 2.934 0 003.083-2.33zM1708.075 929.888l4.823-5.383h1.873l-3.997 4.366 4.454 6.327h-1.799l-3.672-5.222-1.682 1.86v3.362h-1.505v-10.693h1.504zM1700.623 580.166c1.675.962 2.71 2.563 2.06 4.553l-1.267-.728a2.57 2.57 0 00-1.477-2.755c-.717-.412-2.152-.813-2.749.221-.47.819-.067 1.596.693 2.287l.934.862c1.243 1.123 2.635 2.638 1.56 4.506-1.036 1.801-3.282 1.801-5.124.742-2.186-1.257-2.875-3.252-2.06-5.233l1.278.735a2.648 2.648 0 001.44 3.414c1.38.795 2.528.604 3.059-.316.565-.984-.045-1.847-1.053-2.785l-1.011-.904c-1.118-1.017-1.971-2.46-1.09-3.995 1.023-1.777 3.312-1.465 4.807-.604zM1705.752 583.337l6.289 3.618-.646 1.125-4.987-2.867-1.618 2.813 4.692 2.698-.646 1.125-4.693-2.698-1.772 3.08 4.986 2.869-.647 1.124-6.29-3.618zM1714.147 595.296c-.25-.128-.467-.253-.71-.392l-1.636-.942-2.244 3.9-1.304-.75 5.332-9.27 2.94 1.692c2.25 1.295 3.605 2.668 2.326 4.894a2.625 2.625 0 01-3.268 1.42l-.221 5.352-1.457-.838zm.109-5.604l-1.825 3.171 1.74 1c1.368.787 2.497 1.25 3.322-.183.823-1.431-.13-2.202-1.497-2.988zM1722.376 592.9l-1.99 9.405 7.079-6.478 1.367.787-8.477 7.46-1.559-.897 2.147-11.1zM1726.028 607.336l-1.304-.75 5.331-9.27 1.304.751zM1737.697 610.118a4.388 4.388 0 01-5.808.81c-2.66-1.53-3.052-4.426-1.435-7.24 1.648-2.864 4.452-3.803 7.06-2.303a4.344 4.344 0 012.066 5.341l-1.265-.728a2.946 2.946 0 00-1.499-3.55c-1.636-.942-3.649-.399-5.032 2.005-1.353 2.353-.913 4.427.812 5.42a2.935 2.935 0 003.836-.484zM1742.834 604.668l6.29 3.617-.647 1.125-4.986-2.868-1.618 2.814 4.692 2.699-.646 1.125-4.693-2.7-1.773 3.081 4.987 2.868-.648 1.125-6.29-3.617zM1756.035 612.26l1.509.868-1.842 11.277-1.407-.809.427-2.426-4.258-2.45-1.87 1.596-1.33-.765zm-4.535 5.576l3.453 1.986 1.04-5.834zM1762.691 623.22c-.25-.128-.468-.253-.71-.393l-1.637-.942-2.243 3.9-1.303-.75 5.331-9.27 2.941 1.692c2.25 1.294 3.603 2.669 2.324 4.894a2.625 2.625 0 01-3.268 1.42l-.22 5.352-1.458-.838zm.11-5.605l-1.824 3.171 1.739 1c1.368.787 2.498 1.25 3.321-.183s-.13-2.201-1.497-2.988zM1770.805 620.756l6.29 3.619-.646 1.125-4.987-2.868-1.617 2.813 4.691 2.7-.647 1.125-4.692-2.7-1.773 3.081 4.987 2.868-.647 1.125-6.291-3.619zM1780.978 626.608l1.509.868-1.84 11.276-1.408-.809.426-2.426-4.257-2.449-1.871 1.596-1.33-.765zm-4.533 5.576l3.45 1.985 1.041-5.833z"
              className={classes.cls33}
              transform="translate(-42.377 -11.012)"
            />
            <path
              d="M1457.363 383.279l-2.33 10.436-1.468-.328 1.058-4.735-5.485-1.224-1.057 4.735-1.468-.328 2.33-10.436 1.468.328-.99 4.434 5.484 1.224.99-4.434zM1461.853 395.433c-2.994-.668-4.39-3.351-3.686-6.505.703-3.152 3.105-4.973 6.1-4.304s4.392 3.337 3.688 6.49c-.703 3.153-3.109 4.987-6.102 4.319zm.277-1.238c1.9.425 3.727-.724 4.328-3.416s-.568-4.494-2.468-4.917c-1.916-.428-3.726.71-4.326 3.4s.55 4.506 2.466 4.933zM1474.394 386.884c1.886.421 3.351 1.64 3.322 3.734l-1.425-.32a2.57 2.57 0 00-2.231-2.188c-.806-.18-2.297-.136-2.558 1.03-.205.921.412 1.542 1.342 1.976l1.149.545c1.52.701 3.3 1.734 2.83 3.835-.453 2.03-2.597 2.7-4.67 2.237-2.46-.55-3.713-2.25-3.524-4.384l1.44.322a2.648 2.648 0 002.39 2.83c1.555.347 2.594-.176 2.826-1.212.246-1.109-.592-1.75-1.835-2.344l-1.235-.564c-1.369-.637-2.614-1.76-2.228-3.49.445-1.999 2.723-2.382 4.407-2.007zM1483.503 389.114c2.548.569 4.204 1.544 3.628 4.12-.578 2.591-2.488 2.753-5.036 2.184l-1.8-.402-.923 4.132-1.468-.328 2.33-10.435zm-2.077.836l-.845 3.786 1.915.428c1.54.344 2.757.45 3.14-1.264.379-1.7-.754-2.179-2.295-2.522zM1488.524 401.192l-1.469-.329 2.33-10.436 1.469.328zM1495.203 393.057l-3.397-.76.284-1.266 8.262 1.845-.283 1.267-3.397-.76-2.047 9.17-1.469-.327zM1503.184 393.508l1.698.379 1.6 11.314-1.583-.354-.315-2.443-4.794-1.07-1.311 2.08-1.498-.334zm-2.668 6.673l3.886.868-.743-5.878zM1509.466 404.538l5.514 1.23-.283 1.266-6.982-1.559 2.33-10.436 1.468.328z"
              className={classes.cls32}
              transform="translate(-42.377 -11.012)"
            />
            <path
              d="M1806.352 489.192l2.798-6.695 1.197.5-2.218 5.308 2.995 1.25 2.087-4.994 1.197.5-2.088 4.995 3.28 1.37 2.218-5.308 1.198.501-2.797 6.696zM1822.172 479.07l-10.314.999 8.426 3.52-.58 1.387-9.868-4.122.854-2.042 10.278-.996-8.397-3.509.58-1.388 9.868 4.123zM1816.178 469.044l-1.342 3.211-1.197-.5 3.264-7.812 1.196.5-1.341 3.213 8.67 3.622-.58 1.388zM1824.713 461.281c-.095.264-.192.496-.3.755l-.728 1.742 4.151 1.734-.58 1.388-9.866-4.123 1.308-3.13c1-2.395 2.193-3.91 4.561-2.921a2.624 2.624 0 011.82 3.063l5.34-.455-.65 1.55zm-5.574.597l3.376 1.41.773-1.85c.609-1.457.925-2.635-.6-3.273s-2.167.406-2.776 1.862zM1822.346 450.915l.67-1.605 11.42.406-.626 1.498-2.46-.117-1.894 4.532 1.819 1.654-.592 1.416zm6.102 3.797l1.535-3.675-5.917-.298zM1837.391 442.645l-10.312.999 8.424 3.52-.58 1.387-9.866-4.123.852-2.04 10.28-.997-8.397-3.509.58-1.388 9.867 4.123zM1839.528 428.694a4.39 4.39 0 011.533 5.66c-1.182 2.832-4.006 3.586-7 2.335-3.048-1.275-4.334-3.937-3.174-6.714a4.343 4.343 0 015.038-2.722l-.564 1.348a2.944 2.944 0 00-3.331 1.932c-.728 1.742.065 3.671 2.623 4.74 2.503 1.046 4.506.348 5.274-1.488a2.936 2.936 0 00-.961-3.743zM1833.475 424.284l2.797-6.695 1.196.5-2.217 5.308 2.995 1.251 2.086-4.995 1.197.5-2.086 4.995 3.28 1.37 2.217-5.307 1.198.5-2.798 6.696zM1844.599 405.73l-.563 1.347a2.849 2.849 0 00-3.049 2.02c-.728 1.742.064 3.67 2.622 4.74 2.504 1.046 4.502.362 5.258-1.448.546-1.307.671-3.14-1.37-3.992l-.26-.108-1.09 2.612-1.197-.501 1.637-3.919 5.036 2.104-.455 1.089-1.267-.45a3.738 3.738 0 01.112 3.707c-1.182 2.83-4 3.572-6.995 2.32-3.048-1.273-4.334-3.936-3.175-6.713a4.255 4.255 0 014.755-2.808zM1843.778 399.624l.671-1.606 11.42.407-.627 1.497-2.46-.117-1.894 4.531 1.819 1.655-.592 1.416zm6.102 3.796l1.535-3.674-5.918-.299zM1848.13 392.575l-1.342 3.212-1.197-.5 3.264-7.812 1.197.5-1.342 3.212 8.67 3.622-.58 1.389zM1849.342 386.31l2.798-6.696 1.197.5-2.218 5.308 2.994 1.251 2.087-4.995 1.197.5-2.087 4.995 3.28 1.37 2.218-5.307 1.197.5-2.797 6.696zM1866.507 372.964l-10.312.998 8.424 3.52-.58 1.388-9.866-4.123.852-2.041 10.28-.997-8.397-3.508.58-1.388 9.867 4.123zM1870.24 364.524c-1.183 2.83-4.069 3.735-7.05 2.49s-4.353-3.93-3.17-6.76 4.057-3.74 7.037-2.495c2.981 1.245 4.365 3.934 3.183 6.765zm-1.17-.49c.751-1.796-.06-3.797-2.605-4.86s-4.523-.228-5.274 1.568c-.756 1.811.046 3.793 2.59 4.856s4.534.248 5.29-1.563zM1872.342 358.998l-1.565-.654.654-1.565 1.565.654zM1864.908 349.055l2.855-6.832 1.156.483a12.775 12.775 0 006.964 7.817l-.625 1.498a13.259 13.259 0 01-6.942-7.872l-2.252 5.389z"
              className={classes.cls33}
              transform="translate(-42.377 -11.012)"
            />
            <path
              d="M1678.079 793.83l-9.892-7.863.656-.825 9.891 7.863zm8.476-9.814l-.825-.656 7.863-9.891.825.656zm-28.258-5.913l-9.89-7.863.655-.825 9.891 7.864zm29.662-12.233l-9.89-7.863.655-.825 9.891 7.863zm-49.444-3.493l-9.891-7.864.656-.824 9.891 7.863zm29.663-12.234l-9.891-7.863.656-.825 9.891 7.863zm-49.444-3.492l-9.891-7.863.656-.825 9.89 7.863zm29.662-12.235l-9.89-7.863.656-.825 9.89 7.864zm-44.675-4.037l-.825-.656 7.864-9.89.824.657zm24.894-11.69l-9.891-7.863.656-.825 9.89 7.864zM1469.729 991.446l-3.525-12.68 1.013-.282 3.244 11.667 8.719-2.424.281 1.014zm21.906-6.09l-.282-1.013 12.174-3.383.282 1.014zm14.273-12.46l-3.384-12.173 1.014-.282 3.384 12.174zm-43.088-6.305l-3.385-12.174 1.014-.281 3.384 12.174zm36.32-18.042l-3.385-12.175 1.014-.282 3.384 12.175zm-43.089-6.306l-3.384-12.175 1.014-.281 3.384 12.175zm36.32-18.043l-3.384-12.174 1.014-.282 3.384 12.174zm-43.088-6.305l-3.384-12.174 1.013-.282 3.385 12.174zm36.32-18.043l-3.384-12.174 1.013-.281 3.385 12.173zm-43.089-6.305l-3.384-12.174 1.014-.282 3.384 12.174zm36.32-18.043l-3.384-12.174 1.014-.281 3.384 12.174zm-43.088-6.305l-3.384-12.174 1.014-.282 3.384 12.174zm36.32-18.042l-3.384-12.174 1.014-.282 3.384 12.174zm-43.089-6.306l-.909-3.27 9.917-2.758.282 1.014-8.903 2.475.627 2.257zm21.464-8.398l-.282-1.014 12.174-3.384.282 1.014z"
              className={classes.cls34}
              transform="translate(-42.377 -11.012)"
            />
            <path
              d="M1439.03 884.163H1494.652V904.32H1439.03z"
              className={classes.cls4}
              transform="rotate(74.465 1452.898 860.855)"
            />
            <path
              d="M1463.158 866.227l-10.302 2.865-.403-1.449 4.675-1.3-1.505-5.414-4.675 1.3-.403-1.45 10.301-2.865.403 1.45-4.376 1.216 1.505 5.415 4.377-1.217zM1454.555 875.916c-.823-2.955.887-5.452 4-6.318s5.85.394 6.673 3.35-.875 5.448-3.987 6.314-5.864-.39-6.686-3.346zm1.222-.34c.521 1.876 2.397 2.947 5.054 2.207s3.696-2.62 3.174-4.495c-.526-1.89-2.382-2.95-5.04-2.211s-3.715 2.609-3.188 4.5zM1462.098 885.477a15.653 15.653 0 01-.232-.777l-.506-1.82-4.334 1.206-.403-1.45 10.301-2.865.91 3.268c.696 2.502.697 4.43-1.776 5.118a2.623 2.623 0 01-3.325-1.28l-3.912 3.66-.45-1.62zm4.008-3.917l-3.524.98.538 1.933c.422 1.52.904 2.643 2.495 2.2 1.59-.442 1.451-1.66 1.029-3.18zM1470.71 892.66c.518 1.862.133 3.73-1.728 4.69l-.39-1.407a2.57 2.57 0 00.88-3c-.221-.797-.964-2.09-2.115-1.77-.91.253-1.166 1.09-1.111 2.116l.06 1.268c.1 1.672.027 3.728-2.046 4.306-2.003.557-3.606-1.018-4.174-3.064-.677-2.431.232-4.338 2.203-5.177l.396 1.421a2.649 2.649 0 00-1.37 3.444c.426 1.534 1.378 2.204 2.401 1.919 1.095-.305 1.264-1.346 1.203-2.723l-.086-1.354c-.082-1.508.322-3.136 2.027-3.61 1.974-.548 3.388 1.278 3.85 2.941zM1472.139 898.519l1.944 6.99-1.249.348-1.541-5.542-3.127.87 1.45 5.215-1.25.348-1.45-5.215-3.426.952 1.542 5.542-1.25.348-1.944-6.992zM1474.84 913.07l-.933-3.354 1.25-.348 2.268 8.157-1.25.347-.932-3.353-9.052 2.517-.403-1.449zM1478.124 920.036l-6.266 1.742c-2.033.565-2.769 1.551-2.231 3.483.549 1.976 1.845 2.396 3.876 1.83l6.11-1.698.403 1.449-5.995 1.668c-3.013.838-4.81.097-5.645-2.901-.795-2.857.023-4.43 3.234-5.324l6.11-1.7zM1472.065 938.156l7.484-7.164-8.796 2.446-.403-1.448 10.301-2.866.593 2.131-7.459 7.143 8.767-2.44.404 1.45-10.302 2.866zM1475.048 948.88l7.483-7.166-8.796 2.447-.403-1.45 10.301-2.865.593 2.132-7.459 7.143 8.767-2.44.404 1.45-10.3 2.865zM1486.616 950.57l1.945 6.991-1.25.348-1.541-5.541-3.127.868 1.45 5.216-1.25.347-1.45-5.215-3.425.953 1.541 5.542-1.25.347-1.944-6.991zM1480.389 963.242l1.514 5.443-1.25.348-1.917-6.892 10.302-2.866.403 1.45z"
              className={classes.cls33}
              transform="translate(-42.377 -11.012)"
            />
            <path
              d="M19.665 26.525H462.105V116.19300000000001H19.665z"
              className={classes.cls7}
            />
            <path
              d="M502.199 124.68H64.373V39.772h437.802v84.908zm-437.461-.364H501.81V40.16H64.738z"
              className={classes.cls35}
              transform="translate(-42.377 -11.012)"
            />
            <path
              d="M105.589 46.548l8.84 8.014-45.708 63.754zm22.198-2.453L68.77 120.332l71.234-60.475zm33.395 43.11a.809.809 0 00-.218-.267 3.504 3.504 0 01-.267-3.28 3.309 3.309 0 011.19-1.457 1.214 1.214 0 01.412-.267 3.22 3.22 0 011.725-.461 3.323 3.323 0 012.501 1.141l.05.097.145.146 7.237 8.33h5.15V64.18a2.547 2.547 0 011.82-2.332 2.777 2.777 0 012.235.316 16.553 16.553 0 00-3.837-2.331 45.41 45.41 0 00-4.469-1.968 34.284 34.284 0 00-14.354-1.967c-.777.049-1.603.097-2.38.219a31.812 31.812 0 00-11.026 4.639 30.35 30.35 0 01-1.19.777c-.146.097-.316.218-.462.315l-.364.316-73.809 58.168 56.42-19.09 59.236 19.041zM230.887 68.916c0 6.946-6.46 10.638-13.528 10.638-8.38 0-13.674-4.566-14.597-11.658h4.906c.923 4.906 4.348 7.456 9.788 7.456 5.246 0 8.282-2.501 8.282-5.974 0-3.716-3.182-5.295-7.65-6.266l-4.396-.923c-4.858-1.069-9.74-3.765-9.74-9.691 0-6.752 7.092-9.69 12.824-9.69 6.363 0 12.095 2.842 13.48 9.69h-4.858c-1.214-4.104-5.246-5.488-8.816-5.488-2.745 0-7.553 1.214-7.553 5.197 0 3.133 2.501 4.712 5.78 5.44l4.104.923c5.465 1.166 11.974 3.23 11.974 10.346zM250.34 43.44l13.382 35.508h-5.392l-2.793-7.7h-16.32l-2.745 7.7h-5.1l13.163-35.508zm3.618 23.559l-6.654-18.507-6.558 18.507zm36.31 6.654L274.045 43.44h-7.335v35.508h5.003V48.612l16.273 30.31h7.286V43.44h-5.003zM326.36 43.44h-28.125v4.299h11.56v31.209h5.004v-31.21h11.561V43.44zm14.208 0l13.382 35.508h-5.416l-2.793-7.7H329.42l-2.744 7.7h-5.1l13.163-35.508zm3.619 23.558l-6.655-18.506-6.557 18.507zM382.05 43.44l13.382 35.508h-5.391l-2.794-7.7h-16.32l-2.745 7.7h-5.1l13.164-35.508zm3.619 23.558l-6.655-18.506-6.557 18.507zm36.31 6.655L405.754 43.44h-7.335v35.508h5.003V48.612l16.273 30.31h7.286V43.44h-5.003zm12.191 5.295h5.004V43.439h-5.004zm36.091-35.508h-28.124v4.299h11.56v31.209h5.004v-31.21h11.56V43.44zm14.208 0l13.382 35.508h-5.391l-2.793-7.7h-16.321l-2.744 7.7h-5.1l13.163-35.508zm3.619 23.559l-6.655-18.507-6.557 18.507zM213.886 84.266h-11.124v35.508h5.003V105.71h6.12c8.67 0 14.743-1.918 14.743-10.71 0-8.768-6.072-10.735-14.742-10.735zm.388 17.074h-6.509V88.467h6.51c5.197 0 9.253.729 9.253 6.51 0 5.828-4.056 6.363-9.254 6.363zm29.485-17.074h-5.805l-13.163 35.508h5.1l2.744-7.7h16.321l2.793 7.7h5.392zm-9.594 23.558l6.558-18.507 6.655 18.507zm44.956-3.837c4.372-1.166 7.068-3.862 7.068-9.496 0-8.5-6.12-10.225-14.791-10.225h-11.27v35.483h4.98v-14.936h6.265c.923 0 1.822 0 2.696-.049l7.7 14.985h5.585zm-7.335-3.376h-6.655V88.467h6.655c5.198 0 9.254.632 9.254 6.12s-4.08 6.024-9.254 6.024zm34.318-1.87l13.285-14.5h-6.217l-16.006 17.876V84.266h-5.003v35.508h5.003v-11.172l5.586-6.17 12.193 17.342h5.974z"
              className={classes.cls35}
              transform="translate(-42.377 -11.012)"
            />
            <path
              d="M74.945 135.183c0 2.477-2.581 4.66-5.575 6.829h5.87v1.253h-7.7v-1.21c3.777-2.787 5.99-4.793 5.99-6.695a1.787 1.787 0 00-2.007-1.86 2.188 2.188 0 00-2.3 2.405h-1.388c-.044-2.124 1.431-3.525 3.718-3.525 1.976 0 3.392.988 3.392 2.803zM80.663 143.457c-2.847 0-4.16-2.168-4.16-5.546s1.313-5.531 4.16-5.531 4.16 2.154 4.16 5.53-1.313 5.547-4.16 5.547zm0-9.956c-1.711 0-2.729 1.416-2.729 4.41 0 3.008 1.018 4.424 2.729 4.424s2.728-1.416 2.728-4.424c0-2.994-1.032-4.41-2.728-4.41zM93.386 135.183c0 2.477-2.581 4.66-5.575 6.829h5.87v1.253h-7.699v-1.21c3.776-2.787 5.988-4.793 5.988-6.695a1.787 1.787 0 00-2.006-1.86 2.188 2.188 0 00-2.3 2.405h-1.387c-.044-2.124 1.43-3.525 3.717-3.525 1.977 0 3.392.988 3.392 2.803zM99.104 143.457c-2.847 0-4.16-2.168-4.16-5.546s1.313-5.531 4.16-5.531 4.16 2.154 4.16 5.53-1.313 5.547-4.16 5.547zm0-9.956c-1.71 0-2.728 1.416-2.728 4.41 0 3.008 1.017 4.424 2.728 4.424s2.729-1.416 2.729-4.424c0-2.994-1.033-4.41-2.729-4.41zM112.165 132.38c1.932 0 3.628.871 4.056 2.92h-1.46a2.571 2.571 0 00-2.655-1.651c-.826 0-2.271.368-2.271 1.563 0 .943.737 1.415 1.74 1.637l1.239.28c1.637.354 3.599.974 3.599 3.127 0 2.08-1.947 3.2-4.071 3.2-2.523 0-4.116-1.386-4.396-3.51h1.475a2.647 2.647 0 002.95 2.242c1.593 0 2.493-.737 2.493-1.8 0-1.135-.958-1.578-2.3-1.887l-1.328-.281c-1.475-.324-2.936-1.15-2.936-2.92 0-2.05 2.14-2.92 3.865-2.92zM120.257 133.87h-3.481v-1.298h8.466v1.298h-3.48v9.396h-1.505zM128.144 132.572h1.74l4.026 10.693h-1.622l-.84-2.315h-4.913l-.825 2.315h-1.534zm-1.151 7.094h3.983l-2.007-5.575zM135.173 132.572h3.85c1.991 0 3.761.516 3.761 2.64a2.646 2.646 0 01-1.18 2.36 2.512 2.512 0 011.623 2.537c0 2.271-1.711 3.157-3.835 3.157h-4.219zm1.505 4.572h2.582c1.238 0 2.006-.472 2.006-1.726 0-1.106-.812-1.578-2.006-1.578h-2.582zm0 4.852h2.728c1.535 0 2.272-.649 2.272-1.872 0-1.254-.722-1.785-2.36-1.785h-2.64zM146.584 141.968h5.65v1.297h-7.154v-10.693h1.504zM153.498 132.572h7.256v1.298h-5.752v3.245h5.413v1.298h-5.413v3.555h5.752v1.297h-7.256zM170.482 143.265l-2.95-9.321v9.321h-1.504v-10.693h2.522l2.728 8.908 2.73-8.908h2.522v10.693h-1.505v-9.321l-2.95 9.321zM181.759 132.572h1.74l4.026 10.693h-1.622l-.84-2.315h-4.912l-.826 2.315h-1.534zm-1.151 7.094h3.982l-2.006-5.575zM192.137 132.572c2.61 0 4.44.59 4.44 3.23 0 2.655-1.83 3.23-4.44 3.23h-1.844v4.233h-1.505v-10.693zm-1.844 1.268v3.88h1.962c1.578 0 2.788-.163 2.788-1.918 0-1.74-1.21-1.962-2.788-1.962z"
              className={classes.cls32}
              transform="translate(-42.377 -11.012)"
            />
            <path
              d="M160.385 127.167H459.822V127.693H160.385z"
              className={classes.cls32}
            />
            <path
              d="M760.143 94.593l-3.846-7.17v7.17h-1.181v-8.399h1.737l3.834 7.148v-7.148h1.182v8.4zM764.914 86.194v5.11c0 1.657.59 2.42 2.166 2.42 1.61 0 2.201-.89 2.201-2.547v-4.982h1.182v4.89c0 2.455-.938 3.66-3.383 3.66-2.328 0-3.347-.95-3.347-3.568v-4.982zM779.313 91.918a3.448 3.448 0 01-3.638 2.825c-2.41 0-3.811-1.818-3.811-4.367 0-2.594 1.54-4.332 3.904-4.332a3.412 3.412 0 013.498 2.827h-1.147a2.313 2.313 0 00-2.41-1.83c-1.482 0-2.64 1.158-2.64 3.336 0 2.131 1.111 3.371 2.675 3.371a2.306 2.306 0 002.421-1.83zM781.86 93.574h4.437v1.02h-5.619v-8.4h1.182zM787.292 86.194h5.7v1.02h-4.519v2.548h4.252v1.02h-4.252v2.792h4.518v1.02h-5.7zM796.511 86.194h1.368l3.162 8.4h-1.274l-.66-1.82h-3.858l-.649 1.82h-1.205zm-.903 5.572h3.128l-1.576-4.378zM805.337 91.049c-.22.011-.417.011-.637.011h-1.483v3.533h-1.181v-8.399h2.664c2.039 0 3.498.406 3.498 2.422a2.06 2.06 0 01-1.668 2.247l1.946 3.73h-1.32zm-2.12-3.858v2.873h1.576c1.24 0 2.19-.128 2.19-1.426s-.95-1.447-2.19-1.447zM758.434 105.123h-1.182v-8.4h1.182zM763.924 105.123l-2.317-7.322v7.322h-1.181v-8.4h1.98l2.144 6.998 2.143-6.997h1.98v8.399h-1.18V97.8l-2.318 7.322zM772.784 96.724h1.367l3.163 8.399h-1.275l-.66-1.82h-3.857l-.65 1.82h-1.204zm-.904 5.572h3.128l-1.575-4.378zM784.981 99.168h-1.146a2.238 2.238 0 00-2.387-1.598c-1.483 0-2.641 1.158-2.641 3.336 0 2.131 1.1 3.372 2.641 3.372 1.112 0 2.48-.464 2.48-2.202v-.22h-2.225v-1.019h3.336v4.286h-.926l-.058-1.054a2.934 2.934 0 01-2.653 1.204c-2.41 0-3.8-1.818-3.8-4.367 0-2.594 1.541-4.332 3.904-4.332a3.34 3.34 0 013.475 2.594zM788.108 105.123h-1.182v-8.4h1.182zM795.127 105.123l-3.846-7.17v7.17H790.1v-8.4h1.737l3.835 7.148v-7.147h1.181v8.399zM805.817 99.168h-1.146a2.238 2.238 0 00-2.387-1.598c-1.483 0-2.64 1.158-2.64 3.336 0 2.131 1.1 3.372 2.64 3.372 1.112 0 2.48-.464 2.48-2.202v-.22h-2.225v-1.019h3.337v4.286h-.927l-.058-1.054a2.934 2.934 0 01-2.653 1.204c-2.41 0-3.8-1.818-3.8-4.367 0-2.594 1.54-4.332 3.904-4.332a3.34 3.34 0 013.475 2.594z"
              className={classes.cls32}
              transform="translate(-42.377 -11.012)"
            />
            <path
              d="M1284.935 814.303a146.238 146.238 0 01-19.812-1.218l.16-1.04c.453.07 45.542 6.765 78.12-12.137.257-.127 22.412-11.244 30.185-50.215l1.032.205c-7.883 39.525-30.498 50.83-30.725 50.94-19.183 11.13-42.653 13.465-58.96 13.465z"
              className={classes.cls34}
              transform="translate(-42.377 -11.012)"
            />
          </g>
          <g onClick={handleGroupClick}>
            <g>
              <g
                data-name="1b"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["1b"]
                })}
              >
                <path
                  d="M87.894 915.964L89.334 919.636 89.334 926.414 87.894 922.743 87.894 915.964z"
                  className={classes.cls18}
                />
                <path
                  d="M124.849 915.894L126.288 919.565 126.288 926.343 124.849 922.672 124.849 915.894z"
                  className={classes.cls18}
                />
                <path
                  d="M248.985 918.096L250.425 921.767 250.425 926.106 248.985 922.435 248.985 918.096z"
                  className={classes.cls18}
                />
                <path
                  d="M369.361 913.801L370.8 917.473 370.8 925.877 369.361 922.206 369.361 913.801z"
                  className={classes.cls18}
                />
                <path
                  d="M411.052 917.787L412.492 921.458 412.492 925.797 411.052 922.126 411.052 917.787z"
                  className={classes.cls18}
                />
                <path
                  d="M431.429 917.748L432.868 921.419 432.868 925.758 431.429 922.087 431.429 917.748z"
                  className={classes.cls18}
                />
                <path
                  d="M480.86 913.589L482.299 917.26 482.299 925.664 480.86 921.993 480.86 913.589z"
                  className={classes.cls18}
                />
                <path
                  d="M493.469 944.497L494.908 948.168 55.912 949.006 54.473 945.334 493.469 944.497z"
                  className={classes.cls19}
                />
                <path
                  d="M493.469 921.969L494.908 925.64 494.908 948.168 493.469 944.497 493.469 921.969z"
                  className={classes.cls18}
                />
                <path
                  d="M480.86 913.589L480.86 921.993 493.469 921.969 493.469 944.497 54.473 945.334 54.473 922.806 72.671 922.772 72.671 915.993 87.894 915.964 87.894 922.743 94.402 922.73 94.402 915.952 124.849 915.894 124.849 922.672 218.539 922.493 218.539 918.154 248.985 918.096 248.985 922.435 320.944 922.298 320.944 913.894 369.361 913.801 369.361 922.206 387.767 922.171 387.767 917.831 411.052 917.787 411.052 922.126 420.364 922.108 420.364 917.769 431.429 917.748 431.429 922.087 433.674 922.083 433.674 913.679 480.86 913.589z"
                  className={classes.barnPath}
                />
                <path
                  d="M384.479 964.35a21.012 21.012 0 1121.011-21.013 21.036 21.036 0 01-21.011 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M384.479 923.325a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.011 22.012 22.037 22.037 0 00-22.011-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M377.94 949.265v-10.617h-3.128v-1.346c1.972-.057 2.996-.322 3.697-1.782h1.423v13.745zM383.077 935.52h5.062c2.521 0 4.872.663 4.872 3.45a3.448 3.448 0 01-1.516 2.977 3.245 3.245 0 012.066 3.26c0 2.92-2.219 4.058-5.024 4.058h-5.46zm2.161 5.82h3.166c1.498 0 2.427-.607 2.427-2.104 0-1.309-.986-1.934-2.427-1.934h-3.166zm0 6.143h3.356c1.838 0 2.748-.815 2.748-2.276 0-1.516-.89-2.198-2.862-2.198h-3.242z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="4"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["4"]
                })}
              >
                <path
                  d="M129.544 875.348L130.984 879.019 70.099 879.135 68.66 875.464 129.544 875.348z"
                  className={classes.cls19}
                />
                <path
                  d="M235.483 826.421L236.922 830.093 236.922 840.529 235.483 836.858 235.483 826.421z"
                  className={classes.cls18}
                />
                <path
                  d="M156.353 875.296L157.793 878.968 157.793 887.239 156.353 883.568 156.353 875.296z"
                  className={classes.cls18}
                />
                <path
                  d="M156.353 883.568L157.793 887.239 130.984 887.291 129.544 883.619 156.353 883.568z"
                  className={classes.cls19}
                />
                <path
                  d="M235.483 826.421L235.483 836.858 257.991 836.815 257.991 875.102 156.353 875.296 156.353 883.568 129.544 883.619 129.544 875.348 68.66 875.464 76.646 837.161 139.633 837.041 139.633 826.604 235.483 826.421z"
                  className={classes.barnPath}
                />
                <path
                  d="M257.991 836.815L259.43 840.486 259.43 878.774 257.991 875.102 257.991 836.815z"
                  className={classes.cls18}
                />
                <path
                  d="M257.991 875.102L259.43 878.774 157.793 878.968 156.353 875.296 257.991 875.102z"
                  className={classes.cls19}
                />
                <path
                  d="M205.346 890.641a21.012 21.012 0 1121.012-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M205.346 849.617a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M210.96 872.239h-2.465v3.318h-1.99v-3.318H199.7v-1.744l6.806-8.683h1.99v8.645h2.465zm-9.081-1.782h4.626v-6.01z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="14"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["14"]
                })}
              >
                <path
                  d="M164.818 742.267L166.257 745.939 166.257 755.345 164.818 751.674 164.818 742.267z"
                  className={classes.cls18}
                />
                <path
                  d="M108.054 790.069L109.494 793.74 88.539 793.78 87.1 790.109 108.054 790.069z"
                  className={classes.cls19}
                />
                <path
                  d="M206.197 742.188L207.636 745.86 207.636 755.266 206.197 751.595 206.197 742.188z"
                  className={classes.cls18}
                />
                <path
                  d="M120.55 795.736L121.989 799.408 109.494 799.431 108.054 795.76 120.55 795.736z"
                  className={classes.cls19}
                />
                <path
                  d="M174.196 795.634L175.636 799.305 175.636 803.021 174.196 799.349 174.196 795.634z"
                  className={classes.cls18}
                />
                <path
                  d="M174.196 799.349L175.636 803.021 121.989 803.123 120.55 799.452 174.196 799.349z"
                  className={classes.cls19}
                />
                <path
                  d="M204.671 795.576L206.111 799.247 175.636 799.305 174.196 795.634 204.671 795.576z"
                  className={classes.cls19}
                />
                <path
                  d="M204.671 789.885L206.111 793.556 206.111 799.247 204.671 795.576 204.671 789.885z"
                  className={classes.cls18}
                />
                <path
                  d="M206.197 742.188L206.197 751.595 266.067 751.481 266.067 789.768 204.671 789.885 204.671 795.576 174.196 795.634 174.196 799.349 120.55 799.452 120.55 795.736 108.054 795.76 108.054 790.069 87.1 790.109 95.086 751.807 118.92 751.761 118.92 742.355 164.818 742.267 164.818 751.674 177.322 751.65 177.322 742.244 206.197 742.188z"
                  className={classes.barnPath}
                />
                <path
                  d="M266.067 789.768L267.506 793.439 206.111 793.556 204.671 789.885 266.067 789.768z"
                  className={classes.cls19}
                />
                <path
                  d="M266.067 751.481L267.506 755.152 267.506 793.439 266.067 789.768 266.067 751.481z"
                  className={classes.cls18}
                />
                <path
                  d="M218.26 808.346a21.012 21.012 0 1121.013-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M218.26 767.322a20.012 20.012 0 11-20.011 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M212.178 793.262v-10.617h-3.129v-1.346c1.972-.057 2.996-.322 3.698-1.782h1.422v13.745zM227.305 789.944h-2.465v3.318h-1.99v-3.318h-6.806V788.2l6.806-8.683h1.99v8.645h2.465zm-9.081-1.782h4.626v-6.01z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="24"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["24"]
                })}
              >
                <path
                  d="M160.219 706.497L161.659 710.168 103.257 710.28 101.817 706.608 160.219 706.497z"
                  className={classes.cls19}
                />
                <path
                  d="M262.34 658.665L263.779 662.337 263.779 671.686 262.34 668.015 262.34 658.665z"
                  className={classes.cls18}
                />
                <path
                  d="M197.155 706.427L198.595 710.098 186.63 710.121 185.191 706.449 197.155 706.427z"
                  className={classes.cls19}
                />
                <path
                  d="M185.191 706.449L186.63 710.121 186.63 718.288 185.191 714.617 185.191 706.449z"
                  className={classes.cls18}
                />
                <path
                  d="M185.191 714.617L186.63 718.288 161.659 718.336 160.219 714.665 185.191 714.617z"
                  className={classes.cls19}
                />
                <path
                  d="M243.053 714.507L244.492 718.178 198.595 718.266 197.155 714.594 243.053 714.507z"
                  className={classes.cls19}
                />
                <path
                  d="M243.053 706.339L244.492 710.01 244.492 718.178 243.053 714.507 243.053 706.339z"
                  className={classes.cls18}
                />
                <path
                  d="M262.34 658.665L262.34 668.015 280.784 667.98 280.784 706.267 243.053 706.339 243.053 714.507 197.155 714.594 197.155 706.427 185.191 706.449 185.191 714.617 160.219 714.665 160.219 706.497 101.817 706.608 109.794 668.306 135.153 668.258 135.153 658.908 262.34 658.665z"
                  className={classes.barnPath}
                />
                <path
                  d="M280.784 706.267L282.224 709.938 244.492 710.01 243.053 706.339 280.784 706.267z"
                  className={classes.cls19}
                />
                <path
                  d="M280.784 667.98L282.224 671.651 282.224 709.938 280.784 706.267 280.784 667.98z"
                  className={classes.cls18}
                />
                <path
                  d="M232.202 722.28a21.012 21.012 0 1121.011-21.01 21.036 21.036 0 01-21.011 21.01z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M232.202 681.257a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M231.172 696.827c0 3.014-3.034 5.764-7.034 8.588h7.394v1.782h-9.953v-1.705c4.72-3.604 7.526-6.067 7.526-8.457a2.165 2.165 0 00-2.408-2.256c-1.403 0-2.768.797-2.768 3.015h-2.01c-.056-2.749 1.896-4.588 4.835-4.588 2.54 0 4.418 1.289 4.418 3.621zM243.056 703.88h-2.465v3.317h-1.99v-3.318h-6.807v-1.744l6.807-8.683h1.99v8.645h2.465zm-9.081-1.783h4.626v-6.01z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="34"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["34"]
                })}
              >
                <path
                  d="M139.036 623.881L140.475 627.552 120.97 627.589 119.53 623.918 139.036 623.881z"
                  className={classes.cls19}
                />
                <path
                  d="M141.129 623.877L142.569 627.548 140.475 627.552 139.036 623.881 141.129 623.877z"
                  className={classes.cls19}
                />
                <path
                  d="M233.142 581.547L234.581 585.219 234.581 593.349 233.142 589.677 233.142 581.547z"
                  className={classes.cls18}
                />
                <path
                  d="M275.582 580.975L277.021 584.646 277.021 593.268 275.582 589.597 275.582 580.975z"
                  className={classes.cls18}
                />
                <path
                  d="M295.599 589.558L297.038 593.23 297.038 601.653 295.599 597.981 295.599 589.558z"
                  className={classes.cls18}
                />
                <path
                  d="M234.326 632.207L235.766 635.878 142.569 636.056 141.129 632.385 234.326 632.207z"
                  className={classes.cls19}
                />
                <path
                  d="M234.326 623.699L235.766 627.37 235.766 635.878 234.326 632.207 234.326 623.699z"
                  className={classes.cls18}
                />
                <path
                  d="M304.92 597.964L306.36 601.635 306.36 620.457 304.92 616.786 304.92 597.964z"
                  className={classes.cls18}
                />
                <path
                  d="M304.92 616.786L306.36 620.457 297.038 620.475 295.599 616.804 304.92 616.786z"
                  className={classes.cls19}
                />
                <path
                  d="M295.599 623.582L297.038 627.253 235.766 627.37 234.326 623.699 295.599 623.582z"
                  className={classes.cls19}
                />
                <path
                  d="M295.599 616.804L297.038 620.475 297.038 627.253 295.599 623.582 295.599 616.804z"
                  className={classes.cls18}
                />
                <path
                  d="M275.582 580.975L275.582 589.597 295.599 589.558 295.599 597.981 304.92 597.964 304.92 616.786 295.599 616.804 295.599 623.582 234.326 623.699 234.326 632.207 141.129 632.385 141.129 623.877 139.036 623.881 119.53 623.918 137.776 589.869 139.036 589.866 207.953 589.726 207.953 581.595 233.142 581.547 233.142 589.677 246.253 589.652 246.253 581.031 275.582 580.975z"
                  className={classes.barnPath}
                />
                <path
                  d="M247.89 646.035a21.012 21.012 0 1121.012-21.012 21.035 21.035 0 01-21.013 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M247.89 605.01a20.012 20.012 0 11-20.012 20.013 20.012 20.012 0 0120.011-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M244.765 627.102c0-1.896-1.593-2.503-3.716-2.503h-.474v-1.724h.399c2.33 0 3.431-.683 3.431-2.2 0-1.44-1.157-2.143-2.54-2.143a2.745 2.745 0 00-2.902 2.655h-1.97c.207-2.521 2.008-4.228 4.966-4.228 2.332 0 4.512.967 4.512 3.545a3.36 3.36 0 01-2.142 3.148 3.385 3.385 0 012.503 3.412c0 2.788-2.389 4.134-5.062 4.134a4.57 4.57 0 01-4.968-4.4h1.972a2.903 2.903 0 003.034 2.807c1.725 0 2.957-.892 2.957-2.503zM259.132 627.633h-2.465v3.318h-1.99v-3.318h-6.807v-1.744l6.806-8.683h1.991v8.644h2.465zm-9.08-1.782h4.625v-6.01z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="44"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["44"]
                })}
              >
                <path
                  d="M194.674 547.748L196.113 551.419 181.922 551.446 180.483 547.775 194.674 547.748z"
                  className={classes.cls19}
                />
                <path
                  d="M286.137 506.356L287.576 510.027 287.576 517.221 286.137 513.55 286.137 506.356z"
                  className={classes.cls18}
                />
                <path
                  d="M223.036 554.708L224.476 558.38 191.272 558.443 189.833 554.772 223.036 554.708z"
                  className={classes.cls19}
                />
                <path
                  d="M269.625 547.605L271.065 551.276 271.065 561.099 269.625 557.427 269.625 547.605z"
                  className={classes.cls18}
                />
                <path
                  d="M269.625 557.427L271.065 561.099 224.476 561.187 223.036 557.516 269.625 557.427z"
                  className={classes.cls19}
                />
                <path
                  d="M305.519 513.513L306.958 517.184 306.958 551.208 305.519 547.537 305.519 513.513z"
                  className={classes.cls18}
                />
                <path
                  d="M305.519 547.537L306.958 551.208 271.065 551.276 269.625 547.605 305.519 547.537z"
                  className={classes.cls19}
                />
                <path
                  d="M286.137 506.356L286.137 513.55 305.519 513.513 305.519 547.537 269.625 547.605 269.625 557.427 223.036 557.516 223.036 554.708 189.833 554.772 194.674 547.748 180.483 547.775 222.572 509.228 233.836 509.197 233.836 506.455 286.137 506.356z"
                  className={classes.barnPath}
                />
                <path
                  d="M281.923 566.657a21.012 21.012 0 1121.012-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M281.923 525.633a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M281.642 548.255h-2.464v3.318h-1.99v-3.318h-6.807v-1.744l6.807-8.683h1.99v8.645h2.464zm-9.08-1.782h4.625v-6.01zM293.431 548.255h-2.464v3.318h-1.991v-3.318h-6.806v-1.744l6.806-8.683h1.991v8.645h2.465zm-9.081-1.782h4.626v-6.01z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="54"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["54"]
                })}
              >
                <path
                  d="M348.345 433.965L349.785 437.636 349.785 446.787 348.345 443.116 348.345 433.965z"
                  className={classes.cls18}
                />
                <path
                  d="M330.394 474.338L331.833 478.009 331.833 485.288 330.394 481.617 330.394 474.338z"
                  className={classes.cls18}
                />
                <path
                  d="M330.394 481.617L331.833 485.288 251.339 485.442 249.9 481.771 330.394 481.617z"
                  className={classes.cls19}
                />
                <path
                  d="M348.345 433.965L348.345 443.116 376.935 443.062 376.935 474.249 330.394 474.338 330.394 481.617 249.9 481.771 290.853 443.226 305.252 443.189 305.252 434.047 348.345 433.965z"
                  className={classes.barnPath}
                />
                <path
                  d="M376.935 443.062L378.375 446.733 378.375 477.92 376.935 474.249 376.935 443.062z"
                  className={classes.cls18}
                />
                <path
                  d="M376.935 474.249L378.375 477.92 331.833 478.009 330.394 474.338 376.935 474.249z"
                  className={classes.cls19}
                />
                <path
                  d="M359.689 494.46A21.012 21.012 0 11380.7 473.45a21.035 21.035 0 01-21.011 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M359.689 453.437a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.011 22.012 22.037 22.037 0 00-22.011-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M356.64 474.903a2.884 2.884 0 00-2.938-3.128 2.666 2.666 0 00-2.579 1.478l-1.915-.114.91-7.507h8.039v1.8h-6.427l-.455 3.678a4.276 4.276 0 012.9-.948 4.408 4.408 0 014.532 4.721c0 3.11-2.351 4.74-4.986 4.74a4.614 4.614 0 01-4.949-4.342h1.972a2.79 2.79 0 002.995 2.75 2.872 2.872 0 002.901-3.128zM371.045 476.059h-2.465v3.318h-1.99v-3.318h-6.806v-1.744l6.806-8.683h1.99v8.645h2.465zm-9.081-1.782h4.626v-6.01z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="64"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["64"]
                })}
              >
                <path
                  d="M390.235 373.159L386.607 405.535 335.821 405.632 370.455 373.215 390.235 373.159z"
                  className={classes.barnPath}
                />
                <path
                  d="M390.235 373.159L391.675 376.83 388.046 409.206 386.607 405.535 390.235 373.159z"
                  className={classes.cls36}
                />
                <path
                  d="M386.607 405.535L388.046 409.206 337.261 409.303 335.821 405.632 386.607 405.535z"
                  className={classes.cls19}
                />
                <path
                  d="M409.264 427.466a21.012 21.012 0 1121.011-21.012 21.036 21.036 0 01-21.011 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M409.264 386.442a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.011 22.012 22.037 22.037 0 00-22.011-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M400.394 404.988a3.892 3.892 0 013.47-1.763 4.424 4.424 0 014.494 4.683 4.643 4.643 0 01-4.911 4.721c-3.488 0-5.081-2.54-5.081-6.674 0-3.943 1.422-7.565 5.422-7.565a4.027 4.027 0 014.323 3.564h-2.067a2.275 2.275 0 00-2.445-1.99c-1.972 0-3.147 2.01-3.204 5.024zm3.034 6.048a3.09 3.09 0 10-2.844-3.052 2.776 2.776 0 002.844 3.052zM420.715 409.064h-2.465v3.318h-1.99v-3.318h-6.807v-1.744l6.807-8.683h1.99v8.645h2.465zm-9.081-1.782h4.626v-6.01z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="64a"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["64a"]
                })}
              >
                <path
                  d="M394.307 320.839L431.64 330.098 422.3 367.373 384.966 358.123 394.307 320.839z"
                  className={classes.barnPath}
                />
                <path
                  d="M431.64 330.098L433.08 333.77 423.739 371.044 422.3 367.373 431.64 330.098z"
                  className={classes.cls26}
                />
                <path
                  d="M422.3 367.373L423.739 371.044 386.405 361.794 384.966 358.123 422.3 367.373z"
                  className={classes.cls19}
                />
                <path
                  d="M442.743 377.682a21.012 21.012 0 1121.012-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M442.743 336.658a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M427.544 355.204a3.892 3.892 0 013.47-1.763 4.424 4.424 0 014.493 4.683 4.643 4.643 0 01-4.91 4.721c-3.49 0-5.082-2.54-5.082-6.674 0-3.943 1.422-7.565 5.423-7.565a4.027 4.027 0 014.322 3.564h-2.066a2.275 2.275 0 00-2.446-1.99c-1.972 0-3.147 2.01-3.204 5.024zm3.033 6.048a3.09 3.09 0 10-2.843-3.052 2.776 2.776 0 002.843 3.052zM447.864 359.28H445.4v3.318h-1.99v-3.318h-6.807v-1.744l6.807-8.683h1.99v8.645h2.465zm-9.08-1.782h4.625v-6.01zM453.245 348.853h2.39l5.175 13.745h-2.351l-1.08-3.015h-5.973l-1.062 3.015h-2.199zm-1.194 8.91h4.663l-2.35-6.56z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="126"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["126"]
                })}
              >
                <path
                  d="M469.127 243.723L470.566 247.394 463.13 245.263 461.69 241.591 469.127 243.723z"
                  className={classes.cls19}
                />
                <path
                  d="M523.825 214.435L525.264 218.107 516.852 247.183 515.413 243.512 523.825 214.435z"
                  className={classes.cls37}
                />
                <path
                  d="M457.001 285.607L458.44 289.278 451.004 287.146 449.565 283.475 457.001 285.607z"
                  className={classes.cls19}
                />
                <path
                  d="M524.327 246.066L525.766 249.737 510.041 304.06 508.601 300.388 524.327 246.066z"
                  className={classes.cls37}
                />
                <path
                  d="M508.601 300.388L510.041 304.06 501.126 301.505 499.687 297.834 508.601 300.388z"
                  className={classes.cls19}
                />
                <path
                  d="M499.687 297.834L501.126 301.505 496.191 318.569 494.752 314.898 499.687 297.834z"
                  className={classes.cls37}
                />
                <path
                  d="M481.148 202.208L523.825 214.435 515.413 243.512 524.327 246.066 508.601 300.388 499.687 297.834 494.752 314.898 452.065 302.671 457.001 285.607 449.565 283.475 457.948 254.512 465.385 256.644 469.127 243.723 461.69 241.591 468.52 218.01 475.957 220.142 481.148 202.208z"
                  className={classes.barnPath}
                />
                <path
                  d="M494.752 314.898L496.191 318.569 453.505 306.342 452.065 302.671 494.752 314.898z"
                  className={classes.cls19}
                />
                <path
                  d="M532.986 300.927A21.012 21.012 0 11554 279.915a21.035 21.035 0 01-21.013 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M532.987 259.903a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M521.436 285.843v-10.617h-3.129v-1.346c1.972-.057 2.996-.322 3.697-1.782h1.423v13.745zM535.16 275.473c0 3.014-3.034 5.763-7.034 8.588h7.394v1.782h-9.953v-1.706c4.72-3.603 7.527-6.067 7.527-8.456a2.165 2.165 0 00-2.408-2.256c-1.403 0-2.768.796-2.768 3.014h-2.01c-.057-2.748 1.896-4.588 4.835-4.588 2.54 0 4.417 1.29 4.417 3.622zM538.967 278.449a3.892 3.892 0 013.47-1.763 4.424 4.424 0 014.493 4.683 4.643 4.643 0 01-4.91 4.721c-3.489 0-5.081-2.54-5.081-6.674 0-3.943 1.422-7.565 5.422-7.565a4.028 4.028 0 014.323 3.564h-2.067a2.275 2.275 0 00-2.445-1.99c-1.972 0-3.148 2.01-3.205 5.024zm3.034 6.048a3.09 3.09 0 10-2.844-3.052 2.776 2.776 0 002.844 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="116"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["116"]
                })}
              >
                <path
                  d="M567.627 171.05L569.066 174.721 562.833 174.412 561.394 170.74 567.627 171.05z"
                  className={classes.cls19}
                />
                <path
                  d="M613.458 130.236L614.898 133.908 613.486 160.73 612.047 157.059 613.458 130.236z"
                  className={classes.cls27}
                />
                <path
                  d="M566.092 200.293L567.532 203.964 561.298 203.645 559.859 199.974 566.092 200.293z"
                  className={classes.cls19}
                />
                <path
                  d="M619.995 157.46L621.434 161.131 618.943 208.612 617.503 204.941 619.995 157.46z"
                  className={classes.cls27}
                />
                <path
                  d="M617.503 204.941L618.943 208.612 610.995 208.211 609.555 204.54 617.503 204.941z"
                  className={classes.cls19}
                />
                <path
                  d="M609.555 204.54L610.995 208.211 610.351 220.483 608.911 216.812 609.555 204.54z"
                  className={classes.cls27}
                />
                <path
                  d="M563.734 245.287L565.173 248.959 558.93 248.649 557.491 244.978 563.734 245.287z"
                  className={classes.cls19}
                />
                <path
                  d="M561.896 280.345L563.335 284.016 549.495 283.315 548.055 279.643 561.896 280.345z"
                  className={classes.cls19}
                />
                <path
                  d="M614.036 271.028L615.475 274.699 607.528 274.299 606.088 270.627 614.036 271.028z"
                  className={classes.cls19}
                />
                <path
                  d="M616.859 217.213L618.298 220.884 615.475 274.699 614.036 271.028 616.859 217.213z"
                  className={classes.cls27}
                />
                <path
                  d="M604.364 303.378L605.803 307.049 562.236 304.854 560.797 301.183 604.364 303.378z"
                  className={classes.cls19}
                />
                <path
                  d="M606.088 270.627L607.528 274.299 605.803 307.049 604.364 303.378 606.088 270.627z"
                  className={classes.cls27}
                />
                <path
                  d="M569.891 128.041L613.458 130.236 612.047 157.059 619.995 157.46 617.503 204.941 609.555 204.54 608.911 216.812 616.859 217.213 614.036 271.028 606.088 270.627 604.364 303.378 560.797 301.183 561.896 280.345 548.055 279.643 549.562 251.005 563.393 251.707 563.734 245.287 557.491 244.978 558.268 230.342 564.501 230.652 566.092 200.293 559.859 199.974 561.166 175.127 567.4 175.437 567.627 171.05 561.394 170.74 562.417 151.311 568.65 151.621 569.891 128.041z"
                  className={classes.barnPath}
                />
                <path
                  d="M628.753 263.794a21.012 21.012 0 1121.012-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M628.753 222.77a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M619.107 248.71v-10.617h-3.129v-1.346c1.972-.057 2.996-.322 3.698-1.782h1.422v13.745zM626.347 248.71v-10.617h-3.129v-1.346c1.972-.057 2.996-.322 3.698-1.782h1.422v13.745zM632.829 241.316a3.892 3.892 0 013.47-1.763 4.424 4.424 0 014.493 4.683 4.643 4.643 0 01-4.91 4.72c-3.49 0-5.081-2.54-5.081-6.673 0-3.943 1.421-7.565 5.422-7.565a4.027 4.027 0 014.322 3.564h-2.066a2.275 2.275 0 00-2.446-1.99c-1.972 0-3.147 2.01-3.204 5.024zm3.033 6.048a3.09 3.09 0 10-2.843-3.052 2.776 2.776 0 002.843 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="136"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["136"]
                })}
              >
                <path
                  d="M699.024 23.121L700.464 26.793 693.482 32.96 692.043 29.289 699.024 23.121z"
                  className={classes.cls30}
                />
                <path
                  d="M715.337 23.308L716.777 26.979 700.464 26.793 699.024 23.121 715.337 23.308z"
                  className={classes.cls19}
                />
                <path
                  d="M648.978 67.384L650.417 71.055 648.494 72.761 647.055 69.09 648.978 67.384z"
                  className={classes.cls30}
                />
                <path
                  d="M751.07 15.251L752.509 18.922 744.902 38.062 743.463 34.39 751.07 15.251z"
                  className={classes.cls25}
                />
                <path
                  d="M743.463 34.39L744.902 38.062 716.777 26.979 715.337 23.308 743.463 34.39z"
                  className={classes.cls19}
                />
                <path
                  d="M697.812 35.782L699.251 39.453 656.186 77.558 654.747 73.887 697.812 35.782z"
                  className={classes.cls30}
                />
                <path
                  d="M654.747 73.887L656.186 77.558 650.417 71.055 648.978 67.384 654.747 73.887z"
                  className={classes.cls19}
                />
                <path
                  d="M602.569 108.435L604.008 112.107 594.696 101.612 593.256 97.941 602.569 108.435z"
                  className={classes.cls19}
                />
                <path
                  d="M616.428 96.176L617.867 99.847 604.008 112.107 602.569 108.435 616.428 96.176z"
                  className={classes.cls30}
                />
                <path
                  d="M622.197 102.679L623.636 106.35 617.867 99.847 616.428 96.176 622.197 102.679z"
                  className={classes.cls19}
                />
                <path
                  d="M722.935 4.169L751.07 15.251 743.463 34.39 715.337 23.308 699.024 23.121 692.043 29.289 697.812 35.782 654.747 73.887 648.978 67.384 647.055 69.09 652.824 75.583 622.197 102.679 616.428 96.176 602.569 108.435 593.256 97.941 696.021 7.028 722.935 4.169z"
                  className={classes.barnPath}
                />
                <path
                  d="M652.824 75.583L654.263 79.254 623.636 106.35 622.197 102.679 652.824 75.583z"
                  className={classes.cls30}
                />
                <path
                  d="M689.37 84.217a21.012 21.012 0 1121.013-21.011 21.035 21.035 0 01-21.012 21.011z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M689.37 43.194a20.012 20.012 0 11-20.011 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M677.716 69.134V58.517h-3.129V57.17c1.972-.057 2.996-.322 3.697-1.782h1.422v13.745zM689.734 65.285c0-1.896-1.593-2.503-3.716-2.503h-.474v-1.724h.398c2.332 0 3.431-.683 3.431-2.2 0-1.441-1.156-2.143-2.54-2.143a2.745 2.745 0 00-2.9 2.655h-1.972c.209-2.522 2.01-4.229 4.967-4.229 2.332 0 4.512.967 4.512 3.546a3.36 3.36 0 01-2.142 3.148 3.385 3.385 0 012.502 3.412c0 2.788-2.389 4.134-5.062 4.134a4.57 4.57 0 01-4.967-4.4h1.971a2.903 2.903 0 003.034 2.807c1.726 0 2.958-.892 2.958-2.503zM695.456 61.74a3.893 3.893 0 013.47-1.763 4.424 4.424 0 014.493 4.683 4.643 4.643 0 01-4.91 4.72c-3.489 0-5.082-2.54-5.082-6.673 0-3.943 1.423-7.565 5.423-7.565a4.027 4.027 0 014.323 3.564h-2.067a2.275 2.275 0 00-2.446-1.99c-1.972 0-3.147 2.01-3.204 5.023zm3.033 6.048a3.09 3.09 0 10-2.844-3.052 2.776 2.776 0 002.844 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g className={classes.cls42}>
                <path
                  d="M761.455 18.18L807.41 36.29 799.812 55.42 753.858 37.319 761.455 18.18z"
                  className={classes.barnPath}
                />
                <path
                  d="M807.41 36.29L808.849 39.962 801.251 59.091 799.812 55.42 807.41 36.29z"
                  className={classes.cls25}
                />
                <path
                  d="M799.812 55.42L801.251 59.091 755.297 40.99 753.858 37.319 799.812 55.42z"
                  className={classes.cls19}
                />
              </g>
              <g className={classes.cls42}>
                <path
                  d="M834.797 69.359L836.237 73.03 806.235 61.204 804.796 57.533 834.797 69.359z"
                  className={classes.cls19}
                />
                <path
                  d="M861.426 57.718L862.866 61.389 855.268 80.528 853.829 76.857 861.426 57.718z"
                  className={classes.cls25}
                />
                <path
                  d="M853.829 76.857L855.268 80.528 849.603 78.299 848.164 74.627 853.829 76.857z"
                  className={classes.cls19}
                />
                <path
                  d="M812.393 38.403L861.426 57.718 853.829 76.857 848.164 74.627 845.606 81.07 832.239 75.802 834.797 69.359 804.796 57.533 812.393 38.403z"
                  className={classes.barnPath}
                />
                <path
                  d="M848.164 74.627L849.603 78.299 847.045 84.741 845.606 81.07 848.164 74.627z"
                  className={classes.cls25}
                />
                <path
                  d="M845.606 81.07L847.045 84.741 833.679 79.473 832.239 75.802 845.606 81.07z"
                  className={classes.cls19}
                />
              </g>
              <path
                d="M847.173 80.23a21.012 21.012 0 1121.012-21.013 21.036 21.036 0 01-21.012 21.012z"
                className={classes.circle}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M847.173 39.205a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                className={classes.circleOutline}
                transform="translate(-42.377 -11.012)"
              />
              <path
                d="M835.404 65.145V54.528h-3.128v-1.346c1.972-.057 2.996-.322 3.697-1.782h1.422v13.745zM847.612 60.671a2.884 2.884 0 00-2.939-3.128 2.666 2.666 0 00-2.578 1.479l-1.915-.114.91-7.508h8.038v1.8h-6.426l-.455 3.679a4.275 4.275 0 012.9-.948 4.408 4.408 0 014.532 4.72c0 3.11-2.352 4.74-4.987 4.74a4.614 4.614 0 01-4.948-4.342h1.971a2.79 2.79 0 002.996 2.75 2.871 2.871 0 002.9-3.128zM853.372 57.75a3.892 3.892 0 013.47-1.762 4.424 4.424 0 014.493 4.683 4.643 4.643 0 01-4.91 4.72c-3.49 0-5.082-2.54-5.082-6.673 0-3.943 1.422-7.565 5.423-7.565a4.028 4.028 0 014.322 3.564h-2.066a2.275 2.275 0 00-2.446-1.99c-1.972 0-3.147 2.01-3.204 5.024zm3.033 6.049a3.09 3.09 0 10-2.844-3.052 2.776 2.776 0 002.844 3.052z"
                className={classes.cls32}
                transform="translate(-42.377 -11.012)"
              />
              <g
                data-name="107a"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["107a"]
                })}
              >
                <path
                  d="M865.64 59.488L897.687 72.113 890.09 91.253 858.033 78.627 865.64 59.488z"
                  className={classes.barnPath}
                />
                <path
                  d="M897.687 72.113L899.127 75.785 891.529 94.924 890.09 91.253 897.687 72.113z"
                  className={classes.cls25}
                />
                <path
                  d="M890.09 91.253L891.529 94.924 859.472 82.298 858.033 78.627 890.09 91.253z"
                  className={classes.cls19}
                />
                <path
                  d="M946.416 118.672a26.59 26.59 0 1126.59-26.59 26.62 26.62 0 01-26.59 26.59z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M946.416 66.492a25.59 25.59 0 11-25.59 25.59 25.59 25.59 0 0125.59-25.59m0-2a27.59 27.59 0 1027.59 27.59 27.621 27.621 0 00-27.59-27.59z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M928.857 98.01V87.393h-3.129v-1.346c1.972-.056 2.996-.322 3.698-1.782h1.422V98.01zM933.31 91.128c0-4.285 1.744-7.11 5.403-7.11 3.678 0 5.403 2.825 5.403 7.11 0 4.304-1.725 7.129-5.403 7.129-3.659 0-5.403-2.825-5.403-7.13zm8.72 0c0-3.697-1.193-5.536-3.317-5.536-2.104 0-3.318 1.84-3.318 5.536 0 3.716 1.214 5.536 3.318 5.536 2.124 0 3.318-1.82 3.318-5.536zM945.042 84.265h9.689v1.8a16.412 16.412 0 00-5.745 11.945h-2.314a17.036 17.036 0 015.878-11.944h-7.508zM959.656 84.265h2.39l5.175 13.745h-2.35l-1.081-3.015h-5.972l-1.063 3.015h-2.198zm-1.194 8.91h4.664l-2.351-6.56z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="146"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["146"]
                })}
              >
                <path
                  d="M699.027 78.783L700.466 82.454 700.466 91.993 699.027 88.322 699.027 78.783z"
                  className={classes.cls18}
                />
                <path
                  d="M681.871 101.769L683.31 105.44 679.985 105.446 678.546 101.775 681.871 101.769z"
                  className={classes.cls19}
                />
                <path
                  d="M702.305 88.315L703.744 91.986 703.744 105.401 702.305 101.73 702.305 88.315z"
                  className={classes.cls18}
                />
                <path
                  d="M702.305 101.73L703.744 105.401 700.466 105.407 699.027 101.736 702.305 101.73z"
                  className={classes.cls19}
                />
                <path
                  d="M699.027 101.736L700.466 105.407 700.466 112.545 699.027 108.874 699.027 101.736z"
                  className={classes.cls18}
                />
                <path
                  d="M701.158 108.87L702.598 112.541 702.598 122.845 701.158 119.174 701.158 108.87z"
                  className={classes.cls18}
                />
                <path
                  d="M685.821 141.107L687.261 144.779 656.691 144.837 655.251 141.166 685.821 141.107z"
                  className={classes.cls19}
                />
                <path
                  d="M701.158 119.174L702.598 122.845 702.598 144.749 701.158 141.078 701.158 119.174z"
                  className={classes.cls18}
                />
                <path
                  d="M701.158 141.078L702.598 144.749 702.598 149.902 701.158 146.23 701.158 141.078z"
                  className={classes.cls18}
                />
                <path
                  d="M701.158 146.23L702.598 149.902 687.261 149.931 685.821 146.26 701.158 146.23z"
                  className={classes.cls19}
                />
                <path
                  d="M699.027 78.783L699.027 88.322 702.305 88.315 702.305 101.73 699.027 101.736 699.027 108.874 701.158 108.87 701.158 119.174 701.158 141.078 701.158 146.23 685.821 146.26 685.821 141.107 655.251 141.166 655.251 108.957 681.871 108.906 681.871 101.769 678.546 101.775 678.546 88.361 681.871 88.354 681.871 78.816 699.027 78.783z"
                  className={classes.barnPath}
                />
                <path
                  d="M715.432 160.634a21.012 21.012 0 1121.012-21.012 21.035 21.035 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M715.432 119.61a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M703.511 145.55v-10.617h-3.128v-1.346c1.972-.057 2.996-.322 3.697-1.782h1.422v13.745zM718.639 142.232h-2.465v3.318h-1.991v-3.318h-6.806v-1.744l6.806-8.683h1.99v8.645h2.466zm-9.082-1.782h4.626v-6.01zM721.782 138.156a3.892 3.892 0 013.47-1.763 4.424 4.424 0 014.493 4.683 4.643 4.643 0 01-4.91 4.72c-3.489 0-5.082-2.54-5.082-6.673 0-3.943 1.422-7.565 5.423-7.565a4.027 4.027 0 014.322 3.564h-2.066a2.275 2.275 0 00-2.446-1.99c-1.971 0-3.147 2.01-3.204 5.024zm3.033 6.048a3.09 3.09 0 10-2.843-3.052 2.776 2.776 0 002.844 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="106"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["106"]
                })}
              >
                <path
                  d="M791.219 67.818L792.659 71.489 792.659 78.154 791.219 74.483 791.219 67.818z"
                  className={classes.cls18}
                />
                <path
                  d="M806.509 74.454L807.948 78.125 807.948 117.622 806.509 113.951 806.509 74.454z"
                  className={classes.cls18}
                />
                <path
                  d="M806.509 113.951L807.948 117.622 807.948 119.04 806.509 115.369 806.509 113.951z"
                  className={classes.cls18}
                />
                <path
                  d="M746.449 141.122L747.889 144.793 702.626 144.879 701.186 141.208 746.449 141.122z"
                  className={classes.cls19}
                />
                <path
                  d="M766.144 141.084L767.583 144.755 767.583 149.907 766.144 146.236 766.144 141.084z"
                  className={classes.cls18}
                />
                <path
                  d="M766.144 146.236L767.583 149.907 747.889 149.945 746.449 146.274 766.144 146.236z"
                  className={classes.cls19}
                />
                <path
                  d="M806.509 115.369L807.948 119.04 807.948 144.678 806.509 141.007 806.509 115.369z"
                  className={classes.cls18}
                />
                <path
                  d="M791.219 67.818L791.219 74.483 806.509 74.454 806.509 113.951 806.509 115.369 806.509 141.007 766.144 141.084 766.144 146.236 746.449 146.274 746.449 141.122 701.186 141.208 701.186 114.152 775.939 114.009 775.939 74.512 778.658 74.507 778.658 67.842 791.219 67.818z"
                  className={classes.barnPath}
                />
                <path
                  d="M806.509 141.007L807.948 144.678 767.583 144.755 766.144 141.084 806.509 141.007z"
                  className={classes.cls19}
                />
                <path
                  d="M767.43 161.422a21.012 21.012 0 1121.013-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M767.43 120.398a20.012 20.012 0 11-20.011 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M755.16 146.338V135.72h-3.129v-1.346c1.972-.057 2.996-.322 3.698-1.782h1.422v13.745zM759.613 139.455c0-4.285 1.744-7.11 5.403-7.11 3.679 0 5.404 2.825 5.404 7.11 0 4.305-1.725 7.13-5.404 7.13-3.659 0-5.403-2.825-5.403-7.13zm8.721 0c0-3.696-1.194-5.536-3.317-5.536-2.105 0-3.318 1.84-3.318 5.536 0 3.717 1.213 5.537 3.318 5.537 2.123 0 3.317-1.82 3.317-5.537zM774.132 138.943a3.893 3.893 0 013.47-1.762 4.424 4.424 0 014.493 4.683 4.643 4.643 0 01-4.91 4.72c-3.49 0-5.082-2.54-5.082-6.673 0-3.944 1.422-7.565 5.423-7.565a4.028 4.028 0 014.322 3.564h-2.066a2.275 2.275 0 00-2.446-1.99c-1.972 0-3.147 2.01-3.204 5.023zm3.033 6.049a3.09 3.09 0 10-2.843-3.052 2.776 2.776 0 002.843 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="96"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["96"]
                })}
              >
                <path
                  d="M702.323 202.078L703.762 205.75 652.73 205.847 651.291 202.176 702.323 202.078z"
                  className={classes.cls19}
                />
                <path
                  d="M784.36 168.626L785.8 172.297 785.8 178.537 784.36 174.866 784.36 168.626z"
                  className={classes.cls18}
                />
                <path
                  d="M731.907 209.32L733.347 212.991 703.762 213.048 702.323 209.377 731.907 209.32z"
                  className={classes.cls19}
                />
                <path
                  d="M773.921 201.942L775.36 205.613 775.36 215.606 773.921 211.934 773.921 201.942z"
                  className={classes.cls18}
                />
                <path
                  d="M773.921 211.934L775.36 215.606 733.347 215.686 731.907 212.014 773.921 211.934z"
                  className={classes.cls19}
                />
                <path
                  d="M803.004 174.83L804.443 178.501 804.443 205.558 803.004 201.886 803.004 174.83z"
                  className={classes.cls18}
                />
                <path
                  d="M803.004 201.886L804.443 205.558 775.36 205.613 773.921 201.942 803.004 201.886z"
                  className={classes.cls19}
                />
                <path
                  d="M784.36 168.626L784.36 174.866 803.004 174.83 803.004 201.886 773.921 201.942 773.921 211.934 731.907 212.014 731.907 209.32 702.323 209.377 702.323 202.078 651.291 202.176 651.291 175.12 673.42 175.077 673.42 168.838 784.36 168.626z"
                  className={classes.barnPath}
                />
                <circle
                  cx="724.678"
                  cy="192.048"
                  r="21.012"
                  className={classes.circle}
                ></circle>
                <path
                  d="M767.055 183.048a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M764.12 202.637a3.938 3.938 0 01-3.47 1.763 4.44 4.44 0 01-4.494-4.701 4.628 4.628 0 014.91-4.703c3.49 0 5.082 2.541 5.082 6.674 0 3.943-1.422 7.565-5.423 7.565a4.027 4.027 0 01-4.322-3.565h2.067a2.237 2.237 0 002.446 1.972c2.01 0 3.109-1.99 3.204-5.005zm-3.034-6.067a2.806 2.806 0 00-2.862 3.071 2.855 2.855 0 105.687 0 2.779 2.779 0 00-2.825-3.071zM769.86 201.594a3.893 3.893 0 013.47-1.763 4.424 4.424 0 014.494 4.683 4.643 4.643 0 01-4.911 4.721c-3.489 0-5.081-2.54-5.081-6.673 0-3.944 1.422-7.566 5.422-7.566a4.027 4.027 0 014.323 3.564h-2.067a2.275 2.275 0 00-2.446-1.99c-1.971 0-3.147 2.01-3.204 5.024zm3.034 6.048a3.09 3.09 0 10-2.844-3.052 2.776 2.776 0 002.844 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="86"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["86"]
                })}
              >
                <path
                  d="M731.906 229.569L733.346 233.24 733.346 241.871 731.906 238.2 731.906 229.569z"
                  className={classes.cls18}
                />
                <path
                  d="M666.409 265.391L667.848 269.062 648.286 269.099 646.847 265.428 666.409 265.391z"
                  className={classes.cls19}
                />
                <path
                  d="M782.683 229.472L784.122 233.143 784.122 241.774 782.683 238.103 782.683 229.472z"
                  className={classes.cls18}
                />
                <path
                  d="M751.042 265.229L752.482 268.9 752.482 274.894 751.042 271.223 751.042 265.229z"
                  className={classes.cls18}
                />
                <path
                  d="M751.042 271.223L752.482 274.894 667.848 275.056 666.409 271.384 751.042 271.223z"
                  className={classes.cls19}
                />
                <path
                  d="M801.743 238.067L803.182 241.738 803.182 268.804 801.743 265.133 801.743 238.067z"
                  className={classes.cls18}
                />
                <path
                  d="M801.743 265.133L803.182 268.804 752.482 268.9 751.042 265.229 801.743 265.133z"
                  className={classes.cls19}
                />
                <path
                  d="M782.683 229.472L782.683 238.103 801.743 238.067 801.743 265.133 751.042 265.229 751.042 271.223 666.409 271.384 666.409 265.391 646.847 265.428 646.847 238.362 712.344 238.237 712.344 229.606 731.906 229.569 731.906 238.2 743.549 238.178 743.549 229.547 782.683 229.472z"
                  className={classes.barnPath}
                />
                <path
                  d="M767.055 288.925a21.012 21.012 0 1121.012-21.013 21.036 21.036 0 01-21.012 21.013z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M767.055 247.9a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M765.845 263.356a3.532 3.532 0 01-1.82 3.166 3.571 3.571 0 012.237 3.432c0 2.655-2.199 4.133-5.061 4.133s-5.063-1.478-5.063-4.133a3.59 3.59 0 012.256-3.432 3.593 3.593 0 01-1.82-3.166c0-2.029 1.783-3.507 4.627-3.507s4.644 1.478 4.644 3.507zm-7.621 6.56c0 1.593 1.156 2.579 2.976 2.579s2.996-.986 2.996-2.579-1.175-2.616-2.996-2.616-2.976 1.024-2.976 2.615zm2.976-8.494c-1.592 0-2.673.835-2.673 2.181a2.701 2.701 0 005.346 0c0-1.346-1.061-2.181-2.673-2.181zM770.05 266.446a3.892 3.892 0 013.47-1.762 4.424 4.424 0 014.494 4.682 4.643 4.643 0 01-4.911 4.721c-3.488 0-5.081-2.54-5.081-6.673 0-3.944 1.422-7.565 5.422-7.565a4.027 4.027 0 014.323 3.564H775.7a2.275 2.275 0 00-2.446-1.991c-1.971 0-3.147 2.01-3.203 5.024zm3.034 6.048a3.09 3.09 0 10-2.844-3.052 2.776 2.776 0 002.844 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="76"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["76"]
                })}
              >
                <path
                  d="M649.565 328.645L651.004 332.316 642.147 332.333 640.707 328.662 649.565 328.645z"
                  className={classes.cls19}
                />
                <path
                  d="M728.883 295.746L730.323 299.417 730.323 305.108 728.883 301.437 728.883 295.746z"
                  className={classes.cls18}
                />
                <path
                  d="M663.964 333.354L665.403 337.025 651.004 337.052 649.565 333.381 663.964 333.354z"
                  className={classes.cls19}
                />
                <path
                  d="M781.507 295.646L782.946 299.317 782.946 305.008 781.507 301.337 781.507 295.646z"
                  className={classes.cls18}
                />
                <path
                  d="M738.177 328.476L739.616 332.147 739.616 341.26 738.177 337.589 738.177 328.476z"
                  className={classes.cls18}
                />
                <path
                  d="M738.177 337.589L739.616 341.26 665.403 341.402 663.964 337.731 738.177 337.589z"
                  className={classes.cls19}
                />
                <path
                  d="M781.507 295.646L781.507 301.337 803.002 301.296 803.002 328.352 738.177 328.476 738.177 337.589 663.964 337.731 663.964 333.354 649.565 333.381 649.565 328.645 640.707 328.662 640.707 301.605 698.134 301.496 698.134 295.805 728.883 295.746 728.883 301.437 750.757 301.395 750.757 295.704 781.507 295.646z"
                  className={classes.barnPath}
                />
                <path
                  d="M803.002 328.352L804.441 332.023 739.616 332.147 738.177 328.476 803.002 328.352z"
                  className={classes.cls19}
                />
                <path
                  d="M803.002 301.296L804.441 304.967 804.441 332.023 803.002 328.352 803.002 301.296z"
                  className={classes.cls18}
                />
                <circle
                  cx="724.678"
                  cy="318.827"
                  r="21.012"
                  className={classes.circle}
                ></circle>
                <path
                  d="M767.055 309.828a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M756.499 322.022h9.688v1.8a16.413 16.413 0 00-5.745 11.945h-2.313a17.036 17.036 0 015.877-11.945H756.5zM768.876 328.373a3.893 3.893 0 013.47-1.762 4.424 4.424 0 014.493 4.683 4.643 4.643 0 01-4.91 4.72c-3.489 0-5.081-2.54-5.081-6.673 0-3.944 1.421-7.565 5.422-7.565a4.027 4.027 0 014.322 3.564h-2.066a2.275 2.275 0 00-2.446-1.991c-1.972 0-3.147 2.01-3.204 5.024zm3.033 6.049a3.09 3.09 0 10-2.844-3.052 2.776 2.776 0 002.844 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="66"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["66"]
                })}
              >
                <path
                  d="M555.413 365.935L556.853 369.606 556.853 375.647 555.413 371.976 555.413 365.935z"
                  className={classes.cls18}
                />
                <path
                  d="M499.862 405.642L501.302 409.313 482.014 409.35 480.575 405.679 499.862 405.642z"
                  className={classes.cls19}
                />
                <path
                  d="M624.539 365.803L625.978 369.474 625.978 375.515 624.539 371.844 624.539 365.803z"
                  className={classes.cls18}
                />
                <path
                  d="M554.182 405.539L555.621 409.21 544.954 409.23 543.515 405.559 554.182 405.539z"
                  className={classes.cls19}
                />
                <path
                  d="M543.515 412.337L544.954 416.008 501.302 416.092 499.862 412.421 543.515 412.337z"
                  className={classes.cls19}
                />
                <path
                  d="M543.515 405.559L544.954 409.23 544.954 416.008 543.515 412.337 543.515 405.559z"
                  className={classes.cls18}
                />
                <path
                  d="M663.928 365.728L665.368 369.399 665.368 375.44 663.928 371.769 663.928 365.728z"
                  className={classes.cls18}
                />
                <path
                  d="M592.756 405.465L594.196 409.136 587.403 409.149 585.964 405.478 592.756 405.465z"
                  className={classes.cls19}
                />
                <path
                  d="M585.964 412.256L587.403 415.927 555.621 415.988 554.182 412.317 585.964 412.256z"
                  className={classes.cls19}
                />
                <path
                  d="M585.964 405.478L587.403 409.149 587.403 415.927 585.964 412.256 585.964 405.478z"
                  className={classes.cls18}
                />
                <path
                  d="M716.618 365.627L718.057 369.299 718.057 375.34 716.618 371.668 716.618 365.627z"
                  className={classes.cls18}
                />
                <path
                  d="M630.924 405.392L632.363 409.063 625.978 409.076 624.539 405.404 630.924 405.392z"
                  className={classes.cls19}
                />
                <path
                  d="M624.539 412.183L625.978 415.854 594.196 415.914 592.756 412.243 624.539 412.183z"
                  className={classes.cls19}
                />
                <path
                  d="M624.539 405.404L625.978 409.076 625.978 415.854 624.539 412.183 624.539 405.404z"
                  className={classes.cls18}
                />
                <path
                  d="M662.697 413.102L664.136 416.774 632.363 416.834 630.924 413.163 662.697 413.102z"
                  className={classes.cls19}
                />
                <path
                  d="M662.697 405.332L664.136 409.003 664.136 416.774 662.697 413.102 662.697 405.332z"
                  className={classes.cls18}
                />
                <path
                  d="M683.765 405.291L685.204 408.963 664.136 409.003 662.697 405.332 683.765 405.291z"
                  className={classes.cls19}
                />
                <path
                  d="M759.986 371.586L761.426 375.257 761.426 380.324 759.986 376.653 759.986 371.586z"
                  className={classes.cls18}
                />
                <path
                  d="M772.709 376.628L774.148 380.3 774.148 389.734 772.709 386.063 772.709 376.628z"
                  className={classes.cls18}
                />
                <path
                  d="M772.709 386.063L774.148 389.734 761.426 389.759 759.986 386.087 772.709 386.063z"
                  className={classes.cls19}
                />
                <path
                  d="M759.986 386.087L761.426 389.759 761.426 394.968 759.986 391.296 759.986 386.087z"
                  className={classes.cls18}
                />
                <path
                  d="M727.162 412.979L728.601 416.651 685.204 416.733 683.765 413.062 727.162 412.979z"
                  className={classes.cls19}
                />
                <path
                  d="M727.162 405.209L728.601 408.88 728.601 416.651 727.162 412.979 727.162 405.209z"
                  className={classes.cls18}
                />
                <path
                  d="M759.986 400.722L761.426 404.393 761.426 408.817 759.986 405.146 759.986 400.722z"
                  className={classes.cls18}
                />
                <path
                  d="M759.986 405.146L761.426 408.817 728.601 408.88 727.162 405.209 759.986 405.146z"
                  className={classes.cls19}
                />
                <path
                  d="M772.709 400.697L774.148 404.369 761.426 404.393 759.986 400.722 772.709 400.697z"
                  className={classes.cls19}
                />
                <path
                  d="M716.618 365.627L716.618 371.668 759.986 371.586 759.986 376.653 772.709 376.628 772.709 386.063 759.986 386.087 759.986 391.296 772.709 391.272 772.709 400.697 759.986 400.722 759.986 405.146 727.162 405.209 727.162 412.979 683.765 413.062 683.765 405.291 662.697 405.332 662.697 413.102 630.924 413.163 630.924 405.392 624.539 405.404 624.539 412.183 592.756 412.243 592.756 405.465 585.964 405.478 585.964 412.256 554.182 412.317 554.182 405.539 543.515 405.559 543.515 412.337 499.862 412.421 499.862 405.642 480.575 405.679 480.575 372.119 513.987 372.055 513.987 366.014 555.413 365.935 555.413 371.976 592.756 371.905 592.756 365.864 624.539 365.803 624.539 371.844 633.965 371.826 633.965 365.785 663.928 365.728 663.928 371.769 679.872 371.738 679.872 365.698 716.618 365.627z"
                  className={classes.barnPath}
                />
                <path
                  d="M772.709 391.272L774.148 394.943 774.148 404.369 772.709 400.697 772.709 391.272z"
                  className={classes.cls18}
                />
                <path
                  d="M654.275 424.337a21.012 21.012 0 1121.012-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M654.275 383.313a20.012 20.012 0 11-20.011 20.012 20.012 20.012 0 0120.011-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M645.463 401.859a3.892 3.892 0 013.47-1.763 4.424 4.424 0 014.493 4.683 4.643 4.643 0 01-4.91 4.721c-3.489 0-5.082-2.54-5.082-6.674 0-3.943 1.422-7.565 5.423-7.565a4.027 4.027 0 014.322 3.564h-2.066a2.275 2.275 0 00-2.446-1.99c-1.972 0-3.147 2.01-3.204 5.024zm3.033 6.048a3.09 3.09 0 10-2.843-3.052 2.776 2.776 0 002.843 3.052zM657.138 401.859a3.892 3.892 0 013.47-1.763 4.424 4.424 0 014.493 4.683 4.643 4.643 0 01-4.91 4.721c-3.489 0-5.082-2.54-5.082-6.674 0-3.943 1.422-7.565 5.423-7.565a4.027 4.027 0 014.322 3.564h-2.066a2.275 2.275 0 00-2.446-1.99c-1.971 0-3.147 2.01-3.204 5.024zm3.034 6.048a3.09 3.09 0 10-2.844-3.052 2.776 2.776 0 002.844 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="56"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["56"]
                })}
              >
                <path
                  d="M548.664 435.084L550.103 438.756 550.103 446.961 548.664 443.29 548.664 435.084z"
                  className={classes.cls18}
                />
                <path
                  d="M513.982 475.432L515.422 479.104 471.902 479.187 470.463 475.515 513.982 475.432z"
                  className={classes.cls19}
                />
                <path
                  d="M536.311 481.799L537.75 485.471 515.422 485.513 513.982 481.842 536.311 481.799z"
                  className={classes.cls19}
                />
                <path
                  d="M536.311 475.39L537.75 479.061 537.75 485.471 536.311 481.799 536.311 475.39z"
                  className={classes.cls18}
                />
                <path
                  d="M556.621 475.351L558.06 479.022 537.75 479.061 536.311 475.39 556.621 475.351z"
                  className={classes.cls19}
                />
                <path
                  d="M691.557 434.812L692.996 438.483 692.996 446.689 691.557 443.018 691.557 434.812z"
                  className={classes.cls18}
                />
                <path
                  d="M624.534 475.222L625.974 478.893 615.657 478.912 614.218 475.241 624.534 475.222z"
                  className={classes.cls19}
                />
                <path
                  d="M614.218 475.241L615.657 478.912 615.657 485.322 614.218 481.651 614.218 475.241z"
                  className={classes.cls18}
                />
                <path
                  d="M614.218 481.651L615.657 485.322 558.06 485.432 556.621 481.761 614.218 481.651z"
                  className={classes.cls19}
                />
                <path
                  d="M646.806 481.589L648.245 485.26 625.974 485.302 624.534 481.631 646.806 481.589z"
                  className={classes.cls19}
                />
                <path
                  d="M646.806 475.179L648.245 478.85 648.245 485.26 646.806 481.589 646.806 475.179z"
                  className={classes.cls18}
                />
                <path
                  d="M669.465 475.136L670.905 478.807 648.245 478.85 646.806 475.179 669.465 475.136z"
                  className={classes.cls19}
                />
                <path
                  d="M723.614 481.442L725.053 485.113 670.905 485.217 669.465 481.545 723.614 481.442z"
                  className={classes.cls19}
                />
                <path
                  d="M723.614 475.033L725.053 478.704 725.053 485.113 723.614 481.442 723.614 475.033z"
                  className={classes.cls18}
                />
                <path
                  d="M691.557 434.812L691.557 443.018 757.964 442.891 757.964 474.967 723.614 475.033 723.614 481.442 669.465 481.545 669.465 475.136 646.806 475.179 646.806 481.589 624.534 481.631 624.534 475.222 614.218 475.241 614.218 481.651 556.621 481.761 556.621 475.351 536.311 475.39 536.311 481.799 513.982 481.842 513.982 475.432 470.463 475.515 470.463 443.439 507.408 443.369 507.408 435.163 548.664 435.084 548.664 443.29 583.269 443.224 583.269 435.018 691.557 434.812z"
                  className={classes.barnPath}
                />
                <path
                  d="M757.964 474.967L759.403 478.638 725.053 478.704 723.614 475.033 757.964 474.967z"
                  className={classes.cls19}
                />
                <path
                  d="M757.964 442.891L759.403 446.562 759.403 478.638 757.964 474.967 757.964 442.891z"
                  className={classes.cls18}
                />
                <path
                  d="M648.787 492.713a21.012 21.012 0 1121.011-21.012 21.036 21.036 0 01-21.011 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M648.787 451.69a20.012 20.012 0 11-20.012 20.011 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M645.795 473.155a2.884 2.884 0 00-2.939-3.128 2.666 2.666 0 00-2.578 1.479l-1.915-.114.91-7.508h8.038v1.8h-6.427l-.455 3.678a4.276 4.276 0 012.901-.948 4.408 4.408 0 014.531 4.721c0 3.11-2.35 4.74-4.986 4.74a4.614 4.614 0 01-4.949-4.342h1.972a2.79 2.79 0 002.996 2.75 2.872 2.872 0 002.9-3.128zM651.555 470.235a3.892 3.892 0 013.469-1.763 4.424 4.424 0 014.494 4.683 4.643 4.643 0 01-4.911 4.721c-3.488 0-5.08-2.54-5.08-6.674 0-3.943 1.42-7.565 5.421-7.565a4.027 4.027 0 014.323 3.564h-2.066a2.275 2.275 0 00-2.446-1.99c-1.972 0-3.147 2.01-3.204 5.024zm3.033 6.048a3.09 3.09 0 10-2.844-3.052 2.776 2.776 0 002.844 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="45"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["45"]
                })}
              >
                <path
                  d="M442.766 507.349L444.206 511.02 444.206 519.821 442.766 516.15 442.766 507.349z"
                  className={classes.cls18}
                />
                <path
                  d="M476.652 509.222L478.091 512.893 478.091 519.757 476.652 516.086 476.652 509.222z"
                  className={classes.cls18}
                />
                <path
                  d="M449.871 549.262L451.311 552.933 363.466 553.101 362.027 549.43 449.871 549.262z"
                  className={classes.cls19}
                />
                <path
                  d="M472.607 549.219L474.046 552.89 474.046 557.834 472.607 554.163 472.607 549.219z"
                  className={classes.cls18}
                />
                <path
                  d="M472.607 554.163L474.046 557.834 451.311 557.878 449.871 554.206 472.607 554.163z"
                  className={classes.cls19}
                />
                <path
                  d="M530.062 549.109L531.501 552.78 474.046 552.89 472.607 549.219 530.062 549.109z"
                  className={classes.cls19}
                />
                <path
                  d="M530.062 515.984L531.501 519.655 531.501 552.78 530.062 549.109 530.062 515.984z"
                  className={classes.cls18}
                />
                <path
                  d="M442.766 507.349L442.766 516.15 453.926 516.129 453.926 509.266 476.652 509.222 476.652 516.086 530.062 515.984 530.062 549.109 472.607 549.219 472.607 554.163 449.871 554.206 449.871 549.262 362.027 549.43 362.027 516.304 387.661 516.255 387.661 507.454 442.766 507.349z"
                  className={classes.barnPath}
                />
                <circle
                  cx="437.771"
                  cy="534.633"
                  r="21.012"
                  className={classes.circle}
                ></circle>
                <path
                  d="M480.149 525.633a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.011 22.012 22.037 22.037 0 00-22.011-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M480.02 548.255h-2.465v3.318h-1.99v-3.318h-6.807v-1.744l6.807-8.683h1.99v8.645h2.465zm-9.081-1.782h4.626v-6.01zM488.889 547.099a2.884 2.884 0 00-2.939-3.128 2.666 2.666 0 00-2.578 1.479l-1.916-.115.91-7.507h8.04v1.8h-6.428l-.455 3.679a4.275 4.275 0 012.901-.948 4.408 4.408 0 014.531 4.72c0 3.11-2.35 4.74-4.986 4.74a4.614 4.614 0 01-4.949-4.342h1.972a2.79 2.79 0 002.996 2.75 2.871 2.871 0 002.9-3.128z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="25"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["25"]
                })}
              >
                <path
                  d="M425.414 661.477L426.854 665.148 426.854 671.898 425.414 668.227 425.414 661.477z"
                  className={classes.cls18}
                />
                <path
                  d="M495.98 661.342L497.419 665.013 497.419 671.763 495.98 668.092 495.98 661.342z"
                  className={classes.cls18}
                />
                <path
                  d="M395.801 707.969L397.241 711.641 342.372 711.745 340.933 708.074 395.801 707.969z"
                  className={classes.cls19}
                />
                <path
                  d="M431.392 707.901L432.831 711.573 420.175 711.597 418.736 707.926 431.392 707.901z"
                  className={classes.cls19}
                />
                <path
                  d="M418.736 707.926L420.175 711.597 420.175 719.32 418.736 715.649 418.736 707.926z"
                  className={classes.cls18}
                />
                <path
                  d="M418.736 715.649L420.175 719.32 397.241 719.364 395.801 715.693 418.736 715.649z"
                  className={classes.cls19}
                />
                <path
                  d="M478.265 715.536L479.705 719.207 432.831 719.296 431.392 715.625 478.265 715.536z"
                  className={classes.cls19}
                />
                <path
                  d="M478.265 707.812L479.705 711.483 479.705 719.207 478.265 715.536 478.265 707.812z"
                  className={classes.cls18}
                />
                <path
                  d="M495.98 661.342L495.98 668.092 515.457 668.055 515.457 707.741 478.265 707.812 478.265 715.536 431.392 715.625 431.392 707.901 418.736 707.926 418.736 715.649 395.801 715.693 395.801 707.969 340.933 708.074 340.933 668.388 390.856 668.292 390.856 661.543 425.414 661.477 425.414 668.227 434.584 668.209 434.584 661.459 495.98 661.342z"
                  className={classes.barnPath}
                />
                <path
                  d="M515.457 707.741L516.896 711.412 479.705 711.483 478.265 707.812 515.457 707.741z"
                  className={classes.cls19}
                />
                <path
                  d="M515.457 668.055L516.896 671.726 516.896 711.412 515.457 707.741 515.457 668.055z"
                  className={classes.cls18}
                />
                <path
                  d="M452.758 722.28a21.012 21.012 0 1121.012-21.01 21.036 21.036 0 01-21.012 21.01z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M452.758 681.257a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M451.596 696.827c0 3.014-3.034 5.764-7.034 8.588h7.394v1.782h-9.953v-1.705c4.72-3.604 7.526-6.067 7.526-8.457a2.165 2.165 0 00-2.407-2.256c-1.404 0-2.769.797-2.769 3.015h-2.01c-.056-2.749 1.897-4.588 4.835-4.588 2.54 0 4.418 1.289 4.418 3.621zM461.128 702.723a2.884 2.884 0 00-2.938-3.128 2.666 2.666 0 00-2.579 1.479l-1.915-.114.91-7.508h8.039v1.8h-6.427l-.455 3.678a4.275 4.275 0 012.9-.948 4.408 4.408 0 014.532 4.721c0 3.11-2.351 4.74-4.986 4.74a4.614 4.614 0 01-4.949-4.342h1.972a2.79 2.79 0 002.996 2.75 2.872 2.872 0 002.9-3.128z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="15"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["15"]
                })}
              >
                <path
                  d="M404.732 742.089L406.171 745.76 406.171 755.251 404.732 751.58 404.732 742.089z"
                  className={classes.cls18}
                />
                <path
                  d="M440.56 742.02L441.999 745.692 441.999 755.183 440.56 751.512 440.56 742.02z"
                  className={classes.cls18}
                />
                <path
                  d="M356.258 791.359L357.697 795.03 333.285 795.077 331.845 791.405 356.258 791.359z"
                  className={classes.cls19}
                />
                <path
                  d="M485.983 741.934L487.423 745.605 487.423 755.096 485.983 751.425 485.983 741.934z"
                  className={classes.cls18}
                />
                <path
                  d="M407.773 798.152L409.212 801.823 406.171 801.829 404.732 798.158 407.773 798.152z"
                  className={classes.cls19}
                />
                <path
                  d="M404.732 800.087L406.171 803.758 357.697 803.85 356.258 800.179 404.732 800.087z"
                  className={classes.cls19}
                />
                <path
                  d="M404.732 798.158L406.171 801.829 406.171 803.758 404.732 800.087 404.732 798.158z"
                  className={classes.cls18}
                />
                <path
                  d="M411.107 798.146L412.547 801.817 409.212 801.823 407.773 798.152 411.107 798.146z"
                  className={classes.cls19}
                />
                <path
                  d="M446.783 798.078L448.223 801.749 412.547 801.817 411.107 798.146 446.783 798.078z"
                  className={classes.cls19}
                />
                <path
                  d="M446.783 791.186L448.223 794.857 448.223 801.749 446.783 798.078 446.783 791.186z"
                  className={classes.cls18}
                />
                <path
                  d="M485.983 741.934L485.983 751.425 511.353 751.377 511.353 791.063 446.783 791.186 446.783 798.078 411.107 798.146 407.773 798.152 404.732 798.158 404.732 800.087 356.258 800.179 356.258 791.359 331.845 791.405 331.845 751.719 356.258 751.673 356.258 742.181 404.732 742.089 404.732 751.58 407.773 751.574 411.107 751.568 413.732 751.563 413.732 742.072 440.56 742.02 440.56 751.512 446.783 751.5 449.587 751.494 449.587 742.003 485.983 741.934z"
                  className={classes.barnPath}
                />
                <path
                  d="M511.353 791.063L512.792 794.734 448.223 794.857 446.783 791.186 511.353 791.063z"
                  className={classes.cls19}
                />
                <path
                  d="M511.353 751.377L512.792 755.048 512.792 794.734 511.353 791.063 511.353 751.377z"
                  className={classes.cls18}
                />
                <path
                  d="M442.632 808.346a21.012 21.012 0 1121.011-21.012 21.036 21.036 0 01-21.011 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M442.631 767.322a20.012 20.012 0 11-20.011 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M436.7 793.262v-10.617h-3.129v-1.346c1.972-.057 2.996-.322 3.698-1.782h1.422v13.745zM448.908 788.788a2.884 2.884 0 00-2.939-3.128 2.666 2.666 0 00-2.578 1.479l-1.915-.115.91-7.507h8.038v1.8h-6.427l-.455 3.678a4.275 4.275 0 012.901-.948 4.408 4.408 0 014.531 4.721c0 3.11-2.35 4.74-4.986 4.74a4.614 4.614 0 01-4.949-4.343h1.972a2.79 2.79 0 002.996 2.75 2.872 2.872 0 002.9-3.127z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="5"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["5"]
                })}
              >
                <path
                  d="M394.285 826.45L395.724 830.121 395.724 840.416 394.285 836.745 394.285 826.45z"
                  className={classes.cls18}
                />
                <path
                  d="M445.601 831.334L447.04 835.005 447.04 840.318 445.601 836.647 445.601 831.334z"
                  className={classes.cls18}
                />
                <path
                  d="M349.704 876.526L351.143 880.197 299.941 880.295 298.501 876.624 349.704 876.526z"
                  className={classes.cls19}
                />
                <path
                  d="M398.178 882.531L399.617 886.202 399.617 889.643 398.178 885.972 398.178 882.531z"
                  className={classes.cls18}
                />
                <path
                  d="M398.178 885.972L399.617 889.643 351.143 889.736 349.704 886.065 398.178 885.972z"
                  className={classes.cls19}
                />
                <path
                  d="M438.875 876.356L440.314 880.027 440.314 886.125 438.875 882.453 438.875 876.356z"
                  className={classes.cls18}
                />
                <path
                  d="M438.875 882.453L440.314 886.125 399.617 886.202 398.178 882.531 438.875 882.453z"
                  className={classes.cls19}
                />
                <path
                  d="M394.285 826.45L394.285 836.745 397.572 836.739 397.572 831.426 445.601 831.334 445.601 836.647 501.682 836.54 501.682 876.236 438.875 876.356 438.875 882.453 398.178 882.531 398.178 885.972 349.704 886.065 349.704 882.623 349.704 876.526 298.501 876.624 298.501 836.928 346.256 836.837 346.256 826.542 394.285 826.45z"
                  className={classes.barnPath}
                />
                <path
                  d="M501.682 876.236L503.121 879.907 440.314 880.027 438.875 876.356 501.682 876.236z"
                  className={classes.cls19}
                />
                <path
                  d="M501.682 836.54L503.121 840.211 503.121 879.907 501.682 876.236 501.682 836.54z"
                  className={classes.cls18}
                />
                <path
                  d="M431.247 890.641a21.012 21.012 0 1121.012-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M431.247 849.617a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M434.092 871.083a2.884 2.884 0 00-2.938-3.128 2.666 2.666 0 00-2.578 1.479l-1.915-.115.91-7.507h8.038v1.8h-6.427l-.455 3.679a4.276 4.276 0 012.901-.948 4.408 4.408 0 014.531 4.72c0 3.11-2.35 4.74-4.986 4.74a4.614 4.614 0 01-4.948-4.342h1.971a2.79 2.79 0 002.996 2.75 2.872 2.872 0 002.9-3.128z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="6"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["6"]
                })}
              >
                <path
                  d="M718.021 826.317L719.46 829.989 719.46 840.284 718.021 836.612 718.021 826.317z"
                  className={classes.cls18}
                />
                <path
                  d="M619.936 876.495L621.375 880.167 563.248 880.277 561.808 876.606 619.936 876.495z"
                  className={classes.cls19}
                />
                <path
                  d="M670.21 876.399L671.649 880.071 647.237 880.117 645.797 876.446 670.21 876.399z"
                  className={classes.cls19}
                />
                <path
                  d="M645.797 876.446L647.237 880.117 647.237 889.656 645.797 885.985 645.797 876.446z"
                  className={classes.cls18}
                />
                <path
                  d="M645.797 885.985L647.237 889.656 621.375 889.705 619.936 886.034 645.797 885.985z"
                  className={classes.cls19}
                />
                <path
                  d="M718.021 885.847L719.46 889.518 671.649 889.609 670.21 885.938 718.021 885.847z"
                  className={classes.cls19}
                />
                <path
                  d="M718.021 876.308L719.46 879.979 719.46 889.518 718.021 885.847 718.021 876.308z"
                  className={classes.cls18}
                />
                <path
                  d="M718.021 826.317L718.021 836.612 746.848 836.557 746.848 876.253 718.021 876.308 718.021 885.847 670.21 885.938 670.21 876.399 645.797 876.446 645.797 885.985 619.936 886.034 619.936 876.495 561.808 876.606 561.808 836.91 622.408 836.795 622.408 826.5 718.021 826.317z"
                  className={classes.barnPath}
                />
                <path
                  d="M746.848 876.253L748.287 879.924 719.46 879.979 718.021 876.308 746.848 876.253z"
                  className={classes.cls19}
                />
                <path
                  d="M746.848 836.557L748.287 840.229 748.287 879.924 746.848 876.253 746.848 836.557z"
                  className={classes.cls18}
                />
                <path
                  d="M709.025 890.641a21.012 21.012 0 1121.012-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M709.025 849.617a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M706.05 868.163a3.892 3.892 0 013.47-1.763 4.424 4.424 0 014.494 4.683 4.643 4.643 0 01-4.911 4.72c-3.488 0-5.081-2.54-5.081-6.673 0-3.943 1.422-7.565 5.422-7.565a4.027 4.027 0 014.323 3.564H711.7a2.275 2.275 0 00-2.446-1.99c-1.971 0-3.147 2.01-3.204 5.024zm3.033 6.048a3.09 3.09 0 10-2.843-3.052 2.776 2.776 0 002.844 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="1C"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["1C"]
                })}
              >
                <path
                  d="M629.541 915.342L630.98 919.013 630.98 929.034 629.541 925.362 629.541 915.342z"
                  className={classes.cls18}
                />
                <path
                  d="M660.025 918.101L661.465 921.772 661.465 928.975 660.025 925.304 660.025 918.101z"
                  className={classes.cls18}
                />
                <path
                  d="M734.626 913.345L736.066 917.016 736.066 928.833 734.626 925.162 734.626 913.345z"
                  className={classes.cls18}
                />
                <path
                  d="M777.047 914.625L778.487 918.296 778.487 928.752 777.047 925.081 777.047 914.625z"
                  className={classes.cls18}
                />
                <path
                  d="M833.271 917.77L834.71 921.441 834.71 928.645 833.271 924.974 833.271 917.77z"
                  className={classes.cls18}
                />
                <path
                  d="M913.679 914.365L915.118 918.036 915.118 928.492 913.679 924.82 913.679 914.365z"
                  className={classes.cls18}
                />
                <path
                  d="M954.148 918.617L955.588 922.288 955.588 928.414 954.148 924.743 954.148 918.617z"
                  className={classes.cls18}
                />
                <path
                  d="M1038.876 914.126L1040.316 917.797 1040.316 928.253 1038.876 924.581 1038.876 914.126z"
                  className={classes.cls18}
                />
                <path
                  d="M1052.764 924.555L1054.203 928.226 1054.203 949.138 1052.764 945.466 1052.764 924.555z"
                  className={classes.cls18}
                />
                <path
                  d="M1052.764 945.466L1054.203 949.138 556.246 950.088 554.807 946.416 1052.764 945.466z"
                  className={classes.cls19}
                />
                <path
                  d="M734.626 913.345L734.626 925.162 757.656 925.118 757.656 914.662 777.047 914.625 777.047 925.081 813.879 925.011 813.879 917.807 833.271 917.77 833.271 924.974 854.898 924.932 854.898 914.477 913.679 914.365 913.679 924.82 935.846 924.778 935.846 918.652 954.148 918.617 954.148 924.743 980.664 924.693 980.664 914.237 1038.876 914.126 1038.876 924.581 1052.764 924.555 1052.764 945.466 554.807 946.416 554.807 925.505 570.769 925.475 570.769 915.454 629.541 915.342 629.541 925.362 637.593 925.347 637.593 918.143 660.025 918.101 660.025 925.304 682.41 925.262 682.41 913.445 734.626 913.345z"
                  className={classes.barnPath}
                />
                <path
                  d="M924.494 965.377a21.012 21.012 0 1121.012-21.012 21.035 21.035 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M924.494 924.353a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M917.426 950.293v-10.617h-3.129v-1.346c1.972-.057 2.996-.322 3.697-1.782h1.423v13.745zM934.183 945.819a5.624 5.624 0 01-5.933 4.721c-3.982 0-6.295-2.92-6.295-7.148 0-4.304 2.484-7.09 6.428-7.09a5.514 5.514 0 015.744 4.72h-2.086a3.59 3.59 0 00-3.753-2.92c-2.332 0-4.115 1.859-4.115 5.29 0 3.394 1.764 5.346 4.134 5.346a3.6 3.6 0 003.791-2.919z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="7"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["7"]
                })}
              >
                <path
                  d="M963.021 827.672L964.46 831.343 964.46 840.022 963.021 836.35 963.021 827.672z"
                  className={classes.cls18}
                />
                <path
                  d="M903.387 876.67L904.827 880.342 805.785 880.531 804.345 876.859 903.387 876.67z"
                  className={classes.cls19}
                />
                <path
                  d="M927.563 876.624L929.002 880.296 929.002 888.161 927.563 884.49 927.563 876.624z"
                  className={classes.cls18}
                />
                <path
                  d="M927.563 884.49L929.002 888.161 904.827 888.207 903.387 884.536 927.563 884.49z"
                  className={classes.cls19}
                />
                <path
                  d="M963.021 827.672L963.021 836.35 987.291 836.304 987.291 876.51 927.563 876.624 927.563 884.49 903.387 884.536 903.387 876.67 804.345 876.859 804.345 836.653 868.081 836.532 868.081 827.853 963.021 827.672z"
                  className={classes.barnPath}
                />
                <path
                  d="M987.291 836.304L988.731 839.975 988.731 880.182 987.291 876.51 987.291 836.304z"
                  className={classes.cls18}
                />
                <path
                  d="M987.291 876.51L988.731 880.182 929.002 880.296 927.563 876.624 987.291 876.51z"
                  className={classes.cls19}
                />
                <path
                  d="M931.705 890.641a21.012 21.012 0 1121.012-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M931.705 849.617a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M926.9 861.812h9.688v1.8a16.413 16.413 0 00-5.744 11.945h-2.313a17.035 17.035 0 015.877-11.944H926.9z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="17"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["17"]
                })}
              >
                <path
                  d="M843.328 791.337L844.767 795.008 808.618 795.077 807.178 791.406 843.328 791.337z"
                  className={classes.cls19}
                />
                <path
                  d="M960.047 743.751L961.486 747.423 961.486 756.914 960.047 753.243 960.047 743.751z"
                  className={classes.cls18}
                />
                <path
                  d="M925.792 791.18L927.231 794.851 927.231 802.943 925.792 799.272 925.792 791.18z"
                  className={classes.cls18}
                />
                <path
                  d="M925.792 799.272L927.231 802.943 844.767 803.1 843.328 799.429 925.792 799.272z"
                  className={classes.cls19}
                />
                <path
                  d="M960.047 743.751L960.047 753.243 985.624 753.194 985.624 791.065 925.792 791.18 925.792 799.272 843.328 799.429 843.328 791.337 807.178 791.406 807.178 753.535 877.583 753.4 877.583 743.909 960.047 743.751z"
                  className={classes.barnPath}
                />
                <path
                  d="M985.624 753.194L987.064 756.865 987.064 794.737 985.624 791.065 985.624 753.194z"
                  className={classes.cls18}
                />
                <path
                  d="M985.624 791.065L987.064 794.737 927.231 794.851 925.792 791.18 985.624 791.065z"
                  className={classes.cls19}
                />
                <path
                  d="M930.631 808.346a21.012 21.012 0 1121.013-21.012 21.036 21.036 0 01-21.013 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M930.632 767.322a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M925.563 793.262v-10.617h-3.129v-1.346c1.972-.057 2.996-.322 3.697-1.782h1.423v13.745zM929.257 779.517h9.689v1.8a16.414 16.414 0 00-5.745 11.945h-2.313a17.036 17.036 0 015.877-11.945h-7.508z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="16"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["16"]
                })}
              >
                <path
                  d="M629.317 741.266L630.757 744.938 630.757 755.28 629.317 751.609 629.317 741.266z"
                  className={classes.cls18}
                />
                <path
                  d="M663.013 741.202L664.453 744.873 664.453 755.216 663.013 751.544 663.013 741.202z"
                  className={classes.cls18}
                />
                <path
                  d="M721.776 741.09L723.215 744.761 723.215 755.103 721.776 751.432 721.776 741.09z"
                  className={classes.cls18}
                />
                <path
                  d="M626.286 791.301L627.725 794.972 568.272 795.085 566.832 791.414 626.286 791.301z"
                  className={classes.cls19}
                />
                <path
                  d="M746.851 751.384L748.29 755.056 748.29 772.734 746.851 769.063 746.851 751.384z"
                  className={classes.cls18}
                />
                <path
                  d="M759.081 781.565L760.52 785.237 748.29 785.26 746.851 781.589 759.081 781.565z"
                  className={classes.cls19}
                />
                <path
                  d="M759.081 769.039L760.52 772.711 760.52 785.237 759.081 781.565 759.081 769.039z"
                  className={classes.cls18}
                />
                <path
                  d="M722.922 791.116L724.361 794.788 724.361 801.679 722.922 798.008 722.922 791.116z"
                  className={classes.cls18}
                />
                <path
                  d="M722.922 798.008L724.361 801.679 627.725 801.864 626.286 798.192 722.922 798.008z"
                  className={classes.cls19}
                />
                <path
                  d="M746.851 791.071L748.29 794.742 724.361 794.788 722.922 791.116 746.851 791.071z"
                  className={classes.cls19}
                />
                <path
                  d="M746.851 781.589L748.29 785.26 748.29 794.742 746.851 791.071 746.851 781.589z"
                  className={classes.cls18}
                />
                <path
                  d="M721.776 741.09L721.776 751.432 746.851 751.384 746.851 769.063 759.081 769.039 759.081 781.565 746.851 781.589 746.851 791.071 722.922 791.116 722.922 798.008 626.286 798.192 626.286 791.301 566.832 791.414 566.832 751.728 595.82 751.673 595.82 741.33 629.317 741.266 629.317 751.609 643.849 751.581 643.849 741.239 663.013 741.202 663.013 751.544 678.578 751.515 678.578 741.172 721.776 741.09z"
                  className={classes.barnPath}
                />
                <path
                  d="M707.988 808.346A21.012 21.012 0 11729 787.334a21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M707.988 767.322a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2A22.012 22.012 0 10730 787.334a22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M701.962 793.262v-10.617h-3.129v-1.346c1.972-.057 2.996-.322 3.697-1.782h1.423v13.745zM708.444 785.868a3.893 3.893 0 013.47-1.763 4.424 4.424 0 014.493 4.683 4.643 4.643 0 01-4.91 4.72c-3.489 0-5.081-2.54-5.081-6.673 0-3.943 1.421-7.565 5.422-7.565a4.027 4.027 0 014.322 3.564h-2.066a2.275 2.275 0 00-2.446-1.99c-1.972 0-3.147 2.01-3.204 5.024zm3.033 6.048a3.09 3.09 0 10-2.844-3.052 2.776 2.776 0 002.844 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="26"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["26"]
                })}
              >
                <path
                  d="M608.658 705.29L610.097 708.962 573.152 709.032 571.713 705.361 608.658 705.29z"
                  className={classes.cls19}
                />
                <path
                  d="M726.343 658.705L727.783 662.376 727.783 670.44 726.343 666.769 726.343 658.705z"
                  className={classes.cls18}
                />
                <path
                  d="M666.444 705.18L667.884 708.851 656.971 708.872 655.531 705.201 666.444 705.18z"
                  className={classes.cls19}
                />
                <path
                  d="M655.531 713.18L656.971 716.851 610.097 716.94 608.658 713.269 655.531 713.18z"
                  className={classes.cls19}
                />
                <path
                  d="M655.531 705.201L656.971 708.872 656.971 716.851 655.531 713.18 655.531 705.201z"
                  className={classes.cls18}
                />
                <path
                  d="M762.739 666.7L764.178 670.371 764.178 687.482 762.739 683.811 762.739 666.7z"
                  className={classes.cls18}
                />
                <path
                  d="M762.739 683.811L764.178 687.482 753.597 687.502 752.158 683.831 762.739 683.811z"
                  className={classes.cls19}
                />
                <path
                  d="M690.724 705.134L692.163 708.805 692.163 716.784 690.724 713.113 690.724 705.134z"
                  className={classes.cls18}
                />
                <path
                  d="M690.724 713.113L692.163 716.784 667.884 716.83 666.444 713.159 690.724 713.113z"
                  className={classes.cls19}
                />
                <path
                  d="M726.343 658.705L726.343 666.769 762.739 666.7 762.739 683.811 752.158 683.831 752.158 705.017 690.724 705.134 690.724 713.113 666.444 713.159 666.444 705.18 655.531 705.201 655.531 713.18 608.658 713.269 608.658 705.29 571.713 705.361 571.713 671.129 622.413 671.033 622.413 658.904 726.343 658.705z"
                  className={classes.barnPath}
                />
                <path
                  d="M752.158 705.017L753.597 708.688 692.163 708.805 690.724 705.134 752.158 705.017z"
                  className={classes.cls19}
                />
                <path
                  d="M752.158 683.831L753.597 687.502 753.597 708.688 752.158 705.017 752.158 683.831z"
                  className={classes.cls18}
                />
                <circle
                  cx="665.161"
                  cy="690.257"
                  r="21.012"
                  className={classes.circle}
                ></circle>
                <path
                  d="M707.539 681.257a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M706.281 696.827c0 3.014-3.033 5.764-7.033 8.588h7.393v1.782h-9.953v-1.705c4.721-3.604 7.527-6.067 7.527-8.457a2.165 2.165 0 00-2.408-2.256c-1.403 0-2.768.797-2.768 3.015h-2.01c-.057-2.749 1.896-4.588 4.834-4.588 2.541 0 4.418 1.289 4.418 3.621zM710.088 699.803a3.892 3.892 0 013.47-1.762 4.424 4.424 0 014.493 4.682 4.643 4.643 0 01-4.91 4.721c-3.489 0-5.08-2.54-5.08-6.673 0-3.944 1.42-7.565 5.421-7.565a4.027 4.027 0 014.323 3.564h-2.067a2.275 2.275 0 00-2.446-1.991c-1.971 0-3.147 2.01-3.204 5.024zm3.034 6.048a3.09 3.09 0 10-2.844-3.052 2.776 2.776 0 002.844 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="36"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["36"]
                })}
              >
                <path
                  d="M660.599 582.554L662.038 586.225 662.038 595.169 660.599 591.497 660.599 582.554z"
                  className={classes.cls18}
                />
                <path
                  d="M602.709 625.839L604.148 629.511 582.161 629.553 580.721 625.881 602.709 625.839z"
                  className={classes.cls19}
                />
                <path
                  d="M694.693 582.489L696.132 586.16 696.132 595.104 694.693 591.432 694.693 582.489z"
                  className={classes.cls18}
                />
                <path
                  d="M727.555 582.427L728.995 586.098 728.995 595.041 727.555 591.37 727.555 582.427z"
                  className={classes.cls18}
                />
                <path
                  d="M699.306 634.872L700.746 638.544 604.148 638.728 602.709 635.057 699.306 634.872z"
                  className={classes.cls19}
                />
                <path
                  d="M727.555 625.601L728.995 629.272 728.995 638.49 727.555 634.819 727.555 625.601z"
                  className={classes.cls18}
                />
                <path
                  d="M752.157 591.323L753.597 594.994 753.597 629.226 752.157 625.554 752.157 591.323z"
                  className={classes.cls18}
                />
                <path
                  d="M752.157 625.554L753.597 629.226 728.995 629.272 727.555 625.601 752.157 625.554z"
                  className={classes.cls19}
                />
                <path
                  d="M727.555 634.819L728.995 638.49 728.995 643.009 727.555 639.337 727.555 634.819z"
                  className={classes.cls18}
                />
                <path
                  d="M727.555 582.427L727.555 591.37 752.157 591.323 752.157 625.554 727.555 625.601 727.555 634.819 727.555 639.337 699.306 639.391 699.306 634.872 602.709 635.057 602.709 625.839 580.721 625.881 580.721 591.65 616.918 591.581 616.918 582.638 660.599 582.554 660.599 591.497 675.917 591.468 675.917 582.525 694.693 582.489 694.693 591.432 718.291 591.387 718.291 582.444 727.555 582.427z"
                  className={classes.barnPath}
                />
                <path
                  d="M727.555 639.337L728.995 643.009 700.746 643.062 699.306 639.391 727.555 639.337z"
                  className={classes.cls19}
                />
                <path
                  d="M707.219 646.035a21.012 21.012 0 1121.012-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M707.219 605.01a20.012 20.012 0 11-20.012 20.013 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M704.151 627.102c0-1.896-1.593-2.503-3.716-2.503h-.474v-1.724h.398c2.332 0 3.432-.683 3.432-2.2 0-1.44-1.157-2.143-2.54-2.143a2.745 2.745 0 00-2.901 2.655h-1.972c.208-2.521 2.01-4.228 4.967-4.228 2.332 0 4.512.967 4.512 3.545a3.36 3.36 0 01-2.142 3.148 3.385 3.385 0 012.503 3.412c0 2.788-2.389 4.134-5.062 4.134a4.57 4.57 0 01-4.968-4.4h1.972a2.903 2.903 0 003.033 2.807c1.726 0 2.958-.892 2.958-2.503zM709.873 623.556a3.893 3.893 0 013.47-1.762 4.424 4.424 0 014.494 4.683 4.643 4.643 0 01-4.911 4.72c-3.489 0-5.08-2.54-5.08-6.673 0-3.943 1.42-7.565 5.421-7.565a4.027 4.027 0 014.323 3.564h-2.067a2.275 2.275 0 00-2.445-1.99c-1.973 0-3.148 2.01-3.205 5.023zm3.033 6.049a3.09 3.09 0 10-2.843-3.052 2.776 2.776 0 002.843 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="27"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["27"]
                })}
              >
                <path
                  d="M878.786 660.752L880.225 664.423 880.225 672.827 878.786 669.156 878.786 660.752z"
                  className={classes.cls18}
                />
                <path
                  d="M831.979 707.117L833.418 710.788 808.618 710.835 807.178 707.164 831.979 707.117z"
                  className={classes.cls19}
                />
                <path
                  d="M960.047 658.697L961.486 662.368 961.486 664.268 960.047 660.597 960.047 658.697z"
                  className={classes.cls18}
                />
                <path
                  d="M960.047 660.597L961.486 664.268 961.486 672.672 960.047 669.001 960.047 660.597z"
                  className={classes.cls18}
                />
                <path
                  d="M924.806 713.103L926.246 716.775 833.418 716.952 831.979 713.28 924.806 713.103z"
                  className={classes.cls19}
                />
                <path
                  d="M924.806 706.94L926.246 710.611 926.246 716.775 924.806 713.103 924.806 706.94z"
                  className={classes.cls18}
                />
                <path
                  d="M985.624 706.823L987.064 710.495 926.246 710.611 924.806 706.94 985.624 706.823z"
                  className={classes.cls19}
                />
                <path
                  d="M985.624 668.952L987.064 672.624 987.064 710.495 985.624 706.823 985.624 668.952z"
                  className={classes.cls18}
                />
                <path
                  d="M960.047 658.697L960.047 660.597 960.047 669.001 985.624 668.952 985.624 706.823 924.806 706.94 924.806 713.103 831.979 713.28 831.979 707.117 807.178 707.164 807.178 669.293 830.473 669.248 830.473 660.844 878.786 660.752 878.786 669.156 887.245 669.14 887.245 660.736 925.792 660.662 925.792 658.762 960.047 658.697z"
                  className={classes.barnPath}
                />
                <path
                  d="M929.94 722.28a21.012 21.012 0 1121.012-21.01 21.035 21.035 0 01-21.012 21.01z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M929.94 681.257a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M929.64 696.827c0 3.014-3.034 5.764-7.034 8.588H930v1.782h-9.953v-1.705c4.72-3.604 7.527-6.067 7.527-8.457a2.165 2.165 0 00-2.408-2.256c-1.403 0-2.768.797-2.768 3.015h-2.01c-.057-2.749 1.896-4.588 4.834-4.588 2.541 0 4.418 1.289 4.418 3.621zM930.66 693.452h9.689v1.8a16.414 16.414 0 00-5.746 11.945h-2.312a17.036 17.036 0 015.877-11.945h-7.508z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="37"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["37"]
                })}
              >
                <path
                  d="M878.785 581.25L880.225 584.921 880.225 588.438 878.785 584.766 878.785 581.25z"
                  className={classes.cls18}
                />
                <path
                  d="M914.092 581.182L915.531 584.854 915.531 593.768 914.092 590.097 914.092 581.182z"
                  className={classes.cls18}
                />
                <path
                  d="M843.706 630.438L845.146 634.109 808.807 634.178 807.367 630.507 843.706 630.438z"
                  className={classes.cls19}
                />
                <path
                  d="M937.387 630.259L938.826 633.93 938.826 642.854 937.387 639.183 937.387 630.259z"
                  className={classes.cls18}
                />
                <path
                  d="M937.387 639.183L938.826 642.854 845.146 643.033 843.706 639.362 937.387 639.183z"
                  className={classes.cls19}
                />
                <path
                  d="M983.682 589.964L985.121 593.636 985.121 633.842 983.682 630.171 983.682 589.964z"
                  className={classes.cls18}
                />
                <path
                  d="M983.682 630.171L985.121 633.842 938.826 633.93 937.387 630.259 983.682 630.171z"
                  className={classes.cls19}
                />
                <path
                  d="M914.092 581.182L914.092 590.097 983.682 589.964 983.682 630.171 937.387 630.259 937.387 639.183 843.706 639.362 843.706 630.438 807.367 630.507 807.367 590.301 831.979 590.254 831.979 581.339 878.785 581.25 878.785 584.766 885.938 584.753 885.938 581.236 914.092 581.182z"
                  className={classes.barnPath}
                />
                <path
                  d="M929.863 646.035a21.012 21.012 0 1121.012-21.012 21.035 21.035 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M929.863 605.01a20.012 20.012 0 11-20.012 20.013 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M927.753 627.102c0-1.896-1.593-2.503-3.717-2.503h-.474v-1.724h.399c2.331 0 3.431-.683 3.431-2.2 0-1.44-1.156-2.143-2.54-2.143a2.745 2.745 0 00-2.9 2.655h-1.972c.208-2.521 2.01-4.228 4.967-4.228 2.332 0 4.512.967 4.512 3.545a3.36 3.36 0 01-2.142 3.148 3.385 3.385 0 012.502 3.412c0 2.788-2.388 4.134-5.062 4.134a4.57 4.57 0 01-4.967-4.4h1.972a2.903 2.903 0 003.033 2.807c1.725 0 2.958-.892 2.958-2.503zM930.687 617.206h9.689v1.8a16.413 16.413 0 00-5.745 11.945h-2.313a17.036 17.036 0 015.877-11.945h-7.508z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="46"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["46"]
                })}
              >
                <path
                  d="M687.495 508.321L688.935 511.993 688.935 519.234 687.495 515.563 687.495 508.321z"
                  className={classes.cls18}
                />
                <path
                  d="M640.471 549.884L641.91 553.555 589.931 553.654 588.491 549.983 640.471 549.884z"
                  className={classes.cls19}
                />
                <path
                  d="M730.996 508.238L732.436 511.91 732.436 519.151 730.996 515.48 730.996 508.238z"
                  className={classes.cls18}
                />
                <path
                  d="M720.642 558.835L722.081 562.506 641.91 562.659 640.471 558.988 720.642 558.835z"
                  className={classes.cls19}
                />
                <path
                  d="M720.642 556.576L722.081 560.247 722.081 562.506 720.642 558.835 720.642 556.576z"
                  className={classes.cls18}
                />
                <path
                  d="M732.862 556.552L734.302 560.223 722.081 560.247 720.642 556.576 732.862 556.552z"
                  className={classes.cls19}
                />
                <path
                  d="M732.862 549.708L734.302 553.379 734.302 560.223 732.862 556.552 732.862 549.708z"
                  className={classes.cls18}
                />
                <path
                  d="M730.996 508.238L730.996 515.48 754.632 515.435 754.632 549.666 732.862 549.708 732.862 556.552 720.642 556.576 720.642 558.835 640.471 558.988 640.471 556.729 640.471 549.884 588.491 549.983 588.491 515.752 608.66 515.713 608.66 508.472 687.495 508.321 687.495 515.563 696.561 515.546 696.561 508.304 730.996 508.238z"
                  className={classes.barnPath}
                />
                <path
                  d="M754.632 549.666L756.071 553.337 734.302 553.379 732.862 549.708 754.632 549.666z"
                  className={classes.cls19}
                />
                <path
                  d="M754.632 515.435L756.071 519.106 756.071 553.337 754.632 549.666 754.632 515.435z"
                  className={classes.cls18}
                />
                <circle
                  cx="664.865"
                  cy="534.633"
                  r="21.012"
                  className={classes.circle}
                ></circle>
                <path
                  d="M707.242 525.633a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M707.018 548.255h-2.464v3.318h-1.99v-3.318h-6.807v-1.744l6.807-8.683h1.99v8.645h2.464zm-9.08-1.782h4.625v-6.01zM710.162 544.179a3.892 3.892 0 013.47-1.763 4.424 4.424 0 014.493 4.683 4.643 4.643 0 01-4.91 4.72c-3.49 0-5.081-2.54-5.081-6.673 0-3.943 1.421-7.565 5.422-7.565a4.027 4.027 0 014.322 3.564h-2.066a2.275 2.275 0 00-2.446-1.99c-1.972 0-3.147 2.01-3.204 5.024zm3.033 6.048a3.09 3.09 0 10-2.843-3.052 2.776 2.776 0 002.843 3.052z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="47"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["47"]
                })}
              >
                <path
                  d="M867.291 549.857L868.73 553.529 793.049 553.673 791.61 550.002 867.291 549.857z"
                  className={classes.cls19}
                />
                <path
                  d="M955.268 508.217L956.708 511.888 956.708 519.205 955.268 515.534 955.268 508.217z"
                  className={classes.cls18}
                />
                <path
                  d="M900.438 549.794L901.877 553.465 891.712 553.485 890.273 549.814 900.438 549.794z"
                  className={classes.cls19}
                />
                <path
                  d="M890.273 549.814L891.712 553.485 891.712 560.235 890.273 556.564 890.273 549.814z"
                  className={classes.cls18}
                />
                <path
                  d="M890.273 556.564L891.712 560.235 868.73 560.279 867.291 556.607 890.273 556.564z"
                  className={classes.cls19}
                />
                <path
                  d="M945.378 556.458L946.818 560.13 901.877 560.215 900.438 556.544 945.378 556.458z"
                  className={classes.cls19}
                />
                <path
                  d="M945.378 549.708L946.818 553.38 946.818 560.13 945.378 556.458 945.378 549.708z"
                  className={classes.cls18}
                />
                <path
                  d="M955.268 508.217L955.268 515.534 980.259 515.486 980.259 549.642 945.378 549.708 945.378 556.458 900.438 556.544 900.438 549.794 890.273 549.814 890.273 556.564 867.291 556.607 867.291 549.857 791.61 550.002 791.61 515.846 834.94 515.763 834.94 508.446 955.268 508.217z"
                  className={classes.barnPath}
                />
                <path
                  d="M980.259 549.642L981.698 553.313 946.818 553.38 945.378 549.708 980.259 549.642z"
                  className={classes.cls19}
                />
                <path
                  d="M980.259 515.486L981.698 519.157 981.698 553.313 980.259 549.642 980.259 515.486z"
                  className={classes.cls18}
                />
                <path
                  d="M929.886 566.657a21.012 21.012 0 1121.012-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M929.886 525.633a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M930.62 548.255h-2.466v3.318h-1.99v-3.318h-6.806v-1.744l6.807-8.683h1.99v8.645h2.464zm-9.082-1.782h4.626v-6.01zM930.976 537.828h9.688v1.8a16.413 16.413 0 00-5.745 11.945h-2.313a17.036 17.036 0 015.878-11.944h-7.508z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="57"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["57"]
                })}
              >
                <path
                  d="M877.583 436.376L879.022 440.047 879.022 447.364 877.583 443.693 877.583 436.376z"
                  className={classes.cls18}
                />
                <path
                  d="M909.858 436.315L911.297 439.986 911.297 447.303 909.858 443.632 909.858 436.315z"
                  className={classes.cls18}
                />
                <path
                  d="M834.944 475.359L836.383 479.03 814.879 479.071 813.44 475.4 834.944 475.359z"
                  className={classes.cls19}
                />
                <path
                  d="M955.272 436.228L956.711 439.899 956.711 447.216 955.272 443.545 955.272 436.228z"
                  className={classes.cls18}
                />
                <path
                  d="M880.065 478.251L881.504 481.922 881.504 484.9 880.065 481.229 880.065 478.251z"
                  className={classes.cls18}
                />
                <path
                  d="M880.065 481.229L881.504 484.9 836.383 484.986 834.944 481.315 880.065 481.229z"
                  className={classes.cls19}
                />
                <path
                  d="M922.817 478.169L924.256 481.841 881.504 481.922 880.065 478.251 922.817 478.169z"
                  className={classes.cls19}
                />
                <path
                  d="M955.272 481.085L956.711 484.757 924.256 484.819 922.817 481.147 955.272 481.085z"
                  className={classes.cls19}
                />
                <path
                  d="M955.272 478.107L956.711 481.779 956.711 484.757 955.272 481.085 955.272 478.107z"
                  className={classes.cls18}
                />
                <path
                  d="M967.606 478.084L969.046 481.755 956.711 481.779 955.272 478.107 967.606 478.084z"
                  className={classes.cls19}
                />
                <path
                  d="M967.606 475.106L969.046 478.777 969.046 481.755 967.606 478.084 967.606 475.106z"
                  className={classes.cls18}
                />
                <path
                  d="M955.272 436.228L955.272 443.545 978.898 443.5 978.898 475.085 967.606 475.106 967.606 478.084 955.272 478.107 955.272 481.085 922.817 481.147 922.817 478.169 880.065 478.251 880.065 481.229 834.944 481.315 834.944 475.359 813.44 475.4 813.44 443.816 837.918 443.769 837.918 436.452 877.583 436.376 877.583 443.693 890.277 443.669 890.277 436.352 909.858 436.315 909.858 443.632 923.622 443.605 923.622 436.288 955.272 436.228z"
                  className={classes.barnPath}
                />
                <path
                  d="M978.898 475.085L980.338 478.756 969.046 478.777 967.606 475.106 978.898 475.085z"
                  className={classes.cls19}
                />
                <path
                  d="M978.898 443.5L980.338 447.171 980.338 478.756 978.898 475.085 978.898 443.5z"
                  className={classes.cls18}
                />
                <path
                  d="M929.867 492.714a21.012 21.012 0 1121.012-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M929.867 451.69a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M927.832 473.156a2.884 2.884 0 00-2.938-3.128 2.666 2.666 0 00-2.579 1.478l-1.915-.114.91-7.507h8.039v1.8h-6.427l-.455 3.678a4.276 4.276 0 012.9-.948 4.408 4.408 0 014.532 4.72c0 3.11-2.351 4.74-4.986 4.74a4.614 4.614 0 01-4.949-4.342h1.972a2.79 2.79 0 002.995 2.75 2.872 2.872 0 002.901-3.127zM930.805 463.885h9.689v1.8a16.414 16.414 0 00-5.746 11.944h-2.312a17.036 17.036 0 015.877-11.944h-7.508z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="67"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["67"]
                })}
              >
                <path
                  d="M867.266 405.452L868.705 409.124 814.878 409.226 813.439 405.555 867.266 405.452z"
                  className={classes.cls19}
                />
                <path
                  d="M951.927 367.202L953.367 370.873 953.367 377.387 951.927 373.716 951.927 367.202z"
                  className={classes.cls18}
                />
                <path
                  d="M900.062 405.39L901.501 409.061 890.162 409.083 888.722 405.412 900.062 405.39z"
                  className={classes.cls19}
                />
                <path
                  d="M888.722 405.412L890.162 409.083 890.162 415.861 888.722 412.19 888.722 405.412z"
                  className={classes.cls18}
                />
                <path
                  d="M888.722 412.19L890.162 415.861 868.705 415.902 867.266 412.231 888.722 412.19z"
                  className={classes.cls19}
                />
                <path
                  d="M942.502 412.087L943.941 415.758 901.501 415.839 900.062 412.168 942.502 412.087z"
                  className={classes.cls19}
                />
                <path
                  d="M942.502 405.309L943.941 408.98 943.941 415.758 942.502 412.087 942.502 405.309z"
                  className={classes.cls18}
                />
                <path
                  d="M951.927 367.202L951.927 373.716 975.004 373.672 975.004 405.247 942.502 405.309 942.502 412.087 900.062 412.168 900.062 405.39 888.722 405.412 888.722 412.19 867.266 412.231 867.266 405.452 813.439 405.555 813.439 373.98 834.943 373.939 834.943 367.425 951.927 367.202z"
                  className={classes.barnPath}
                />
                <path
                  d="M975.004 405.247L976.443 408.918 943.941 408.98 942.502 405.309 975.004 405.247z"
                  className={classes.cls19}
                />
                <path
                  d="M975.004 373.672L976.443 377.343 976.443 408.918 975.004 405.247 975.004 373.672z"
                  className={classes.cls18}
                />
                <path
                  d="M929.906 424.338a21.012 21.012 0 1121.014-21.012 21.037 21.037 0 01-21.014 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M929.907 383.314a20.012 20.012 0 11-20.014 20.012 20.013 20.013 0 0120.014-20.012m0-2a22.012 22.012 0 1022.013 22.012 22.038 22.038 0 00-22.014-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M922.05 401.86a3.89 3.89 0 013.47-1.764 4.425 4.425 0 014.493 4.684 4.643 4.643 0 01-4.91 4.72c-3.489 0-5.08-2.54-5.08-6.674 0-3.943 1.42-7.564 5.421-7.564a4.027 4.027 0 014.323 3.564H927.7a2.274 2.274 0 00-2.446-1.99c-1.971 0-3.147 2.01-3.204 5.024zm3.033 6.048a3.09 3.09 0 10-2.843-3.053 2.776 2.776 0 002.843 3.053zM930.94 395.509h9.688v1.801a16.412 16.412 0 00-5.745 11.944h-2.313a17.034 17.034 0 015.877-11.944h-7.508z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="77"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["77"]
                })}
              >
                <path
                  d="M898.248 329.84L899.688 333.511 856.49 333.594 855.051 329.923 898.248 329.84z"
                  className={classes.cls19}
                />
                <path
                  d="M991.417 294.381L992.856 298.053 992.856 303.744 991.417 300.072 991.417 294.381z"
                  className={classes.cls18}
                />
                <path
                  d="M939.229 329.762L940.669 333.433 931.792 333.45 930.353 329.779 939.229 329.762z"
                  className={classes.cls19}
                />
                <path
                  d="M930.353 329.779L931.792 333.45 931.792 341.041 930.353 337.37 930.353 329.779z"
                  className={classes.cls18}
                />
                <path
                  d="M930.353 337.37L931.792 341.041 899.688 341.103 898.248 337.431 930.353 337.37z"
                  className={classes.cls19}
                />
                <path
                  d="M982.19 337.271L983.629 340.942 940.669 341.024 939.229 337.353 982.19 337.271z"
                  className={classes.cls19}
                />
                <path
                  d="M982.19 329.68L983.629 333.351 983.629 340.942 982.19 337.271 982.19 329.68z"
                  className={classes.cls18}
                />
                <path
                  d="M991.417 294.381L991.417 300.072 1013.044 300.031 1013.044 329.621 982.19 329.68 982.19 337.271 939.229 337.353 939.229 329.762 930.353 329.779 930.353 337.37 898.248 337.431 898.248 329.84 855.051 329.923 855.051 300.333 909.872 300.228 909.872 294.537 991.417 294.381z"
                  className={classes.barnPath}
                />
                <path
                  d="M1013.044 329.621L1014.484 333.292 983.629 333.351 982.19 329.68 1013.044 329.621z"
                  className={classes.cls19}
                />
                <path
                  d="M1013.044 300.031L1014.484 303.702 1014.484 333.292 1013.044 329.621 1013.044 300.031z"
                  className={classes.cls18}
                />
                <path
                  d="M975.006 350.851a21.012 21.012 0 1121.013-21.011 21.035 21.035 0 01-21.013 21.011z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M975.006 309.828a20.012 20.012 0 11-20.011 20.012 20.012 20.012 0 0120.011-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M965.122 322.022h9.69v1.8a16.412 16.412 0 00-5.746 11.945h-2.313a17.035 17.035 0 015.877-11.944h-7.508zM975.281 322.022h9.689v1.8a16.415 16.415 0 00-5.745 11.945h-2.313a17.036 17.036 0 015.878-11.944h-7.509z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="87"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["87"]
                })}
              >
                <path
                  d="M885.137 230.786L886.577 234.457 886.577 241.982 885.137 238.311 885.137 230.786z"
                  className={classes.cls18}
                />
                <path
                  d="M878.004 265.391L879.444 269.062 856.49 269.106 855.051 265.434 878.004 265.391z"
                  className={classes.cls19}
                />
                <path
                  d="M989.513 230.587L990.952 234.258 990.952 241.783 989.513 238.112 989.513 230.587z"
                  className={classes.cls18}
                />
                <path
                  d="M989.513 265.178L990.952 268.849 990.952 276.497 989.513 272.826 989.513 265.178z"
                  className={classes.cls18}
                />
                <path
                  d="M989.513 272.826L990.952 276.497 879.444 276.71 878.004 273.039 989.513 272.826z"
                  className={classes.cls19}
                />
                <path
                  d="M1013.044 238.067L1014.484 241.738 1014.484 268.804 1013.044 265.133 1013.044 238.067z"
                  className={classes.cls18}
                />
                <path
                  d="M1013.044 265.133L1014.484 268.804 990.952 268.849 989.513 265.178 1013.044 265.133z"
                  className={classes.cls19}
                />
                <path
                  d="M989.513 230.587L989.513 238.112 1013.044 238.067 1013.044 265.133 989.513 265.178 989.513 272.826 878.004 273.039 878.004 265.391 855.051 265.434 855.051 238.369 879.056 238.323 879.056 230.798 885.137 230.786 885.137 238.311 915.868 238.253 915.868 230.728 989.513 230.587z"
                  className={classes.barnPath}
                />
                <path
                  d="M974.711 288.925a21.012 21.012 0 1121.012-21.013 21.036 21.036 0 01-21.012 21.013z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M974.711 247.9a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M974.458 263.356a3.531 3.531 0 01-1.82 3.166 3.57 3.57 0 012.238 3.432c0 2.655-2.2 4.133-5.062 4.133s-5.063-1.478-5.063-4.133a3.591 3.591 0 012.256-3.432 3.594 3.594 0 01-1.82-3.166c0-2.029 1.784-3.507 4.627-3.507s4.644 1.478 4.644 3.507zm-7.621 6.56c0 1.593 1.156 2.579 2.977 2.579s2.995-.986 2.995-2.579-1.175-2.616-2.995-2.616-2.977 1.024-2.977 2.615zm2.977-8.494c-1.593 0-2.674.835-2.674 2.181a2.702 2.702 0 005.347 0c0-1.346-1.062-2.181-2.673-2.181zM975.877 260.095h9.688v1.8a16.414 16.414 0 00-5.744 11.945h-2.314a17.037 17.037 0 015.878-11.945h-7.508z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="97"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["97"]
                })}
              >
                <path
                  d="M889.277 170.198L890.716 173.869 890.716 180.619 889.277 176.948 889.277 170.198z"
                  className={classes.cls18}
                />
                <path
                  d="M915.868 170.147L917.308 173.818 917.308 180.568 915.868 176.897 915.868 170.147z"
                  className={classes.cls18}
                />
                <path
                  d="M887.325 204.017L888.765 207.689 858.072 207.747 856.632 204.076 887.325 204.017z"
                  className={classes.cls19}
                />
                <path
                  d="M986.794 168.632L988.233 172.303 988.233 180.433 986.794 176.762 986.794 168.632z"
                  className={classes.cls18}
                />
                <path
                  d="M936.539 203.923L937.978 207.595 927.245 207.615 925.805 203.944 936.539 203.923z"
                  className={classes.cls19}
                />
                <path
                  d="M925.805 203.944L927.245 207.615 927.245 214.393 925.805 210.722 925.805 203.944z"
                  className={classes.cls18}
                />
                <path
                  d="M925.805 210.722L927.245 214.393 888.765 214.467 887.325 210.796 925.805 210.722z"
                  className={classes.cls19}
                />
                <path
                  d="M967.781 210.642L969.22 214.313 937.978 214.373 936.539 210.702 967.781 210.642z"
                  className={classes.cls19}
                />
                <path
                  d="M967.781 203.864L969.22 207.535 969.22 214.313 967.781 210.642 967.781 203.864z"
                  className={classes.cls18}
                />
                <path
                  d="M986.794 168.632L986.794 176.762 1009.937 176.718 1009.937 203.783 967.781 203.864 967.781 210.642 936.539 210.702 936.539 203.923 925.805 203.944 925.805 210.722 887.325 210.796 887.325 204.017 856.632 204.076 856.632 177.01 875.778 176.974 875.778 170.224 889.277 170.198 889.277 176.948 897.149 176.933 897.149 170.183 915.868 170.147 915.868 176.897 927.028 176.876 927.028 168.746 986.794 168.632z"
                  className={classes.barnPath}
                />
                <path
                  d="M1009.937 203.783L1011.376 207.455 969.22 207.535 967.781 203.864 1009.937 203.783z"
                  className={classes.cls19}
                />
                <path
                  d="M1009.937 176.718L1011.376 180.389 1011.376 207.455 1009.937 203.783 1009.937 176.718z"
                  className={classes.cls18}
                />
                <path
                  d="M974.751 224.072a21.012 21.012 0 1121.013-21.012 21.035 21.035 0 01-21.013 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M974.751 183.048a20.012 20.012 0 11-20.011 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.011 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M972.774 202.637a3.939 3.939 0 01-3.47 1.763 4.44 4.44 0 01-4.493-4.701 4.628 4.628 0 014.91-4.703c3.489 0 5.08 2.541 5.08 6.674 0 3.943-1.42 7.565-5.421 7.565a4.026 4.026 0 01-4.322-3.565h2.066a2.238 2.238 0 002.446 1.972c2.01 0 3.108-1.99 3.204-5.005zm-3.033-6.067a2.807 2.807 0 00-2.863 3.071 2.855 2.855 0 105.687 0 2.779 2.779 0 00-2.824-3.071zM975.727 195.243h9.689v1.8a16.411 16.411 0 00-5.745 11.945h-2.313a17.036 17.036 0 015.877-11.945h-7.508z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="107"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["107"]
                })}
              >
                <path
                  d="M920.244 108.973L921.684 112.644 921.684 117.796 920.244 114.125 920.244 108.973z"
                  className={classes.cls18}
                />
                <path
                  d="M875.777 141.266L877.216 144.937 857.976 144.974 856.537 141.303 875.777 141.266z"
                  className={classes.cls19}
                />
                <path
                  d="M969.865 108.878L971.304 112.549 971.304 117.701 969.865 114.03 969.865 108.878z"
                  className={classes.cls18}
                />
                <path
                  d="M947.015 141.13L948.455 144.801 937.977 144.821 936.538 141.15 947.015 141.13z"
                  className={classes.cls19}
                />
                <path
                  d="M936.538 141.15L937.977 144.821 937.977 151.325 936.538 147.654 936.538 141.15z"
                  className={classes.cls18}
                />
                <path
                  d="M936.538 147.654L937.977 151.325 877.216 151.441 875.777 147.77 936.538 147.654z"
                  className={classes.cls19}
                />
                <path
                  d="M986.793 147.558L988.233 151.229 948.455 151.305 947.015 147.634 986.793 147.558z"
                  className={classes.cls19}
                />
                <path
                  d="M986.793 141.054L988.233 144.725 988.233 151.229 986.793 147.558 986.793 141.054z"
                  className={classes.cls18}
                />
                <path
                  d="M969.865 108.878L969.865 114.03 1006.838 113.96 1006.838 141.016 986.793 141.054 986.793 147.558 947.015 147.634 947.015 141.13 936.538 141.15 936.538 147.654 875.777 147.77 875.777 141.266 856.537 141.303 856.537 114.246 876.184 114.209 876.184 109.057 920.244 108.973 920.244 114.125 936.538 114.094 936.538 108.941 969.865 108.878z"
                  className={classes.barnPath}
                />
                <path
                  d="M1006.838 141.016L1008.278 144.687 988.233 144.725 986.793 141.054 1006.838 141.016z"
                  className={classes.cls19}
                />
                <path
                  d="M1006.838 113.96L1008.278 117.631 1008.278 144.687 1006.838 141.016 1006.838 113.96z"
                  className={classes.cls18}
                />
                <path
                  d="M973.682 164.115a21.012 21.012 0 1121.011-21.012 21.036 21.036 0 01-21.011 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M973.682 123.091a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M962.368 149.031v-10.617h-3.128v-1.346c1.971-.056 2.995-.322 3.697-1.782h1.422v13.745zM966.821 142.149c0-4.285 1.744-7.11 5.404-7.11 3.678 0 5.403 2.825 5.403 7.11 0 4.304-1.725 7.13-5.403 7.13-3.66 0-5.404-2.826-5.404-7.13zm8.721 0c0-3.697-1.194-5.536-3.317-5.536-2.105 0-3.318 1.84-3.318 5.536 0 3.716 1.213 5.536 3.318 5.536 2.123 0 3.317-1.82 3.317-5.536zM978.553 135.286h9.689v1.8a16.411 16.411 0 00-5.746 11.945h-2.312a17.035 17.035 0 015.877-11.945h-7.508z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="18"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["18"]
                })}
              >
                <path
                  d="M1134.633 743.827L1136.072 747.498 1136.072 755.089 1134.633 751.418 1134.633 743.827z"
                  className={classes.cls18}
                />
                <path
                  d="M1102.064 789.352L1103.504 793.023 1043.198 793.138 1041.758 789.467 1102.064 789.352z"
                  className={classes.cls19}
                />
                <path
                  d="M1126.382 789.305L1127.821 792.976 1127.821 798.223 1126.382 794.552 1126.382 789.305z"
                  className={classes.cls18}
                />
                <path
                  d="M1126.382 794.552L1127.821 798.223 1103.504 798.27 1102.064 794.598 1126.382 794.552z"
                  className={classes.cls19}
                />
                <path
                  d="M1134.633 743.827L1134.633 751.418 1185.457 751.321 1185.457 789.193 1126.382 789.305 1126.382 794.552 1102.064 794.598 1102.064 789.352 1041.758 789.467 1041.758 751.595 1099.412 751.485 1099.412 743.894 1134.633 743.827z"
                  className={classes.barnPath}
                />
                <path
                  d="M1185.457 751.321L1186.896 754.992 1186.896 792.864 1185.457 789.193 1185.457 751.321z"
                  className={classes.cls18}
                />
                <path
                  d="M1185.457 789.193L1186.896 792.864 1127.821 792.976 1126.382 789.305 1185.457 789.193z"
                  className={classes.cls19}
                />
                <path
                  d="M1152.673 803.08a21.012 21.012 0 1121.012-21.011 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1152.673 762.057a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1146.514 787.997V777.38h-3.128v-1.346c1.97-.057 2.995-.322 3.696-1.782h1.422v13.745zM1160.73 777.513a3.533 3.533 0 01-1.82 3.166 3.57 3.57 0 012.238 3.431c0 2.655-2.2 4.134-5.062 4.134s-5.062-1.479-5.062-4.134a3.703 3.703 0 00.436-6.597c0-2.029 1.782-3.508 4.626-3.508s4.645 1.479 4.645 3.508zm-7.62 6.56c0 1.593 1.156 2.579 2.976 2.579s2.995-.986 2.995-2.58-1.175-2.615-2.995-2.615-2.977 1.024-2.977 2.615zm2.976-8.494c-1.593 0-2.674.835-2.674 2.181a2.702 2.702 0 005.348 0c0-1.346-1.063-2.181-2.674-2.181z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="28"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["28"]
                })}
              >
                <path
                  d="M1134.638 660.291L1136.077 663.963 1136.077 672.783 1134.638 669.112 1134.638 660.291z"
                  className={classes.cls18}
                />
                <path
                  d="M1075.781 707.095L1077.22 710.766 1040.142 710.837 1038.703 707.166 1075.781 707.095z"
                  className={classes.cls19}
                />
                <path
                  d="M1186.901 660.192L1188.341 663.863 1188.341 672.683 1186.901 669.012 1186.901 660.192z"
                  className={classes.cls18}
                />
                <path
                  d="M1130.309 706.991L1131.748 710.662 1122.559 710.68 1121.12 707.009 1130.309 706.991z"
                  className={classes.cls19}
                />
                <path
                  d="M1121.12 715.753L1122.559 719.425 1077.22 719.511 1075.781 715.84 1121.12 715.753z"
                  className={classes.cls19}
                />
                <path
                  d="M1121.12 707.009L1122.559 710.68 1122.559 719.425 1121.12 715.753 1121.12 707.009z"
                  className={classes.cls18}
                />
                <path
                  d="M1170.039 706.915L1171.478 710.587 1156.028 710.616 1154.588 706.945 1170.039 706.915z"
                  className={classes.cls19}
                />
                <path
                  d="M1154.588 706.945L1156.028 710.616 1156.028 719.361 1154.588 715.689 1154.588 706.945z"
                  className={classes.cls18}
                />
                <path
                  d="M1154.588 715.689L1156.028 719.361 1131.748 719.407 1130.309 715.736 1154.588 715.689z"
                  className={classes.cls19}
                />
                <path
                  d="M1179.588 715.642L1181.027 719.313 1171.478 719.331 1170.039 715.66 1179.588 715.642z"
                  className={classes.cls19}
                />
                <path
                  d="M1179.588 706.897L1181.027 710.568 1181.027 719.313 1179.588 715.642 1179.588 706.897z"
                  className={classes.cls18}
                />
                <path
                  d="M1186.901 660.192L1186.901 669.012 1214.07 668.96 1214.07 706.831 1179.588 706.897 1179.588 715.642 1170.039 715.66 1170.039 706.915 1154.588 706.945 1154.588 715.689 1130.309 715.736 1130.309 706.991 1121.12 707.009 1121.12 715.753 1075.781 715.84 1075.781 707.095 1038.703 707.166 1038.703 669.295 1096.812 669.184 1096.812 660.364 1134.638 660.291 1134.638 669.112 1142.444 669.097 1142.444 660.277 1186.901 660.192z"
                  className={classes.barnPath}
                />
                <path
                  d="M1214.07 706.831L1215.51 710.503 1181.027 710.568 1179.588 706.897 1214.07 706.831z"
                  className={classes.cls19}
                />
                <path
                  d="M1214.07 668.96L1215.51 672.631 1215.51 710.503 1214.07 706.831 1214.07 668.96z"
                  className={classes.cls18}
                />
                <path
                  d="M1168.203 722.28a21.012 21.012 0 1121.012-21.01 21.036 21.036 0 01-21.012 21.01z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1168.203 681.257a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1166.813 696.827c0 3.014-3.033 5.764-7.033 8.588h7.393v1.782h-9.953v-1.705c4.72-3.604 7.526-6.067 7.526-8.457a2.165 2.165 0 00-2.407-2.256c-1.404 0-2.768.797-2.768 3.015h-2.01c-.057-2.749 1.896-4.588 4.835-4.588 2.54 0 4.417 1.289 4.417 3.621zM1178.356 696.713a3.534 3.534 0 01-1.82 3.166 3.571 3.571 0 012.236 3.431c0 2.656-2.198 4.134-5.061 4.134s-5.062-1.478-5.062-4.133a3.703 3.703 0 00.436-6.598c0-2.029 1.782-3.507 4.626-3.507s4.645 1.478 4.645 3.507zm-7.622 6.56c0 1.592 1.157 2.578 2.977 2.578s2.995-.986 2.995-2.579-1.175-2.616-2.995-2.616-2.977 1.025-2.977 2.616zm2.977-8.494c-1.593 0-2.674.835-2.674 2.18a2.701 2.701 0 005.346 0c0-1.345-1.06-2.18-2.672-2.18z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="38"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["38"]
                })}
              >
                <path
                  d="M1125.608 582.264L1127.047 585.935 1127.047 594.935 1125.608 591.264 1125.608 582.264z"
                  className={classes.cls18}
                />
                <path
                  d="M1072.406 625.815L1073.846 629.486 1037.431 629.555 1035.991 625.884 1072.406 625.815z"
                  className={classes.cls19}
                />
                <path
                  d="M1218.397 582.087L1219.837 585.758 1219.837 594.758 1218.397 591.087 1218.397 582.087z"
                  className={classes.cls18}
                />
                <path
                  d="M1140.092 625.686L1141.531 629.357 1129.415 629.38 1127.976 625.709 1140.092 625.686z"
                  className={classes.cls19}
                />
                <path
                  d="M1127.976 634.141L1129.415 637.812 1073.846 637.919 1072.406 634.247 1127.976 634.141z"
                  className={classes.cls19}
                />
                <path
                  d="M1127.976 625.709L1129.415 629.38 1129.415 637.812 1127.976 634.141 1127.976 625.709z"
                  className={classes.cls18}
                />
                <path
                  d="M1175.654 625.618L1177.094 629.289 1165.963 629.31 1164.523 625.639 1175.654 625.618z"
                  className={classes.cls19}
                />
                <path
                  d="M1164.523 632.833L1165.963 636.504 1141.531 636.551 1140.092 632.88 1164.523 632.833z"
                  className={classes.cls19}
                />
                <path
                  d="M1164.523 625.639L1165.963 629.31 1165.963 636.504 1164.523 632.833 1164.523 625.639z"
                  className={classes.cls18}
                />
                <path
                  d="M1185.469 632.793L1186.908 636.464 1177.094 636.483 1175.654 632.812 1185.469 632.793z"
                  className={classes.cls19}
                />
                <path
                  d="M1255.238 625.466L1256.678 629.137 1235.771 629.177 1234.331 625.506 1255.238 625.466z"
                  className={classes.cls19}
                />
                <path
                  d="M1255.238 591.017L1256.678 594.688 1256.678 629.137 1255.238 625.466 1255.238 591.017z"
                  className={classes.cls18}
                />
                <path
                  d="M1234.331 635.46L1235.771 639.132 1186.908 639.225 1185.469 635.554 1234.331 635.46z"
                  className={classes.cls19}
                />
                <path
                  d="M1218.397 582.087L1218.397 591.087 1255.238 591.017 1255.238 625.466 1234.331 625.506 1234.331 635.46 1185.469 635.554 1185.469 632.793 1175.654 632.812 1175.654 625.618 1164.523 625.639 1164.523 632.833 1140.092 632.88 1140.092 625.686 1127.976 625.709 1127.976 634.141 1072.406 634.247 1072.406 625.815 1035.991 625.884 1035.991 591.435 1084.75 591.342 1084.75 582.342 1125.608 582.264 1125.608 591.264 1136.094 591.244 1136.094 582.244 1218.397 582.087z"
                  className={classes.barnPath}
                />
                <path
                  d="M1234.331 625.506L1235.771 629.177 1235.771 639.132 1234.331 635.46 1234.331 625.506z"
                  className={classes.cls18}
                />
                <path
                  d="M1181.085 640.77a21.012 21.012 0 1121.012-21.013 21.036 21.036 0 01-21.012 21.013z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1181.085 599.746a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1177.885 621.836c0-1.896-1.593-2.503-3.716-2.503h-.475v-1.723h.4c2.33 0 3.43-.683 3.43-2.2 0-1.44-1.156-2.143-2.54-2.143a2.746 2.746 0 00-2.9 2.654h-1.972c.208-2.52 2.01-4.228 4.967-4.228 2.332 0 4.512.967 4.512 3.546a3.362 3.362 0 01-2.142 3.148 3.385 3.385 0 012.503 3.412c0 2.787-2.39 4.134-5.063 4.134a4.57 4.57 0 01-4.967-4.4h1.972a2.902 2.902 0 003.033 2.806c1.726 0 2.958-.89 2.958-2.503zM1191.342 615.202a3.53 3.53 0 01-1.82 3.165 3.571 3.571 0 012.238 3.432c0 2.655-2.2 4.134-5.063 4.134s-5.062-1.479-5.062-4.134a3.592 3.592 0 012.256-3.432 3.592 3.592 0 01-1.82-3.165c0-2.03 1.782-3.509 4.626-3.509s4.645 1.479 4.645 3.509zm-7.622 6.558c0 1.594 1.157 2.579 2.977 2.579s2.995-.985 2.995-2.579c0-1.592-1.175-2.616-2.995-2.616s-2.977 1.024-2.977 2.616zm2.977-8.494c-1.593 0-2.674.835-2.674 2.182a2.702 2.702 0 005.347 0c0-1.347-1.061-2.182-2.673-2.182z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="48"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["48"]
                })}
              >
                <path
                  d="M1107.338 508.641L1108.777 512.312 1108.777 519.989 1107.338 516.317 1107.338 508.641z"
                  className={classes.cls18}
                />
                <path
                  d="M1164.527 508.532L1165.967 512.203 1165.967 519.88 1164.527 516.208 1164.527 508.532z"
                  className={classes.cls18}
                />
                <path
                  d="M1078.416 549.971L1079.856 553.642 1033.304 553.731 1031.865 550.06 1078.416 549.971z"
                  className={classes.cls19}
                />
                <path
                  d="M1144.624 549.845L1146.063 553.516 1134.146 553.538 1132.707 549.867 1144.624 549.845z"
                  className={classes.cls19}
                />
                <path
                  d="M1132.707 557.544L1134.146 561.215 1079.856 561.318 1078.416 557.647 1132.707 557.544z"
                  className={classes.cls19}
                />
                <path
                  d="M1132.707 549.867L1134.146 553.538 1134.146 561.215 1132.707 557.544 1132.707 549.867z"
                  className={classes.cls18}
                />
                <path
                  d="M1242.615 508.383L1244.054 512.054 1244.054 519.731 1242.615 516.059 1242.615 508.383z"
                  className={classes.cls18}
                />
                <path
                  d="M1178.292 549.78L1179.731 553.451 1179.731 561.128 1178.292 557.457 1178.292 549.78z"
                  className={classes.cls18}
                />
                <path
                  d="M1178.292 557.457L1179.731 561.128 1146.063 561.192 1144.624 557.521 1178.292 557.457z"
                  className={classes.cls19}
                />
                <path
                  d="M1201.804 549.735L1203.244 553.407 1179.731 553.451 1178.292 549.78 1201.804 549.735z"
                  className={classes.cls19}
                />
                <path
                  d="M1247.237 557.325L1248.677 560.996 1203.244 561.083 1201.804 557.412 1247.237 557.325z"
                  className={classes.cls19}
                />
                <path
                  d="M1247.237 549.649L1248.677 553.32 1248.677 560.996 1247.237 557.325 1247.237 549.649z"
                  className={classes.cls18}
                />
                <path
                  d="M1242.615 508.383L1242.615 516.059 1279.655 515.989 1279.655 549.587 1247.237 549.649 1247.237 557.325 1201.804 557.412 1201.804 549.735 1178.292 549.78 1178.292 557.457 1144.624 557.521 1144.624 549.845 1132.707 549.867 1132.707 557.544 1078.416 557.647 1078.416 549.971 1031.865 550.06 1031.865 516.461 1065.277 516.398 1065.277 508.721 1107.338 508.641 1107.338 516.317 1132.707 516.269 1132.707 508.593 1164.527 508.532 1164.527 516.208 1187.661 516.164 1187.661 508.488 1242.615 508.383z"
                  className={classes.barnPath}
                />
                <path
                  d="M1279.655 549.587L1281.094 553.258 1248.677 553.32 1247.237 549.649 1279.655 549.587z"
                  className={classes.cls19}
                />
                <path
                  d="M1279.655 515.989L1281.094 519.66 1281.094 553.258 1279.655 549.587 1279.655 515.989z"
                  className={classes.cls18}
                />
                <circle
                  cx="1153.677"
                  cy="534.633"
                  r="21.012"
                  className={classes.circle}
                ></circle>
                <path
                  d="M1196.054 525.633a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.011 22.012 22.037 22.037 0 00-22.011-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1195.697 548.255h-2.465v3.318h-1.99v-3.318h-6.807v-1.744l6.807-8.683h1.99v8.645h2.465zm-9.081-1.782h4.626v-6.01zM1206.576 541.089a3.533 3.533 0 01-1.82 3.166 3.571 3.571 0 012.237 3.431c0 2.655-2.199 4.134-5.062 4.134s-5.062-1.479-5.062-4.134a3.591 3.591 0 012.256-3.431 3.592 3.592 0 01-1.82-3.166c0-2.03 1.782-3.508 4.626-3.508s4.645 1.479 4.645 3.508zm-7.622 6.56c0 1.592 1.157 2.578 2.977 2.578s2.996-.986 2.996-2.579-1.176-2.616-2.996-2.616-2.977 1.024-2.977 2.616zm2.977-8.495c-1.593 0-2.673.835-2.673 2.181a2.701 2.701 0 005.346 0c0-1.346-1.061-2.18-2.673-2.18z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="58"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["58"]
                })}
              >
                <path
                  d="M1117.062 436.902L1118.501 440.573 1118.501 448.779 1117.062 445.107 1117.062 436.902z"
                  className={classes.cls18}
                />
                <path
                  d="M1063.69 475.442L1065.129 479.113 1030.751 479.179 1029.312 475.507 1063.69 475.442z"
                  className={classes.cls19}
                />
                <path
                  d="M1141.104 482.205L1142.544 485.876 1065.129 486.024 1063.69 482.352 1141.104 482.205z"
                  className={classes.cls19}
                />
                <path
                  d="M1141.104 475.294L1142.544 478.965 1142.544 485.876 1141.104 482.205 1141.104 475.294z"
                  className={classes.cls18}
                />
                <path
                  d="M1164.532 475.249L1165.971 478.921 1142.544 478.965 1141.104 475.294 1164.532 475.249z"
                  className={classes.cls19}
                />
                <path
                  d="M1258.913 436.631L1260.352 440.302 1260.352 448.508 1258.913 444.837 1258.913 436.631z"
                  className={classes.cls18}
                />
                <path
                  d="M1215.26 475.153L1216.7 478.824 1199.07 478.858 1197.631 475.186 1215.26 475.153z"
                  className={classes.cls19}
                />
                <path
                  d="M1197.631 475.186L1199.07 478.858 1199.07 485.768 1197.631 482.097 1197.631 475.186z"
                  className={classes.cls18}
                />
                <path
                  d="M1197.631 482.097L1199.07 485.768 1165.971 485.831 1164.532 482.16 1197.631 482.097z"
                  className={classes.cls19}
                />
                <path
                  d="M1275.766 481.948L1277.205 485.619 1216.7 485.734 1215.26 482.063 1275.766 481.948z"
                  className={classes.cls19}
                />
                <path
                  d="M1275.766 475.037L1277.205 478.708 1277.205 485.619 1275.766 481.948 1275.766 475.037z"
                  className={classes.cls18}
                />
                <path
                  d="M1258.913 436.631L1258.913 444.837 1305.388 444.748 1305.388 474.981 1275.766 475.037 1275.766 481.948 1215.26 482.063 1215.26 475.153 1197.631 475.186 1197.631 482.097 1164.532 482.16 1164.532 475.249 1141.104 475.294 1141.104 482.205 1063.69 482.352 1063.69 475.442 1029.312 475.507 1029.312 445.275 1063.69 445.209 1063.69 437.003 1117.062 436.902 1117.062 445.107 1170.935 445.005 1170.935 436.799 1258.913 436.631z"
                  className={classes.barnPath}
                />
                <path
                  d="M1305.388 474.981L1306.827 478.652 1277.205 478.708 1275.766 475.037 1305.388 474.981z"
                  className={classes.cls19}
                />
                <path
                  d="M1305.388 444.748L1306.827 448.419 1306.827 478.652 1305.388 474.981 1305.388 444.748z"
                  className={classes.cls18}
                />
                <path
                  d="M1205.426 492.714a21.012 21.012 0 1121.012-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1205.425 451.69a20.012 20.012 0 11-20.011 20.012 20.012 20.012 0 0120.011-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1202.3 473.156a2.884 2.884 0 00-2.937-3.128 2.666 2.666 0 00-2.58 1.478l-1.914-.114.91-7.507h8.038v1.8h-6.427l-.455 3.678a4.275 4.275 0 012.901-.948 4.408 4.408 0 014.53 4.72c0 3.11-2.35 4.74-4.985 4.74a4.614 4.614 0 01-4.948-4.342h1.97a2.79 2.79 0 002.996 2.75 2.872 2.872 0 002.902-3.127zM1215.796 467.145a3.534 3.534 0 01-1.82 3.167 3.57 3.57 0 012.237 3.43c0 2.656-2.2 4.135-5.062 4.135s-5.062-1.48-5.062-4.134a3.591 3.591 0 012.256-3.431 3.594 3.594 0 01-1.82-3.167c0-2.028 1.782-3.507 4.626-3.507s4.645 1.479 4.645 3.507zm-7.622 6.56c0 1.593 1.157 2.579 2.977 2.579s2.995-.986 2.995-2.58-1.175-2.615-2.995-2.615-2.977 1.024-2.977 2.616zm2.977-8.494c-1.593 0-2.674.835-2.674 2.181a2.702 2.702 0 005.347 0c0-1.346-1.062-2.18-2.673-2.18z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="68"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["68"]
                })}
              >
                <path
                  d="M1094.796 366.061L1096.235 369.732 1096.235 377.862 1094.796 374.191 1094.796 366.061z"
                  className={classes.cls18}
                />
                <path
                  d="M1153.671 366.762L1155.111 370.433 1155.111 377.75 1153.671 374.079 1153.671 366.762z"
                  className={classes.cls18}
                />
                <path
                  d="M1081.211 404.431L1082.651 408.102 1026.617 408.209 1025.177 404.538 1081.211 404.431z"
                  className={classes.cls19}
                />
                <path
                  d="M1197.636 366.678L1199.076 370.349 1199.076 377.666 1197.636 373.995 1197.636 366.678z"
                  className={classes.cls18}
                />
                <path
                  d="M1250.506 367.39L1251.946 371.061 1251.946 377.565 1250.506 373.894 1250.506 367.39z"
                  className={classes.cls18}
                />
                <path
                  d="M1157.612 410.997L1159.052 414.668 1082.651 414.814 1081.211 411.143 1157.612 410.997z"
                  className={classes.cls19}
                />
                <path
                  d="M1157.612 404.285L1159.052 407.956 1159.052 414.668 1157.612 410.997 1157.612 404.285z"
                  className={classes.cls18}
                />
                <path
                  d="M1178.188 404.246L1179.627 407.917 1159.052 407.956 1157.612 404.285 1178.188 404.246z"
                  className={classes.cls19}
                />
                <path
                  d="M1283.227 367.327L1284.666 370.999 1284.666 377.503 1283.227 373.832 1283.227 367.327z"
                  className={classes.cls18}
                />
                <path
                  d="M1339.781 373.724L1341.221 377.395 1341.221 384.097 1339.781 380.426 1339.781 373.724z"
                  className={classes.cls18}
                />
                <path
                  d="M1286.305 404.039L1287.745 407.711 1287.745 414.423 1286.305 410.751 1286.305 404.039z"
                  className={classes.cls18}
                />
                <path
                  d="M1286.305 410.751L1287.745 414.423 1179.627 414.629 1178.188 410.958 1286.305 410.751z"
                  className={classes.cls19}
                />
                <path
                  d="M1328.518 403.959L1329.957 407.63 1287.745 407.711 1286.305 404.039 1328.518 403.959z"
                  className={classes.cls19}
                />
                <path
                  d="M1339.781 380.426L1341.221 384.097 1341.221 407.609 1339.781 403.937 1339.781 380.426z"
                  className={classes.cls18}
                />
                <path
                  d="M1339.781 403.937L1341.221 407.609 1341.221 416.391 1339.781 412.72 1339.781 403.937z"
                  className={classes.cls18}
                />
                <path
                  d="M1094.796 366.061L1094.796 374.191 1112.368 374.157 1112.368 366.84 1153.671 366.762 1153.671 374.079 1176.54 374.035 1176.54 366.718 1197.636 366.678 1197.636 373.995 1208.322 373.974 1208.322 367.47 1250.506 367.39 1250.506 373.894 1262.31 373.871 1262.31 367.367 1283.227 367.327 1283.227 373.832 1339.781 373.724 1339.781 380.426 1339.781 403.937 1339.781 412.72 1328.518 412.741 1328.518 403.959 1286.305 404.039 1286.305 410.751 1178.188 410.958 1178.188 404.246 1157.612 404.285 1157.612 410.997 1081.211 411.143 1081.211 404.431 1025.177 404.538 1025.177 374.324 1053.493 374.27 1053.493 366.14 1094.796 366.061z"
                  className={classes.barnPath}
                />
                <path
                  d="M1339.781 412.72L1341.221 416.391 1329.957 416.413 1328.518 412.741 1339.781 412.72z"
                  className={classes.cls19}
                />
                <path
                  d="M1218.381 424.337a21.012 21.012 0 1121.012-21.012 21.035 21.035 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1218.38 383.313a20.012 20.012 0 11-20.011 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1209.436 401.859a3.891 3.891 0 013.47-1.763 4.424 4.424 0 014.493 4.683 4.643 4.643 0 01-4.911 4.721c-3.488 0-5.081-2.54-5.081-6.674 0-3.943 1.422-7.565 5.422-7.565a4.028 4.028 0 014.323 3.564h-2.067a2.275 2.275 0 00-2.445-1.99c-1.972 0-3.148 2.01-3.204 5.024zm3.033 6.048a3.09 3.09 0 10-2.844-3.052 2.777 2.777 0 002.844 3.052zM1228.846 398.769a3.531 3.531 0 01-1.82 3.166 3.57 3.57 0 012.237 3.431c0 2.655-2.2 4.134-5.062 4.134s-5.062-1.479-5.062-4.134a3.591 3.591 0 012.256-3.431 3.594 3.594 0 01-1.82-3.166c0-2.029 1.783-3.508 4.626-3.508s4.645 1.479 4.645 3.508zm-7.622 6.56c0 1.593 1.157 2.579 2.977 2.579s2.995-.986 2.995-2.58-1.175-2.615-2.995-2.615-2.977 1.023-2.977 2.615zm2.977-8.494c-1.593 0-2.674.835-2.674 2.181a2.702 2.702 0 005.347 0c0-1.346-1.062-2.181-2.673-2.181z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="78"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["78"]
                })}
              >
                <path
                  d="M1189.818 297.165L1191.257 300.837 1191.257 304.098 1189.818 300.427 1189.818 297.165z"
                  className={classes.cls18}
                />
                <path
                  d="M1222.405 300.365L1223.845 304.036 1223.845 308.564 1222.405 304.893 1222.405 300.365z"
                  className={classes.cls18}
                />
                <path
                  d="M1174.13 335.208L1175.57 338.879 1119.214 338.987 1117.774 335.316 1174.13 335.208z"
                  className={classes.cls19}
                />
                <path
                  d="M1225.873 335.11L1227.312 338.781 1215.499 338.803 1214.06 335.132 1225.873 335.11z"
                  className={classes.cls19}
                />
                <path
                  d="M1304.68 298.846L1306.119 302.518 1306.119 308.407 1304.68 304.736 1304.68 298.846z"
                  className={classes.cls18}
                />
                <path
                  d="M1214.06 335.132L1215.499 338.803 1215.499 346.12 1214.06 342.449 1214.06 335.132z"
                  className={classes.cls18}
                />
                <path
                  d="M1214.06 342.449L1215.499 346.12 1175.57 346.197 1174.13 342.525 1214.06 342.449z"
                  className={classes.cls19}
                />
                <path
                  d="M1257.655 335.049L1259.094 338.72 1247.272 338.743 1245.833 335.072 1257.655 335.049z"
                  className={classes.cls19}
                />
                <path
                  d="M1245.833 335.072L1247.272 338.743 1247.272 346.06 1245.833 342.389 1245.833 335.072z"
                  className={classes.cls18}
                />
                <path
                  d="M1245.833 342.389L1247.272 346.06 1227.312 346.098 1225.873 342.427 1245.833 342.389z"
                  className={classes.cls19}
                />
                <path
                  d="M1308.829 342.268L1310.268 345.94 1259.094 346.037 1257.655 342.366 1308.829 342.268z"
                  className={classes.cls19}
                />
                <path
                  d="M1308.829 334.951L1310.268 338.623 1310.268 345.94 1308.829 342.268 1308.829 334.951z"
                  className={classes.cls18}
                />
                <path
                  d="M1189.818 297.165L1189.818 300.427 1222.405 300.365 1222.405 304.893 1233.347 304.872 1233.347 298.982 1304.68 298.846 1304.68 304.736 1330.399 304.687 1330.399 334.91 1308.829 334.951 1308.829 342.268 1257.655 342.366 1257.655 335.049 1245.833 335.072 1245.833 342.389 1225.873 342.427 1225.873 335.11 1214.06 335.132 1214.06 342.449 1174.13 342.525 1174.13 335.208 1117.774 335.316 1117.774 305.093 1138.464 305.053 1138.464 297.263 1189.818 297.165z"
                  className={classes.barnPath}
                />
                <path
                  d="M1330.399 334.91L1331.839 338.581 1310.268 338.623 1308.829 334.951 1330.399 334.91z"
                  className={classes.cls19}
                />
                <path
                  d="M1330.399 304.687L1331.839 308.358 1331.839 338.581 1330.399 334.91 1330.399 304.687z"
                  className={classes.cls18}
                />
                <path
                  d="M1262.331 353.942a21.012 21.012 0 1121.012-21.012 21.035 21.035 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1262.33 312.918a20.012 20.012 0 11-20.011 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1250.466 325.113h9.688v1.8a16.415 16.415 0 00-5.744 11.944h-2.314a17.036 17.036 0 015.878-11.945h-7.507zM1270.579 328.373a3.533 3.533 0 01-1.82 3.166 3.571 3.571 0 012.236 3.432c0 2.655-2.198 4.133-5.06 4.133s-5.063-1.478-5.063-4.133a3.59 3.59 0 012.256-3.432 3.592 3.592 0 01-1.82-3.166c0-2.029 1.782-3.507 4.626-3.507s4.645 1.478 4.645 3.507zm-7.622 6.56c0 1.592 1.157 2.579 2.977 2.579s2.995-.987 2.995-2.58-1.175-2.615-2.995-2.615-2.977 1.024-2.977 2.616zm2.977-8.494c-1.593 0-2.674.835-2.674 2.181a2.701 2.701 0 005.347 0c0-1.346-1.062-2.181-2.673-2.181z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="88"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["88"]
                })}
              >
                <path
                  d="M1136.112 268.597L1137.551 272.268 1116.369 272.309 1114.93 268.638 1136.112 268.597z"
                  className={classes.cls19}
                />
                <path
                  d="M1224.8 235.492L1226.239 239.163 1226.239 245.043 1224.8 241.372 1224.8 235.492z"
                  className={classes.cls18}
                />
                <path
                  d="M1219.23 268.439L1220.669 272.11 1209.784 272.131 1208.345 268.459 1219.23 268.439z"
                  className={classes.cls19}
                />
                <path
                  d="M1208.345 276.107L1209.784 279.779 1137.551 279.916 1136.112 276.245 1208.345 276.107z"
                  className={classes.cls19}
                />
                <path
                  d="M1208.345 268.459L1209.784 272.131 1209.784 279.779 1208.345 276.107 1208.345 268.459z"
                  className={classes.cls18}
                />
                <path
                  d="M1298.236 235.352L1299.675 239.023 1299.675 244.903 1298.236 241.232 1298.236 235.352z"
                  className={classes.cls18}
                />
                <path
                  d="M1247.46 268.385L1248.899 272.056 1248.899 279.704 1247.46 276.033 1247.46 268.385z"
                  className={classes.cls18}
                />
                <path
                  d="M1247.46 276.033L1248.899 279.704 1220.669 279.758 1219.23 276.087 1247.46 276.033z"
                  className={classes.cls19}
                />
                <path
                  d="M1281.364 268.32L1282.803 271.991 1248.899 272.056 1247.46 268.385 1281.364 268.32z"
                  className={classes.cls19}
                />
                <path
                  d="M1293.509 275.945L1294.948 279.616 1282.803 279.639 1281.364 275.968 1293.509 275.945z"
                  className={classes.cls19}
                />
                <path
                  d="M1293.509 268.297L1294.948 271.968 1294.948 279.616 1293.509 275.945 1293.509 268.297z"
                  className={classes.cls18}
                />
                <path
                  d="M1320.649 241.189L1322.089 244.86 1322.089 271.916 1320.649 268.245 1320.649 241.189z"
                  className={classes.cls18}
                />
                <path
                  d="M1320.649 268.245L1322.089 271.916 1294.948 271.968 1293.509 268.297 1320.649 268.245z"
                  className={classes.cls19}
                />
                <path
                  d="M1298.236 235.352L1298.236 241.232 1320.649 241.189 1320.649 268.245 1293.509 268.297 1293.509 275.945 1281.364 275.968 1281.364 268.32 1247.46 268.385 1247.46 276.033 1219.23 276.087 1219.23 268.439 1208.345 268.459 1208.345 276.107 1136.112 276.245 1136.112 268.597 1114.93 268.638 1114.93 241.581 1146.078 241.522 1146.078 235.642 1224.8 235.492 1224.8 241.372 1245.016 241.333 1245.016 235.453 1298.236 235.352z"
                  className={classes.barnPath}
                />
                <path
                  d="M1262.331 288.925a21.012 21.012 0 1121.012-21.013 21.036 21.036 0 01-21.012 21.013z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1262.33 247.9a20.012 20.012 0 11-20.011 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1260.988 263.356a3.531 3.531 0 01-1.82 3.166 3.57 3.57 0 012.238 3.432c0 2.655-2.2 4.133-5.063 4.133s-5.062-1.478-5.062-4.133a3.591 3.591 0 012.256-3.432 3.594 3.594 0 01-1.82-3.166c0-2.029 1.783-3.507 4.626-3.507s4.645 1.478 4.645 3.507zm-7.622 6.56c0 1.593 1.157 2.579 2.977 2.579s2.996-.986 2.996-2.579-1.176-2.616-2.996-2.616-2.977 1.024-2.977 2.615zm2.977-8.494c-1.593 0-2.673.835-2.673 2.181a2.702 2.702 0 005.347 0c0-1.346-1.063-2.181-2.674-2.181zM1272.928 263.356a3.531 3.531 0 01-1.82 3.166 3.57 3.57 0 012.238 3.432c0 2.655-2.2 4.133-5.062 4.133s-5.063-1.478-5.063-4.133a3.591 3.591 0 012.257-3.432 3.594 3.594 0 01-1.82-3.166c0-2.029 1.783-3.507 4.626-3.507s4.644 1.478 4.644 3.507zm-7.621 6.56c0 1.593 1.157 2.579 2.977 2.579s2.995-.986 2.995-2.579-1.175-2.616-2.995-2.616-2.977 1.024-2.977 2.615zm2.977-8.494c-1.593 0-2.674.835-2.674 2.181a2.702 2.702 0 005.347 0c0-1.346-1.062-2.181-2.673-2.181z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="98"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["98"]
                })}
              >
                <path
                  d="M1106.366 168.797L1107.805 172.469 1107.805 179.795 1106.366 176.124 1106.366 168.797z"
                  className={classes.cls18}
                />
                <path
                  d="M1146.049 168.722L1147.488 172.393 1147.488 179.719 1146.049 176.048 1146.049 168.722z"
                  className={classes.cls18}
                />
                <path
                  d="M1080.712 203.229L1082.152 206.9 1061.368 206.94 1059.928 203.269 1080.712 203.229z"
                  className={classes.cls19}
                />
                <path
                  d="M1200.273 168.618L1201.713 172.289 1201.713 179.616 1200.273 175.945 1200.273 168.618z"
                  className={classes.cls18}
                />
                <path
                  d="M1131.64 203.132L1133.08 206.803 1121.835 206.825 1120.396 203.153 1131.64 203.132z"
                  className={classes.cls19}
                />
                <path
                  d="M1120.396 203.153L1121.835 206.825 1121.835 213.036 1120.396 209.364 1120.396 203.153z"
                  className={classes.cls18}
                />
                <path
                  d="M1120.396 209.364L1121.835 213.036 1082.152 213.111 1080.712 209.44 1120.396 209.364z"
                  className={classes.cls19}
                />
                <path
                  d="M1202.319 209.208L1203.759 212.879 1133.08 213.014 1131.64 209.343 1202.319 209.208z"
                  className={classes.cls19}
                />
                <path
                  d="M1202.319 202.997L1203.759 206.668 1203.759 212.879 1202.319 209.208 1202.319 202.997z"
                  className={classes.cls18}
                />
                <path
                  d="M1200.273 168.618L1200.273 175.945 1221.181 175.905 1221.181 202.961 1202.319 202.997 1202.319 209.208 1131.64 209.343 1131.64 203.132 1120.396 203.153 1120.396 209.364 1080.712 209.44 1080.712 203.229 1059.928 203.269 1059.928 176.213 1080.712 176.173 1080.712 168.846 1106.366 168.797 1106.366 176.124 1120.396 176.097 1120.396 168.771 1146.049 168.722 1146.049 176.048 1150.615 176.039 1150.615 168.713 1200.273 168.618z"
                  className={classes.barnPath}
                />
                <path
                  d="M1221.181 202.961L1222.62 206.632 1203.759 206.668 1202.319 202.997 1221.181 202.961z"
                  className={classes.cls19}
                />
                <path
                  d="M1221.181 175.905L1222.62 179.576 1222.62 206.632 1221.181 202.961 1221.181 175.905z"
                  className={classes.cls18}
                />
                <path
                  d="M1182.205 224.073a21.012 21.012 0 1121.012-21.012 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1182.205 183.049a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1179.138 202.637a3.94 3.94 0 01-3.47 1.764 4.44 4.44 0 01-4.493-4.702 4.628 4.628 0 014.91-4.702c3.489 0 5.08 2.54 5.08 6.673 0 3.944-1.42 7.566-5.422 7.566a4.026 4.026 0 01-4.322-3.566h2.066a2.238 2.238 0 002.447 1.973c2.01 0 3.109-1.991 3.204-5.006zm-3.033-6.067a2.807 2.807 0 00-2.863 3.072 2.855 2.855 0 105.688 0 2.779 2.779 0 00-2.825-3.072zM1192.614 198.504a3.533 3.533 0 01-1.82 3.167 3.571 3.571 0 012.236 3.43c0 2.656-2.198 4.135-5.06 4.135s-5.063-1.48-5.063-4.134a3.59 3.59 0 012.256-3.432 3.592 3.592 0 01-1.82-3.166c0-2.028 1.782-3.507 4.626-3.507s4.645 1.479 4.645 3.507zm-7.622 6.56c0 1.593 1.157 2.579 2.977 2.579s2.996-.986 2.996-2.58-1.176-2.615-2.996-2.615-2.977 1.024-2.977 2.616zm2.977-8.494c-1.593 0-2.673.835-2.673 2.181a2.701 2.701 0 005.346 0c0-1.346-1.062-2.181-2.673-2.181z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="99"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["99"]
                })}
              >
                <path
                  d="M1324.977 168.76L1326.416 172.431 1326.416 179.757 1324.977 176.086 1324.977 168.76z"
                  className={classes.cls18}
                />
                <path
                  d="M1284.469 203.22L1285.909 206.891 1253.169 206.953 1251.73 203.282 1284.469 203.22z"
                  className={classes.cls19}
                />
                <path
                  d="M1376.501 168.803L1377.94 172.474 1377.94 179.659 1376.501 175.988 1376.501 168.803z"
                  className={classes.cls18}
                />
                <path
                  d="M1335.994 203.121L1337.433 206.793 1326.416 206.814 1324.977 203.142 1335.994 203.121z"
                  className={classes.cls19}
                />
                <path
                  d="M1324.977 209.486L1326.416 213.157 1285.909 213.234 1284.469 209.563 1324.977 209.486z"
                  className={classes.cls19}
                />
                <path
                  d="M1324.977 203.142L1326.416 206.814 1326.416 213.157 1324.977 209.486 1324.977 203.142z"
                  className={classes.cls18}
                />
                <path
                  d="M1376.501 203.044L1377.94 206.715 1377.94 213.059 1376.501 209.388 1376.501 203.044z"
                  className={classes.cls18}
                />
                <path
                  d="M1376.501 209.388L1377.94 213.059 1337.433 213.136 1335.994 209.465 1376.501 209.388z"
                  className={classes.cls19}
                />
                <path
                  d="M1324.977 168.76L1324.977 176.086 1335.994 176.065 1335.994 168.88 1376.501 168.803 1376.501 175.988 1426.898 175.892 1426.898 202.948 1376.501 203.044 1376.501 209.388 1335.994 209.465 1335.994 203.121 1324.977 203.142 1324.977 209.486 1284.469 209.563 1284.469 203.22 1251.73 203.282 1251.73 176.226 1280.604 176.171 1280.604 168.844 1324.977 168.76z"
                  className={classes.barnPath}
                />
                <path
                  d="M1426.898 202.948L1428.338 206.619 1377.94 206.715 1376.501 203.044 1426.898 202.948z"
                  className={classes.cls19}
                />
                <path
                  d="M1426.898 175.892L1428.338 179.563 1428.338 206.619 1426.898 202.948 1426.898 175.892z"
                  className={classes.cls18}
                />
                <circle
                  cx="1332.966"
                  cy="192.048"
                  r="21.012"
                  className={classes.circle}
                ></circle>
                <path
                  d="M1375.343 183.048a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1372.465 202.636a3.938 3.938 0 01-3.47 1.764 4.44 4.44 0 01-4.493-4.702 4.628 4.628 0 014.91-4.702c3.489 0 5.08 2.54 5.08 6.673 0 3.944-1.42 7.566-5.42 7.566a4.027 4.027 0 01-4.323-3.566h2.067a2.236 2.236 0 002.445 1.973c2.009 0 3.109-1.991 3.204-5.006zm-3.034-6.067a2.807 2.807 0 00-2.862 3.072 2.855 2.855 0 105.687 0 2.779 2.779 0 00-2.825-3.072zM1384.026 202.636a3.938 3.938 0 01-3.47 1.764 4.44 4.44 0 01-4.494-4.702 4.628 4.628 0 014.91-4.702c3.49 0 5.082 2.54 5.082 6.673 0 3.944-1.422 7.566-5.423 7.566a4.028 4.028 0 01-4.322-3.566h2.066a2.239 2.239 0 002.446 1.973c2.011 0 3.109-1.991 3.205-5.006zm-3.034-6.067a2.807 2.807 0 00-2.862 3.072 2.855 2.855 0 105.687 0 2.779 2.779 0 00-2.825-3.072z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="59"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["59"]
                })}
              >
                <path
                  d="M1439.188 423.387L1440.627 427.058 1437.662 435.638 1436.222 431.967 1439.188 423.387z"
                  className={classes.cls38}
                />
                <path
                  d="M1428.227 455.115L1429.667 458.786 1428.577 461.937 1427.138 458.265 1428.227 455.115z"
                  className={classes.cls38}
                />
                <path
                  d="M1446.34 435.436L1447.779 439.107 1439.784 462.246 1438.344 458.575 1446.34 435.436z"
                  className={classes.cls38}
                />
                <path
                  d="M1438.344 458.575L1439.784 462.246 1429.667 458.786 1428.227 455.115 1438.344 458.575z"
                  className={classes.cls19}
                />
                <path
                  d="M1367.495 508.238L1368.934 511.909 1356.695 507.725 1355.255 504.054 1367.495 508.238z"
                  className={classes.cls19}
                />
                <path
                  d="M1354.014 547.269L1355.454 550.94 1343.214 546.757 1341.775 543.085 1354.014 547.269z"
                  className={classes.cls19}
                />
                <path
                  d="M1397.25 544.814L1398.689 548.485 1395.895 556.601 1394.455 552.93 1397.25 544.814z"
                  className={classes.cls38}
                />
                <path
                  d="M1437.255 461.725L1438.694 465.396 1408.807 551.944 1407.367 548.273 1437.255 461.725z"
                  className={classes.cls38}
                />
                <path
                  d="M1407.367 548.273L1408.807 551.944 1398.689 548.485 1397.25 544.814 1407.367 548.273z"
                  className={classes.cls19}
                />
                <path
                  d="M1343.329 578.231L1344.768 581.902 1332.529 577.709 1331.089 574.038 1343.329 578.231z"
                  className={classes.cls19}
                />
                <path
                  d="M1324.486 632.786L1325.926 636.457 1313.686 632.264 1312.247 628.593 1324.486 632.786z"
                  className={classes.cls19}
                />
                <path
                  d="M1374.675 642.938L1376.115 646.609 1365.997 643.14 1364.558 639.469 1374.675 642.938z"
                  className={classes.cls19}
                />
                <path
                  d="M1404.563 556.39L1406.003 560.061 1376.115 646.609 1374.675 642.938 1404.563 556.39z"
                  className={classes.cls38}
                />
                <path
                  d="M1364.558 639.469L1365.997 643.14 1361.706 655.57 1360.267 651.899 1364.558 639.469z"
                  className={classes.cls38}
                />
                <path
                  d="M1308.42 679.319L1309.859 682.99 1297.62 678.797 1296.181 675.126 1308.42 679.319z"
                  className={classes.cls19}
                />
                <path
                  d="M1356.146 696.613L1357.585 700.284 1347.468 696.815 1346.028 693.144 1356.146 696.613z"
                  className={classes.cls19}
                />
                <path
                  d="M1370.384 655.359L1371.823 659.03 1357.585 700.284 1356.146 696.613 1370.384 655.359z"
                  className={classes.cls38}
                />
                <path
                  d="M1342.04 704.704L1343.48 708.375 1305.568 695.402 1304.129 691.73 1342.04 704.704z"
                  className={classes.cls19}
                />
                <path
                  d="M1346.028 693.144L1347.468 696.815 1343.48 708.375 1342.04 704.704 1346.028 693.144z"
                  className={classes.cls38}
                />
                <path
                  d="M1401.276 410.423L1439.188 423.387 1436.222 431.967 1446.34 435.436 1438.344 458.575 1428.227 455.115 1427.138 458.265 1437.255 461.725 1407.367 548.273 1397.25 544.814 1394.455 552.93 1404.563 556.39 1374.675 642.938 1364.558 639.469 1360.267 651.899 1370.384 655.359 1356.146 696.613 1346.028 693.144 1342.04 704.704 1304.129 691.73 1308.42 679.319 1296.181 675.126 1310.125 634.742 1322.364 638.926 1324.486 632.786 1312.247 628.593 1328.825 580.594 1341.064 584.787 1343.329 578.231 1331.089 574.038 1338.099 553.747 1350.329 557.94 1354.014 547.269 1341.775 543.085 1352.442 512.218 1364.672 516.411 1367.495 508.238 1355.255 504.054 1386.072 414.81 1398.311 419.003 1401.276 410.423z"
                  className={classes.barnPath}
                />
                <circle
                  cx="1369.547"
                  cy="555.754"
                  r="21.012"
                  className={classes.circle}
                ></circle>
                <path
                  d="M1411.924 546.754a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1408.989 568.22a2.884 2.884 0 00-2.94-3.128 2.666 2.666 0 00-2.577 1.479l-1.916-.115.91-7.507h8.04v1.801h-6.428l-.455 3.678a4.277 4.277 0 012.9-.948 4.409 4.409 0 014.532 4.721c0 3.11-2.351 4.74-4.986 4.74a4.615 4.615 0 01-4.949-4.343h1.972a2.79 2.79 0 002.996 2.75 2.872 2.872 0 002.9-3.128zM1420.57 566.342a3.938 3.938 0 01-3.47 1.764 4.44 4.44 0 01-4.494-4.701 4.628 4.628 0 014.91-4.703c3.49 0 5.08 2.541 5.08 6.674 0 3.943-1.42 7.565-5.421 7.565a4.026 4.026 0 01-4.322-3.565h2.066a2.238 2.238 0 002.446 1.972c2.01 0 3.109-1.99 3.204-5.006zm-3.034-6.066a2.806 2.806 0 00-2.863 3.071 2.855 2.855 0 105.687 0 2.779 2.779 0 00-2.824-3.072z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="69"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["69"]
                })}
              >
                <path
                  d="M1483.529 477.792L1484.968 481.463 1479.038 479.432 1477.598 475.761 1483.529 477.792z"
                  className={classes.cls19}
                />
                <path
                  d="M1465.52 529.953L1466.96 533.625 1461.029 531.594 1459.59 527.923 1465.52 529.953z"
                  className={classes.cls19}
                />
                <path
                  d="M1446.697 584.452L1448.136 588.123 1442.206 586.092 1440.767 582.421 1446.697 584.452z"
                  className={classes.cls19}
                />
                <path
                  d="M1491.998 434.071L1520.19 443.717 1524.225 445.231 1432.212 711.659 1405.877 702.653 1446.697 584.452 1440.767 582.421 1456.767 536.087 1462.697 538.117 1465.52 529.953 1459.59 527.923 1475.59 481.579 1481.52 483.61 1483.529 477.792 1477.598 475.761 1491.998 434.071z"
                  className={classes.barnPath}
                />
                <path
                  d="M1524.225 445.231L1525.665 448.903 1433.652 715.33 1432.212 711.659 1524.225 445.231z"
                  className={classes.cls38}
                />
                <path
                  d="M1432.212 711.659L1433.652 715.33 1407.316 706.324 1405.877 702.653 1432.212 711.659z"
                  className={classes.cls19}
                />
                <path
                  d="M1506.428 604.224a21.012 21.012 0 1121.013-21.012 21.035 21.035 0 01-21.013 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1506.428 563.2a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.011m0-2a22.012 22.012 0 1022.012 22.011 22.037 22.037 0 00-22.012-22.011z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1497.672 581.747a3.894 3.894 0 013.47-1.762 4.423 4.423 0 014.493 4.682 4.643 4.643 0 01-4.91 4.72c-3.489 0-5.081-2.54-5.081-6.673 0-3.943 1.422-7.564 5.423-7.564a4.026 4.026 0 014.322 3.564h-2.066a2.275 2.275 0 00-2.446-1.991c-1.972 0-3.147 2.01-3.205 5.024zm3.034 6.049a3.09 3.09 0 10-2.843-3.052 2.776 2.776 0 002.843 3.052zM1515.169 582.79a3.94 3.94 0 01-3.47 1.762 4.44 4.44 0 01-4.493-4.7 4.627 4.627 0 014.91-4.702c3.489 0 5.08 2.54 5.08 6.673 0 3.943-1.42 7.565-5.422 7.565a4.026 4.026 0 01-4.322-3.565h2.066a2.238 2.238 0 002.446 1.973c2.01 0 3.11-1.991 3.205-5.006zm-3.034-6.067a2.806 2.806 0 00-2.863 3.07 2.855 2.855 0 105.688 0 2.778 2.778 0 00-2.825-3.07z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="79"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["79"]
                })}
              >
                <path
                  d="M1448.697 295.655L1450.136 299.326 1450.136 308.543 1448.697 304.872 1448.697 295.655z"
                  className={classes.cls18}
                />
                <path
                  d="M1398.555 332.033L1399.995 335.704 1351.198 335.798 1349.759 332.126 1398.555 332.033z"
                  className={classes.cls19}
                />
                <path
                  d="M1487.48 295.581L1488.919 299.252 1488.919 308.469 1487.48 304.798 1487.48 295.581z"
                  className={classes.cls18}
                />
                <path
                  d="M1448.697 331.938L1450.136 335.609 1450.136 342.926 1448.697 339.255 1448.697 331.938z"
                  className={classes.cls18}
                />
                <path
                  d="M1448.697 339.255L1450.136 342.926 1399.995 343.022 1398.555 339.35 1448.697 339.255z"
                  className={classes.cls19}
                />
                <path
                  d="M1486.722 331.865L1488.161 335.536 1450.136 335.609 1448.697 331.938 1486.722 331.865z"
                  className={classes.cls19}
                />
                <path
                  d="M1506.824 339.144L1508.264 342.815 1488.161 342.853 1486.722 339.182 1506.824 339.144z"
                  className={classes.cls19}
                />
                <path
                  d="M1506.824 331.827L1508.264 335.498 1508.264 342.815 1506.824 339.144 1506.824 331.827z"
                  className={classes.cls18}
                />
                <path
                  d="M1487.48 295.581L1487.48 304.798 1534.77 304.708 1534.77 331.773 1506.824 331.827 1506.824 339.144 1486.722 339.182 1486.722 331.865 1448.697 331.938 1448.697 339.255 1398.555 339.35 1398.555 332.033 1349.759 332.126 1349.759 305.061 1371.121 305.02 1371.121 295.803 1448.697 295.655 1448.697 304.872 1457.45 304.855 1457.45 295.638 1487.48 295.581z"
                  className={classes.barnPath}
                />
                <path
                  d="M1534.77 331.773L1536.209 335.445 1508.264 335.498 1506.824 331.827 1534.77 331.773z"
                  className={classes.cls19}
                />
                <path
                  d="M1534.77 304.708L1536.209 308.379 1536.209 335.445 1534.77 331.773 1534.77 304.708z"
                  className={classes.cls18}
                />
                <circle
                  cx="1429.479"
                  cy="323.04"
                  r="21.012"
                  className={classes.circle}
                ></circle>
                <path
                  d="M1471.857 314.04a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1461.357 326.235h9.688v1.8a16.414 16.414 0 00-5.744 11.945h-2.314a17.036 17.036 0 015.878-11.945h-7.508zM1479.555 333.628a3.938 3.938 0 01-3.47 1.764 4.44 4.44 0 01-4.493-4.702 4.628 4.628 0 014.91-4.702c3.489 0 5.08 2.541 5.08 6.674 0 3.943-1.42 7.565-5.421 7.565a4.026 4.026 0 01-4.322-3.565h2.066a2.238 2.238 0 002.446 1.972c2.009 0 3.108-1.99 3.204-5.006zm-3.033-6.067a2.807 2.807 0 00-2.863 3.072 2.855 2.855 0 105.687 0 2.779 2.779 0 00-2.824-3.072z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="89"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["89"]
                })}
              >
                <path
                  d="M1374.48 268.55L1375.92 272.222 1344.355 272.282 1342.916 268.611 1374.48 268.55z"
                  className={classes.cls19}
                />
                <path
                  d="M1389.808 276.169L1391.247 279.84 1375.92 279.87 1374.48 276.198 1389.808 276.169z"
                  className={classes.cls19}
                />
                <path
                  d="M1389.808 268.521L1391.247 272.192 1391.247 279.84 1389.808 276.169 1389.808 268.521z"
                  className={classes.cls18}
                />
                <path
                  d="M1485.809 233.747L1487.248 237.418 1487.248 244.953 1485.809 241.282 1485.809 233.747z"
                  className={classes.cls18}
                />
                <path
                  d="M1418.057 268.467L1419.496 272.138 1391.247 272.192 1389.808 268.521 1418.057 268.467z"
                  className={classes.cls19}
                />
                <path
                  d="M1449.896 268.407L1451.336 272.078 1439.333 272.101 1437.894 268.429 1449.896 268.407z"
                  className={classes.cls19}
                />
                <path
                  d="M1437.894 268.429L1439.333 272.101 1439.333 279.749 1437.894 276.077 1437.894 268.429z"
                  className={classes.cls18}
                />
                <path
                  d="M1437.894 276.077L1439.333 279.749 1419.496 279.786 1418.057 276.115 1437.894 276.077z"
                  className={classes.cls19}
                />
                <path
                  d="M1489.892 275.978L1491.331 279.649 1451.336 279.726 1449.896 276.055 1489.892 275.978z"
                  className={classes.cls19}
                />
                <path
                  d="M1489.892 268.33L1491.331 272.001 1491.331 279.649 1489.892 275.978 1489.892 268.33z"
                  className={classes.cls18}
                />
                <path
                  d="M1485.809 233.747L1485.809 241.282 1522.366 241.212 1522.366 268.268 1489.892 268.33 1489.892 275.978 1449.896 276.055 1449.896 268.407 1437.894 268.429 1437.894 276.077 1418.057 276.115 1418.057 268.467 1389.808 268.521 1389.808 276.169 1374.48 276.198 1374.48 268.55 1342.916 268.611 1342.916 241.554 1361.076 241.52 1361.076 233.985 1485.809 233.747z"
                  className={classes.barnPath}
                />
                <path
                  d="M1522.366 268.268L1523.805 271.939 1491.331 272.001 1489.892 268.33 1522.366 268.268z"
                  className={classes.cls19}
                />
                <path
                  d="M1522.366 241.212L1523.805 244.883 1523.805 271.939 1522.366 268.268 1522.366 241.212z"
                  className={classes.cls18}
                />
                <path
                  d="M1471.857 287.871a21.012 21.012 0 1121.011-21.011 21.035 21.035 0 01-21.011 21.011z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1471.857 246.847a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.011m0-2a22.012 22.012 0 1022.012 22.011 22.037 22.037 0 00-22.012-22.011z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1470.703 262.303a3.531 3.531 0 01-1.82 3.166 3.57 3.57 0 012.238 3.432c0 2.655-2.2 4.133-5.062 4.133s-5.062-1.478-5.062-4.133a3.591 3.591 0 012.255-3.432 3.594 3.594 0 01-1.82-3.166c0-2.029 1.784-3.507 4.627-3.507s4.644 1.478 4.644 3.507zm-7.621 6.56c0 1.593 1.157 2.579 2.977 2.579s2.995-.986 2.995-2.579-1.175-2.616-2.995-2.616-2.977 1.024-2.977 2.615zm2.977-8.494c-1.593 0-2.674.835-2.674 2.181a2.702 2.702 0 005.347 0c0-1.346-1.062-2.181-2.673-2.181zM1480.73 266.436a3.936 3.936 0 01-3.47 1.763 4.44 4.44 0 01-4.494-4.701 4.628 4.628 0 014.911-4.702c3.488 0 5.081 2.54 5.081 6.673 0 3.944-1.422 7.565-5.422 7.565a4.028 4.028 0 01-4.323-3.565h2.067a2.237 2.237 0 002.445 1.972c2.01 0 3.11-1.99 3.204-5.005zm-3.034-6.067a2.807 2.807 0 00-2.863 3.071 2.855 2.855 0 105.687 0 2.779 2.779 0 00-2.824-3.071z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="109"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["109"]
                })}
              >
                <path
                  d="M1543.842 219.445L1545.281 223.116 1463.518 204.998 1462.079 201.327 1543.842 219.445z"
                  className={classes.cls19}
                />
                <path
                  d="M1556.185 222.182L1557.625 225.853 1556.725 229.863 1555.285 226.192 1556.185 222.182z"
                  className={classes.cls21}
                />
                <path
                  d="M1555.285 226.192L1556.725 229.863 1544.381 227.126 1542.942 223.455 1555.285 226.192z"
                  className={classes.cls19}
                />
                <path
                  d="M1466.938 179.659L1605.796 210.44 1600.927 232.098 1556.185 222.182 1555.285 226.192 1542.942 223.455 1543.842 219.445 1462.079 201.327 1466.938 179.659z"
                  className={classes.barnPath}
                />
                <path
                  d="M1605.796 210.44L1607.236 214.111 1602.366 235.769 1600.927 232.098 1605.796 210.44z"
                  className={classes.cls21}
                />
                <path
                  d="M1600.927 232.098L1602.366 235.769 1557.625 225.853 1556.185 222.182 1600.927 232.098z"
                  className={classes.cls19}
                />
                <path
                  d="M1581.607 239.701a21.012 21.012 0 1121.011-21.012 21.036 21.036 0 01-21.011 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1581.607 198.677a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.011 22.012 22.037 22.037 0 00-22.011-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1569.392 224.617V214h-3.128v-1.346c1.972-.057 2.996-.322 3.697-1.782h1.422v13.745zM1573.846 217.735c0-4.285 1.744-7.11 5.404-7.11 3.677 0 5.402 2.825 5.402 7.11 0 4.304-1.725 7.13-5.402 7.13-3.66 0-5.404-2.826-5.404-7.13zm8.72 0c0-3.697-1.194-5.536-3.316-5.536-2.105 0-3.319 1.84-3.319 5.536 0 3.716 1.214 5.536 3.319 5.536 2.122 0 3.317-1.82 3.317-5.536zM1594.185 218.266a3.937 3.937 0 01-3.47 1.763 4.44 4.44 0 01-4.494-4.701 4.629 4.629 0 014.911-4.703c3.488 0 5.08 2.541 5.08 6.674 0 3.943-1.421 7.565-5.421 7.565a4.028 4.028 0 01-4.323-3.565h2.067a2.237 2.237 0 002.445 1.972c2.01 0 3.11-1.99 3.205-5.005zm-3.034-6.067a2.807 2.807 0 00-2.863 3.071 2.856 2.856 0 105.689 0 2.779 2.779 0 00-2.826-3.071z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="122"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["122"]
                })}
              >
                <path
                  d="M1590.692 330.024L1608.676 335.375 1598.619 368.827 1580.647 363.477 1590.692 330.024z"
                  className={classes.barnPath}
                />
                <path
                  d="M1608.676 335.375L1610.37 339.696 1600.313 373.148 1598.619 368.827 1608.676 335.375z"
                  className={classes.cls20}
                />
                <path
                  d="M1598.619 368.827L1600.313 373.148 1582.341 367.797 1580.647 363.477 1598.619 368.827z"
                  className={classes.cls19}
                />
                <path
                  d="M1622.356 380.358a21.012 21.012 0 1121.012-21.012 21.035 21.035 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1622.356 339.334a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1611.118 365.274v-10.617h-3.128v-1.346c1.971-.057 2.995-.322 3.697-1.782h1.422v13.745zM1624.842 354.904c0 3.014-3.033 5.763-7.033 8.588h7.393v1.782h-9.952v-1.706c4.72-3.603 7.526-6.067 7.526-8.457a2.165 2.165 0 00-2.407-2.256c-1.404 0-2.768.797-2.768 3.015h-2.01c-.057-2.748 1.896-4.588 4.835-4.588 2.54 0 4.416 1.29 4.416 3.622zM1635.891 354.904c0 3.014-3.033 5.763-7.033 8.588h7.394v1.782h-9.954v-1.706c4.721-3.603 7.527-6.067 7.527-8.457a2.165 2.165 0 00-2.408-2.256c-1.402 0-2.768.797-2.768 3.015h-2.009c-.057-2.748 1.896-4.588 4.834-4.588 2.54 0 4.417 1.29 4.417 3.622z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="121"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["121"]
                })}
              >
                <path
                  d="M1573.521 385L1574.961 388.671 1572.611 396.484 1571.172 392.813 1573.521 385z"
                  className={classes.cls20}
                />
                <path
                  d="M1636.357 403.683L1637.796 407.354 1635.456 415.167 1634.017 411.496 1636.357 403.683z"
                  className={classes.cls20}
                />
                <path
                  d="M1721.104 428.81L1722.543 432.481 1720.184 440.351 1718.745 436.68 1721.104 428.81z"
                  className={classes.cls20}
                />
                <path
                  d="M1555.589 379.674L1573.521 385 1571.172 392.813 1582.682 396.232 1585.022 388.419 1636.357 403.683 1634.017 411.496 1644.911 414.737 1647.279 406.857 1721.104 428.81 1718.745 436.68 1727.356 439.244 1721.985 457.14 1544.098 404.256 1549.478 386.359 1553.249 387.477 1555.589 379.674z"
                  className={classes.barnPath}
                />
                <path
                  d="M1727.356 439.244L1728.795 442.915 1723.424 460.812 1721.985 457.14 1727.356 439.244z"
                  className={classes.cls20}
                />
                <path
                  d="M1721.985 457.14L1723.424 460.812 1545.537 407.927 1544.098 404.256 1721.985 457.14z"
                  className={classes.cls19}
                />
                <path
                  d="M1711.17 461.42q-.793 0-1.596-.06a21.011 21.011 0 01-19.378-22.527 21.09 21.09 0 0120.932-19.438q.793 0 1.596.06a21.011 21.011 0 0119.378 22.527 21.09 21.09 0 01-20.932 19.438z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1711.128 420.394q.755 0 1.52.058a20.012 20.012 0 01-1.477 39.968q-.756 0-1.521-.057a20.012 20.012 0 011.478-39.968m.001-2h-.001a22.012 22.012 0 00-1.628 43.962c.555.042 1.117.063 1.67.063a22.095 22.095 0 0021.93-20.363 22.012 22.012 0 00-20.301-23.6 22.369 22.369 0 00-1.67-.063z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1702.006 446.335v-10.617h-3.13v-1.346c1.973-.056 2.997-.322 3.698-1.782h1.422v13.745zM1715.73 435.965c0 3.014-3.034 5.764-7.034 8.588h7.394v1.782h-9.954v-1.705c4.721-3.603 7.527-6.067 7.527-8.457a2.165 2.165 0 00-2.408-2.256c-1.402 0-2.768.797-2.768 3.015h-2.01c-.056-2.748 1.897-4.588 4.836-4.588 2.54 0 4.416 1.289 4.416 3.621zM1719.916 446.335v-10.617h-3.129v-1.346c1.973-.056 2.997-.322 3.698-1.782h1.422v13.745z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="117"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["117"]
                })}
              >
                <path
                  d="M1644.634 377.247L1646.073 380.918 1612.671 370.989 1611.232 367.318 1644.634 377.247z"
                  className={classes.cls19}
                />
                <path
                  d="M1692.331 353.011L1693.771 356.683 1691.715 363.521 1690.276 359.85 1692.331 353.011z"
                  className={classes.cls20}
                />
                <path
                  d="M1717.17 398.814L1718.609 402.485 1716.194 410.516 1714.754 406.845 1717.17 398.814z"
                  className={classes.cls20}
                />
                <path
                  d="M1714.754 406.845L1716.194 410.516 1643.658 388.949 1642.218 385.278 1714.754 406.845z"
                  className={classes.cls19}
                />
                <path
                  d="M1619.767 338.894L1660.151 350.898 1662.207 344.05 1692.331 353.011 1690.276 359.85 1749.625 377.5 1741.09 405.925 1717.17 398.814 1714.754 406.845 1642.218 385.278 1644.634 377.247 1611.232 367.318 1619.767 338.894z"
                  className={classes.barnPath}
                />
                <path
                  d="M1749.625 377.5L1751.065 381.172 1742.529 409.596 1741.09 405.925 1749.625 377.5z"
                  className={classes.cls20}
                />
                <path
                  d="M1741.09 405.925L1742.529 409.596 1718.609 402.485 1717.17 398.814 1741.09 405.925z"
                  className={classes.cls19}
                />
                <path
                  d="M1726.985 415.068a21.012 21.012 0 1121.012-21.012 21.035 21.035 0 01-21.013 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1726.985 374.044a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1718.296 399.984v-10.617h-3.13v-1.346c1.973-.056 2.997-.322 3.699-1.782h1.422v13.745zM1725.536 399.984v-10.617h-3.128v-1.346c1.971-.056 2.995-.322 3.697-1.782h1.422v13.745zM1729.23 386.24h9.69v1.8a16.415 16.415 0 00-5.746 11.944h-2.312a17.035 17.035 0 015.876-11.945h-7.507z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="118"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["118"]
                })}
              >
                <path
                  d="M1627.65 301.671L1629.09 305.342 1600.263 296.776 1598.823 293.104 1627.65 301.671z"
                  className={classes.cls19}
                />
                <path
                  d="M1647.241 307.495L1648.68 311.166 1646.994 316.785 1645.555 313.114 1647.241 307.495z"
                  className={classes.cls20}
                />
                <path
                  d="M1645.555 313.114L1646.994 316.785 1627.403 310.961 1625.964 307.29 1645.555 313.114z"
                  className={classes.cls19}
                />
                <path
                  d="M1668.963 313.958L1670.402 317.629 1648.68 311.166 1647.241 307.495 1668.963 313.958z"
                  className={classes.cls19}
                />
                <path
                  d="M1737.814 340.542L1739.253 344.213 1668.716 323.238 1667.277 319.567 1737.814 340.542z"
                  className={classes.cls19}
                />
                <path
                  d="M1739.5 334.924L1740.939 338.595 1739.253 344.213 1737.814 340.542 1739.5 334.924z"
                  className={classes.cls20}
                />
                <path
                  d="M1608.808 259.818L1770.487 307.884 1760.492 341.17 1739.5 334.924 1737.814 340.542 1667.277 319.567 1668.963 313.958 1647.241 307.495 1645.555 313.114 1625.964 307.29 1627.65 301.671 1598.823 293.104 1608.808 259.818z"
                  className={classes.barnPath}
                />
                <path
                  d="M1760.492 341.17L1761.932 344.841 1740.939 338.595 1739.5 334.924 1760.492 341.17z"
                  className={classes.cls19}
                />
                <path
                  d="M1770.487 307.884L1771.926 311.555 1761.932 344.841 1760.492 341.17 1770.487 307.884z"
                  className={classes.cls20}
                />
                <path
                  d="M1748.918 348.084a21.012 21.012 0 1121.012-21.012 21.035 21.035 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1748.918 307.06a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1739.14 333v-10.617h-3.13v-1.346c1.972-.057 2.996-.322 3.698-1.782h1.423V333zM1746.38 333v-10.617h-3.128v-1.346c1.972-.057 2.996-.322 3.698-1.782h1.42V333zM1760.597 322.515a3.533 3.533 0 01-1.82 3.167 3.57 3.57 0 012.237 3.431c0 2.655-2.198 4.134-5.061 4.134s-5.063-1.479-5.063-4.134a3.593 3.593 0 012.256-3.431 3.594 3.594 0 01-1.82-3.167c0-2.028 1.783-3.507 4.627-3.507s4.644 1.479 4.644 3.507zm-7.622 6.56c0 1.593 1.158 2.58 2.978 2.58s2.994-.987 2.994-2.58-1.174-2.616-2.994-2.616-2.978 1.024-2.978 2.616zm2.978-8.493c-1.594 0-2.674.835-2.674 2.18a2.701 2.701 0 005.346 0c0-1.346-1.062-2.18-2.672-2.18z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="119"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["119"]
                })}
              >
                <path
                  d="M1656.364 237.677L1657.803 241.348 1640.316 236.144 1638.876 232.473 1656.364 237.677z"
                  className={classes.cls19}
                />
                <path
                  d="M1672.497 249.964L1673.936 253.635 1655.738 248.225 1654.299 244.553 1672.497 249.964z"
                  className={classes.cls19}
                />
                <path
                  d="M1674.562 243.087L1676.001 246.759 1673.936 253.635 1672.497 249.964 1674.562 243.087z"
                  className={classes.cls20}
                />
                <path
                  d="M1695.877 249.418L1697.316 253.09 1676.001 246.759 1674.562 243.087 1695.877 249.418z"
                  className={classes.cls19}
                />
                <path
                  d="M1736.753 261.573L1738.193 265.245 1736.128 272.121 1734.688 268.45 1736.753 261.573z"
                  className={classes.cls20}
                />
                <path
                  d="M1734.688 268.45L1736.128 272.121 1695.251 259.976 1693.811 256.305 1734.688 268.45z"
                  className={classes.cls19}
                />
                <path
                  d="M1747.022 264.626L1748.462 268.297 1738.193 265.245 1736.753 261.573 1747.022 264.626z"
                  className={classes.cls19}
                />
                <path
                  d="M1784.119 262.447L1785.558 266.119 1781.911 278.245 1780.472 274.574 1784.119 262.447z"
                  className={classes.cls20}
                />
                <path
                  d="M1780.472 274.574L1781.911 278.245 1778.302 277.174 1776.863 273.503 1780.472 274.574z"
                  className={classes.cls19}
                />
                <path
                  d="M1642.524 220.346L1784.119 262.447 1780.472 274.574 1776.863 273.503 1774.798 280.38 1744.957 271.503 1747.022 264.626 1736.753 261.573 1734.688 268.45 1693.811 256.305 1695.877 249.418 1674.562 243.087 1672.497 249.964 1654.299 244.553 1656.364 237.677 1638.876 232.473 1642.524 220.346z"
                  className={classes.barnPath}
                />
                <path
                  d="M1774.798 280.38L1776.237 284.051 1746.396 275.174 1744.957 271.503 1774.798 280.38z"
                  className={classes.cls19}
                />
                <path
                  d="M1776.863 273.503L1778.302 277.174 1776.237 284.051 1774.798 280.38 1776.863 273.503z"
                  className={classes.cls20}
                />
                <path
                  d="M1764.905 283.73a21.012 21.012 0 1121.012-21.013 21.036 21.036 0 01-21.012 21.012z"
                  className={classes.circle}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1764.905 242.706a20.012 20.012 0 11-20.012 20.011 20.012 20.012 0 0120.012-20.011m0-2a22.012 22.012 0 1022.012 22.011 22.037 22.037 0 00-22.012-22.011z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1755.316 268.646v-10.618h-3.129v-1.346c1.972-.056 2.997-.322 3.698-1.782h1.422v13.745zM1762.556 268.646v-10.618h-3.128v-1.346c1.972-.056 2.996-.322 3.697-1.782h1.422v13.745zM1774.859 262.294a3.937 3.937 0 01-3.47 1.763 4.44 4.44 0 01-4.493-4.701 4.628 4.628 0 014.911-4.702c3.488 0 5.08 2.54 5.08 6.673 0 3.944-1.421 7.565-5.421 7.565a4.027 4.027 0 01-4.323-3.565h2.067a2.236 2.236 0 002.445 1.973c2.01 0 3.11-1.991 3.204-5.006zm-3.034-6.067a2.807 2.807 0 00-2.862 3.071 2.855 2.855 0 105.687 0 2.779 2.779 0 00-2.825-3.071z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
              <g
                data-name="120"
                className={clsx(classes.barn, {
                  [classes.hasHorses]: barnsWithHorses["120"]
                })}
              >
                <path
                  d="M1771.514 300.314L1772.953 303.986 1765.858 301.881 1764.418 298.21 1771.514 300.314z"
                  className={classes.cls19}
                />
                <path
                  d="M1751.004 368.609L1752.444 372.28 1745.68 370.27 1744.241 366.599 1751.004 368.609z"
                  className={classes.cls19}
                />
                <path
                  d="M1783.081 261.769L1812.921 270.636 1759.672 447.974 1729.832 439.107 1751.004 368.609 1744.241 366.599 1747.765 354.85 1754.528 356.861 1771.514 300.314 1764.418 298.21 1767.942 286.462 1775.038 288.566 1783.081 261.769z"
                  className={classes.barnPath}
                />
                <path
                  d="M1812.921 270.636L1814.36 274.307 1761.112 451.645 1759.672 447.974 1812.921 270.636z"
                  className={classes.cls20}
                />
                <path
                  d="M1759.672 447.974L1761.112 451.645 1731.271 442.778 1729.832 439.107 1759.672 447.974z"
                  className={classes.cls19}
                />
                <circle
                  cx="1759.734"
                  cy="395.442"
                  r="21.012"
                  className={classes.circle}
                ></circle>
                <path
                  d="M1802.111 386.442a20.012 20.012 0 11-20.012 20.012 20.012 20.012 0 0120.012-20.012m0-2a22.012 22.012 0 1022.012 22.012 22.037 22.037 0 00-22.012-22.012z"
                  className={classes.circleOutline}
                  transform="translate(-42.377 -11.012)"
                />
                <path
                  d="M1790.153 412.382v-10.617h-3.128v-1.346c1.97-.056 2.995-.322 3.696-1.782h1.423v13.745zM1803.877 402.012c0 3.014-3.033 5.764-7.033 8.588h7.393v1.782h-9.953v-1.706c4.72-3.603 7.526-6.066 7.526-8.456a2.164 2.164 0 00-2.407-2.256c-1.403 0-2.768.797-2.768 3.015h-2.01c-.057-2.749 1.896-4.589 4.835-4.589 2.54 0 4.417 1.29 4.417 3.622zM1805.655 405.5c0-4.285 1.745-7.11 5.404-7.11 3.678 0 5.404 2.825 5.404 7.11 0 4.304-1.726 7.13-5.404 7.13-3.659 0-5.404-2.826-5.404-7.13zm8.722 0c0-3.697-1.195-5.536-3.318-5.536-2.104 0-3.317 1.84-3.317 5.536 0 3.716 1.213 5.536 3.317 5.536 2.123 0 3.318-1.82 3.318-5.536z"
                  className={classes.cls32}
                  transform="translate(-42.377 -11.012)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default React.memo(SantaAnitaMap, mapPropsAreEqual);
